/*
 * Generated on 3/16/2022, 2:41:59 PM
 * Do not edit this file, any changes will be overwritten
 */

"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/*!
 * Bootstrap v3.4.1 (https://getbootstrap.com/)
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under the MIT license
 */
if (typeof jQuery === 'undefined') {
  throw new Error('Bootstrap\'s JavaScript requires jQuery');
}

+function ($) {
  'use strict';

  var version = $.fn.jquery.split(' ')[0].split('.');

  if (version[0] < 2 && version[1] < 9 || version[0] == 1 && version[1] == 9 && version[2] < 1 || version[0] > 3) {
    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4');
  }
}(jQuery);
/* ========================================================================
 * Bootstrap: transition.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  'use strict'; // CSS TRANSITION SUPPORT (Shoutout: https://modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap');
    var transEndEventNames = {
      WebkitTransition: 'webkitTransitionEnd',
      MozTransition: 'transitionend',
      OTransition: 'oTransitionEnd otransitionend',
      transition: 'transitionend'
    };

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return {
          end: transEndEventNames[name]
        };
      }
    }

    return false; // explicit for ie8 (  ._.)
  } // https://blog.alexmaccaw.com/css-transitions


  $.fn.emulateTransitionEnd = function (duration) {
    var called = false;
    var $el = this;
    $(this).one('bsTransitionEnd', function () {
      called = true;
    });

    var callback = function callback() {
      if (!called) $($el).trigger($.support.transition.end);
    };

    setTimeout(callback, duration);
    return this;
  };

  $(function () {
    $.support.transition = transitionEnd();
    if (!$.support.transition) return;
    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function handle(e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments);
      }
    };
  });
}(jQuery);
/* ========================================================================
 * Bootstrap: alert.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#alerts
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  'use strict'; // ALERT CLASS DEFINITION
  // ======================

  var dismiss = '[data-dismiss="alert"]';

  var Alert = function Alert(el) {
    $(el).on('click', dismiss, this.close);
  };

  Alert.VERSION = '3.4.1';
  Alert.TRANSITION_DURATION = 150;

  Alert.prototype.close = function (e) {
    var $this = $(this);
    var selector = $this.attr('data-target');

    if (!selector) {
      selector = $this.attr('href');
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, ''); // strip for ie7
    }

    selector = selector === '#' ? [] : selector;
    var $parent = $(document).find(selector);
    if (e) e.preventDefault();

    if (!$parent.length) {
      $parent = $this.closest('.alert');
    }

    $parent.trigger(e = $.Event('close.bs.alert'));
    if (e.isDefaultPrevented()) return;
    $parent.removeClass('in');

    function removeElement() {
      // detach from parent, fire event then clean up data
      $parent.detach().trigger('closed.bs.alert').remove();
    }

    $.support.transition && $parent.hasClass('fade') ? $parent.one('bsTransitionEnd', removeElement).emulateTransitionEnd(Alert.TRANSITION_DURATION) : removeElement();
  }; // ALERT PLUGIN DEFINITION
  // =======================


  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('bs.alert');
      if (!data) $this.data('bs.alert', data = new Alert(this));
      if (typeof option == 'string') data[option].call($this);
    });
  }

  var old = $.fn.alert;
  $.fn.alert = Plugin;
  $.fn.alert.Constructor = Alert; // ALERT NO CONFLICT
  // =================

  $.fn.alert.noConflict = function () {
    $.fn.alert = old;
    return this;
  }; // ALERT DATA-API
  // ==============


  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close);
}(jQuery);
/* ========================================================================
 * Bootstrap: button.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#buttons
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  'use strict'; // BUTTON PUBLIC CLASS DEFINITION
  // ==============================

  var Button = function Button(element, options) {
    this.$element = $(element);
    this.options = $.extend({}, Button.DEFAULTS, options);
    this.isLoading = false;
  };

  Button.VERSION = '3.4.1';
  Button.DEFAULTS = {
    loadingText: 'loading...'
  };

  Button.prototype.setState = function (state) {
    var d = 'disabled';
    var $el = this.$element;
    var val = $el.is('input') ? 'val' : 'html';
    var data = $el.data();
    state += 'Text';
    if (data.resetText == null) $el.data('resetText', $el[val]()); // push to event loop to allow forms to submit

    setTimeout($.proxy(function () {
      $el[val](data[state] == null ? this.options[state] : data[state]);

      if (state == 'loadingText') {
        this.isLoading = true;
        $el.addClass(d).attr(d, d).prop(d, true);
      } else if (this.isLoading) {
        this.isLoading = false;
        $el.removeClass(d).removeAttr(d).prop(d, false);
      }
    }, this), 0);
  };

  Button.prototype.toggle = function () {
    var changed = true;
    var $parent = this.$element.closest('[data-toggle="buttons"]');

    if ($parent.length) {
      var $input = this.$element.find('input');

      if ($input.prop('type') == 'radio') {
        if ($input.prop('checked')) changed = false;
        $parent.find('.active').removeClass('active');
        this.$element.addClass('active');
      } else if ($input.prop('type') == 'checkbox') {
        if ($input.prop('checked') !== this.$element.hasClass('active')) changed = false;
        this.$element.toggleClass('active');
      }

      $input.prop('checked', this.$element.hasClass('active'));
      if (changed) $input.trigger('change');
    } else {
      this.$element.attr('aria-pressed', !this.$element.hasClass('active'));
      this.$element.toggleClass('active');
    }
  }; // BUTTON PLUGIN DEFINITION
  // ========================


  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('bs.button');
      var options = _typeof(option) == 'object' && option;
      if (!data) $this.data('bs.button', data = new Button(this, options));
      if (option == 'toggle') data.toggle();else if (option) data.setState(option);
    });
  }

  var old = $.fn.button;
  $.fn.button = Plugin;
  $.fn.button.Constructor = Button; // BUTTON NO CONFLICT
  // ==================

  $.fn.button.noConflict = function () {
    $.fn.button = old;
    return this;
  }; // BUTTON DATA-API
  // ===============


  $(document).on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
    var $btn = $(e.target).closest('.btn');
    Plugin.call($btn, 'toggle');

    if (!$(e.target).is('input[type="radio"], input[type="checkbox"]')) {
      // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
      e.preventDefault(); // The target component still receive the focus

      if ($btn.is('input,button')) $btn.trigger('focus');else $btn.find('input:visible,button:visible').first().trigger('focus');
    }
  }).on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
    $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type));
  });
}(jQuery);
/* ========================================================================
 * Bootstrap: carousel.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#carousel
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  'use strict'; // CAROUSEL CLASS DEFINITION
  // =========================

  var Carousel = function Carousel(element, options) {
    this.$element = $(element);
    this.$indicators = this.$element.find('.carousel-indicators');
    this.options = options;
    this.paused = null;
    this.sliding = null;
    this.interval = null;
    this.$active = null;
    this.$items = null;
    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this));
    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element.on('mouseenter.bs.carousel', $.proxy(this.pause, this)).on('mouseleave.bs.carousel', $.proxy(this.cycle, this));
  };

  Carousel.VERSION = '3.4.1';
  Carousel.TRANSITION_DURATION = 600;
  Carousel.DEFAULTS = {
    interval: 5000,
    pause: 'hover',
    wrap: true,
    keyboard: true
  };

  Carousel.prototype.keydown = function (e) {
    if (/input|textarea/i.test(e.target.tagName)) return;

    switch (e.which) {
      case 37:
        this.prev();
        break;

      case 39:
        this.next();
        break;

      default:
        return;
    }

    e.preventDefault();
  };

  Carousel.prototype.cycle = function (e) {
    e || (this.paused = false);
    this.interval && clearInterval(this.interval);
    this.options.interval && !this.paused && (this.interval = setInterval($.proxy(this.next, this), this.options.interval));
    return this;
  };

  Carousel.prototype.getItemIndex = function (item) {
    this.$items = item.parent().children('.item');
    return this.$items.index(item || this.$active);
  };

  Carousel.prototype.getItemForDirection = function (direction, active) {
    var activeIndex = this.getItemIndex(active);
    var willWrap = direction == 'prev' && activeIndex === 0 || direction == 'next' && activeIndex == this.$items.length - 1;
    if (willWrap && !this.options.wrap) return active;
    var delta = direction == 'prev' ? -1 : 1;
    var itemIndex = (activeIndex + delta) % this.$items.length;
    return this.$items.eq(itemIndex);
  };

  Carousel.prototype.to = function (pos) {
    var that = this;
    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'));
    if (pos > this.$items.length - 1 || pos < 0) return;
    if (this.sliding) return this.$element.one('slid.bs.carousel', function () {
      that.to(pos);
    }); // yes, "slid"

    if (activeIndex == pos) return this.pause().cycle();
    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos));
  };

  Carousel.prototype.pause = function (e) {
    e || (this.paused = true);

    if (this.$element.find('.next, .prev').length && $.support.transition) {
      this.$element.trigger($.support.transition.end);
      this.cycle(true);
    }

    this.interval = clearInterval(this.interval);
    return this;
  };

  Carousel.prototype.next = function () {
    if (this.sliding) return;
    return this.slide('next');
  };

  Carousel.prototype.prev = function () {
    if (this.sliding) return;
    return this.slide('prev');
  };

  Carousel.prototype.slide = function (type, next) {
    var $active = this.$element.find('.item.active');
    var $next = next || this.getItemForDirection(type, $active);
    var isCycling = this.interval;
    var direction = type == 'next' ? 'left' : 'right';
    var that = this;
    if ($next.hasClass('active')) return this.sliding = false;
    var relatedTarget = $next[0];
    var slideEvent = $.Event('slide.bs.carousel', {
      relatedTarget: relatedTarget,
      direction: direction
    });
    this.$element.trigger(slideEvent);
    if (slideEvent.isDefaultPrevented()) return;
    this.sliding = true;
    isCycling && this.pause();

    if (this.$indicators.length) {
      this.$indicators.find('.active').removeClass('active');
      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)]);
      $nextIndicator && $nextIndicator.addClass('active');
    }

    var slidEvent = $.Event('slid.bs.carousel', {
      relatedTarget: relatedTarget,
      direction: direction
    }); // yes, "slid"

    if ($.support.transition && this.$element.hasClass('slide')) {
      $next.addClass(type);

      if (_typeof($next) === 'object' && $next.length) {
        $next[0].offsetWidth; // force reflow
      }

      $active.addClass(direction);
      $next.addClass(direction);
      $active.one('bsTransitionEnd', function () {
        $next.removeClass([type, direction].join(' ')).addClass('active');
        $active.removeClass(['active', direction].join(' '));
        that.sliding = false;
        setTimeout(function () {
          that.$element.trigger(slidEvent);
        }, 0);
      }).emulateTransitionEnd(Carousel.TRANSITION_DURATION);
    } else {
      $active.removeClass('active');
      $next.addClass('active');
      this.sliding = false;
      this.$element.trigger(slidEvent);
    }

    isCycling && this.cycle();
    return this;
  }; // CAROUSEL PLUGIN DEFINITION
  // ==========================


  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('bs.carousel');
      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), _typeof(option) == 'object' && option);
      var action = typeof option == 'string' ? option : options.slide;
      if (!data) $this.data('bs.carousel', data = new Carousel(this, options));
      if (typeof option == 'number') data.to(option);else if (action) data[action]();else if (options.interval) data.pause().cycle();
    });
  }

  var old = $.fn.carousel;
  $.fn.carousel = Plugin;
  $.fn.carousel.Constructor = Carousel; // CAROUSEL NO CONFLICT
  // ====================

  $.fn.carousel.noConflict = function () {
    $.fn.carousel = old;
    return this;
  }; // CAROUSEL DATA-API
  // =================


  var clickHandler = function clickHandler(e) {
    var $this = $(this);
    var href = $this.attr('href');

    if (href) {
      href = href.replace(/.*(?=#[^\s]+$)/, ''); // strip for ie7
    }

    var target = $this.attr('data-target') || href;
    var $target = $(document).find(target);
    if (!$target.hasClass('carousel')) return;
    var options = $.extend({}, $target.data(), $this.data());
    var slideIndex = $this.attr('data-slide-to');
    if (slideIndex) options.interval = false;
    Plugin.call($target, options);

    if (slideIndex) {
      $target.data('bs.carousel').to(slideIndex);
    }

    e.preventDefault();
  };

  $(document).on('click.bs.carousel.data-api', '[data-slide]', clickHandler).on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler);
  $(window).on('load', function () {
    $('[data-ride="carousel"]').each(function () {
      var $carousel = $(this);
      Plugin.call($carousel, $carousel.data());
    });
  });
}(jQuery);
/* ========================================================================
 * Bootstrap: collapse.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

/* jshint latedef: false */

+function ($) {
  'use strict'; // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function Collapse(element, options) {
    this.$element = $(element);
    this.options = $.extend({}, Collapse.DEFAULTS, options);
    this.$trigger = $('[data-toggle="collapse"][href="#' + element.id + '"],' + '[data-toggle="collapse"][data-target="#' + element.id + '"]');
    this.transitioning = null;

    if (this.options.parent) {
      this.$parent = this.getParent();
    } else {
      this.addAriaAndCollapsedClass(this.$element, this.$trigger);
    }

    if (this.options.toggle) this.toggle();
  };

  Collapse.VERSION = '3.4.1';
  Collapse.TRANSITION_DURATION = 350;
  Collapse.DEFAULTS = {
    toggle: true
  };

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width');
    return hasWidth ? 'width' : 'height';
  };

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return;
    var activesData;
    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing');

    if (actives && actives.length) {
      activesData = actives.data('bs.collapse');
      if (activesData && activesData.transitioning) return;
    }

    var startEvent = $.Event('show.bs.collapse');
    this.$element.trigger(startEvent);
    if (startEvent.isDefaultPrevented()) return;

    if (actives && actives.length) {
      Plugin.call(actives, 'hide');
      activesData || actives.data('bs.collapse', null);
    }

    var dimension = this.dimension();
    this.$element.removeClass('collapse').addClass('collapsing')[dimension](0).attr('aria-expanded', true);
    this.$trigger.removeClass('collapsed').attr('aria-expanded', true);
    this.transitioning = 1;

    var complete = function complete() {
      this.$element.removeClass('collapsing').addClass('collapse in')[dimension]('');
      this.transitioning = 0;
      this.$element.trigger('shown.bs.collapse');
    };

    if (!$.support.transition) return complete.call(this);
    var scrollSize = $.camelCase(['scroll', dimension].join('-'));
    this.$element.one('bsTransitionEnd', $.proxy(complete, this)).emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize]);
  };

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return;
    var startEvent = $.Event('hide.bs.collapse');
    this.$element.trigger(startEvent);
    if (startEvent.isDefaultPrevented()) return;
    var dimension = this.dimension();
    this.$element[dimension](this.$element[dimension]())[0].offsetHeight;
    this.$element.addClass('collapsing').removeClass('collapse in').attr('aria-expanded', false);
    this.$trigger.addClass('collapsed').attr('aria-expanded', false);
    this.transitioning = 1;

    var complete = function complete() {
      this.transitioning = 0;
      this.$element.removeClass('collapsing').addClass('collapse').trigger('hidden.bs.collapse');
    };

    if (!$.support.transition) return complete.call(this);
    this.$element[dimension](0).one('bsTransitionEnd', $.proxy(complete, this)).emulateTransitionEnd(Collapse.TRANSITION_DURATION);
  };

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']();
  };

  Collapse.prototype.getParent = function () {
    return $(document).find(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each($.proxy(function (i, element) {
      var $element = $(element);
      this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element);
    }, this)).end();
  };

  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
    var isOpen = $element.hasClass('in');
    $element.attr('aria-expanded', isOpen);
    $trigger.toggleClass('collapsed', !isOpen).attr('aria-expanded', isOpen);
  };

  function getTargetFromTrigger($trigger) {
    var href;
    var target = $trigger.attr('data-target') || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, ''); // strip for ie7

    return $(document).find(target);
  } // COLLAPSE PLUGIN DEFINITION
  // ==========================


  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('bs.collapse');
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), _typeof(option) == 'object' && option);
      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false;
      if (!data) $this.data('bs.collapse', data = new Collapse(this, options));
      if (typeof option == 'string') data[option]();
    });
  }

  var old = $.fn.collapse;
  $.fn.collapse = Plugin;
  $.fn.collapse.Constructor = Collapse; // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old;
    return this;
  }; // COLLAPSE DATA-API
  // =================


  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
    var $this = $(this);
    if (!$this.attr('data-target')) e.preventDefault();
    var $target = getTargetFromTrigger($this);
    var data = $target.data('bs.collapse');
    var option = data ? 'toggle' : $this.data();
    Plugin.call($target, option);
  });
}(jQuery);
/* ========================================================================
 * Bootstrap: dropdown.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  'use strict'; // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = '.dropdown-backdrop';
  var toggle = '[data-toggle="dropdown"]';

  var Dropdown = function Dropdown(element) {
    $(element).on('click.bs.dropdown', this.toggle);
  };

  Dropdown.VERSION = '3.4.1';

  function getParent($this) {
    var selector = $this.attr('data-target');

    if (!selector) {
      selector = $this.attr('href');
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, ''); // strip for ie7
    }

    var $parent = selector !== '#' ? $(document).find(selector) : null;
    return $parent && $parent.length ? $parent : $this.parent();
  }

  function clearMenus(e) {
    if (e && e.which === 3) return;
    $(backdrop).remove();
    $(toggle).each(function () {
      var $this = $(this);
      var $parent = getParent($this);
      var relatedTarget = {
        relatedTarget: this
      };
      if (!$parent.hasClass('open')) return;
      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return;
      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget));
      if (e.isDefaultPrevented()) return;
      $this.attr('aria-expanded', 'false');
      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget));
    });
  }

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this);
    if ($this.is('.disabled, :disabled')) return;
    var $parent = getParent($this);
    var isActive = $parent.hasClass('open');
    clearMenus();

    if (!isActive) {
      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
        $(document.createElement('div')).addClass('dropdown-backdrop').insertAfter($(this)).on('click', clearMenus);
      }

      var relatedTarget = {
        relatedTarget: this
      };
      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget));
      if (e.isDefaultPrevented()) return;
      $this.trigger('focus').attr('aria-expanded', 'true');
      $parent.toggleClass('open').trigger($.Event('shown.bs.dropdown', relatedTarget));
    }

    return false;
  };

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return;
    var $this = $(this);
    e.preventDefault();
    e.stopPropagation();
    if ($this.is('.disabled, :disabled')) return;
    var $parent = getParent($this);
    var isActive = $parent.hasClass('open');

    if (!isActive && e.which != 27 || isActive && e.which == 27) {
      if (e.which == 27) $parent.find(toggle).trigger('focus');
      return $this.trigger('click');
    }

    var desc = ' li:not(.disabled):visible a';
    var $items = $parent.find('.dropdown-menu' + desc);
    if (!$items.length) return;
    var index = $items.index(e.target);
    if (e.which == 38 && index > 0) index--; // up

    if (e.which == 40 && index < $items.length - 1) index++; // down

    if (!~index) index = 0;
    $items.eq(index).trigger('focus');
  }; // DROPDOWN PLUGIN DEFINITION
  // ==========================


  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('bs.dropdown');
      if (!data) $this.data('bs.dropdown', data = new Dropdown(this));
      if (typeof option == 'string') data[option].call($this);
    });
  }

  var old = $.fn.dropdown;
  $.fn.dropdown = Plugin;
  $.fn.dropdown.Constructor = Dropdown; // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old;
    return this;
  }; // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================


  $(document).on('click.bs.dropdown.data-api', clearMenus).on('click.bs.dropdown.data-api', '.dropdown form', function (e) {
    e.stopPropagation();
  }).on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle).on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown).on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown);
}(jQuery);
/* ========================================================================
 * Bootstrap: modal.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#modals
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  'use strict'; // MODAL CLASS DEFINITION
  // ======================

  var Modal = function Modal(element, options) {
    this.options = options;
    this.$body = $(document.body);
    this.$element = $(element);
    this.$dialog = this.$element.find('.modal-dialog');
    this.$backdrop = null;
    this.isShown = null;
    this.originalBodyPad = null;
    this.scrollbarWidth = 0;
    this.ignoreBackdropClick = false;
    this.fixedContent = '.navbar-fixed-top, .navbar-fixed-bottom';

    if (this.options.remote) {
      this.$element.find('.modal-content').load(this.options.remote, $.proxy(function () {
        this.$element.trigger('loaded.bs.modal');
      }, this));
    }
  };

  Modal.VERSION = '3.4.1';
  Modal.TRANSITION_DURATION = 300;
  Modal.BACKDROP_TRANSITION_DURATION = 150;
  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  };

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget);
  };

  Modal.prototype.show = function (_relatedTarget) {
    var that = this;
    var e = $.Event('show.bs.modal', {
      relatedTarget: _relatedTarget
    });
    this.$element.trigger(e);
    if (this.isShown || e.isDefaultPrevented()) return;
    this.isShown = true;
    this.checkScrollbar();
    this.setScrollbar();
    this.$body.addClass('modal-open');
    this.escape();
    this.resize();
    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this));
    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true;
      });
    });
    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade');

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body); // don't move modals dom position
      }

      that.$element.show().scrollTop(0);
      that.adjustDialog();

      if (transition) {
        that.$element[0].offsetWidth; // force reflow
      }

      that.$element.addClass('in');
      that.enforceFocus();
      var e = $.Event('shown.bs.modal', {
        relatedTarget: _relatedTarget
      });
      transition ? that.$dialog // wait for modal to slide in
      .one('bsTransitionEnd', function () {
        that.$element.trigger('focus').trigger(e);
      }).emulateTransitionEnd(Modal.TRANSITION_DURATION) : that.$element.trigger('focus').trigger(e);
    });
  };

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault();
    e = $.Event('hide.bs.modal');
    this.$element.trigger(e);
    if (!this.isShown || e.isDefaultPrevented()) return;
    this.isShown = false;
    this.escape();
    this.resize();
    $(document).off('focusin.bs.modal');
    this.$element.removeClass('in').off('click.dismiss.bs.modal').off('mouseup.dismiss.bs.modal');
    this.$dialog.off('mousedown.dismiss.bs.modal');
    $.support.transition && this.$element.hasClass('fade') ? this.$element.one('bsTransitionEnd', $.proxy(this.hideModal, this)).emulateTransitionEnd(Modal.TRANSITION_DURATION) : this.hideModal();
  };

  Modal.prototype.enforceFocus = function () {
    $(document).off('focusin.bs.modal') // guard against infinite focus loop
    .on('focusin.bs.modal', $.proxy(function (e) {
      if (document !== e.target && this.$element[0] !== e.target && !this.$element.has(e.target).length) {
        this.$element.trigger('focus');
      }
    }, this));
  };

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide();
      }, this));
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal');
    }
  };

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this));
    } else {
      $(window).off('resize.bs.modal');
    }
  };

  Modal.prototype.hideModal = function () {
    var that = this;
    this.$element.hide();
    this.backdrop(function () {
      that.$body.removeClass('modal-open');
      that.resetAdjustments();
      that.resetScrollbar();
      that.$element.trigger('hidden.bs.modal');
    });
  };

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove();
    this.$backdrop = null;
  };

  Modal.prototype.backdrop = function (callback) {
    var that = this;
    var animate = this.$element.hasClass('fade') ? 'fade' : '';

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate;
      this.$backdrop = $(document.createElement('div')).addClass('modal-backdrop ' + animate).appendTo(this.$body);
      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false;
          return;
        }

        if (e.target !== e.currentTarget) return;
        this.options.backdrop == 'static' ? this.$element[0].focus() : this.hide();
      }, this));
      if (doAnimate) this.$backdrop[0].offsetWidth; // force reflow

      this.$backdrop.addClass('in');
      if (!callback) return;
      doAnimate ? this.$backdrop.one('bsTransitionEnd', callback).emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) : callback();
    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in');

      var callbackRemove = function callbackRemove() {
        that.removeBackdrop();
        callback && callback();
      };

      $.support.transition && this.$element.hasClass('fade') ? this.$backdrop.one('bsTransitionEnd', callbackRemove).emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) : callbackRemove();
    } else if (callback) {
      callback();
    }
  }; // these following methods are used to handle overflowing modals


  Modal.prototype.handleUpdate = function () {
    this.adjustDialog();
  };

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight;
    this.$element.css({
      paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    });
  };

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    });
  };

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth;

    if (!fullWindowWidth) {
      // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect();
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left);
    }

    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth;
    this.scrollbarWidth = this.measureScrollbar();
  };

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt(this.$body.css('padding-right') || 0, 10);
    this.originalBodyPad = document.body.style.paddingRight || '';
    var scrollbarWidth = this.scrollbarWidth;

    if (this.bodyIsOverflowing) {
      this.$body.css('padding-right', bodyPad + scrollbarWidth);
      $(this.fixedContent).each(function (index, element) {
        var actualPadding = element.style.paddingRight;
        var calculatedPadding = $(element).css('padding-right');
        $(element).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + scrollbarWidth + 'px');
      });
    }
  };

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad);
    $(this.fixedContent).each(function (index, element) {
      var padding = $(element).data('padding-right');
      $(element).removeData('padding-right');
      element.style.paddingRight = padding ? padding : '';
    });
  };

  Modal.prototype.measureScrollbar = function () {
    // thx walsh
    var scrollDiv = document.createElement('div');
    scrollDiv.className = 'modal-scrollbar-measure';
    this.$body.append(scrollDiv);
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    this.$body[0].removeChild(scrollDiv);
    return scrollbarWidth;
  }; // MODAL PLUGIN DEFINITION
  // =======================


  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('bs.modal');
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), _typeof(option) == 'object' && option);
      if (!data) $this.data('bs.modal', data = new Modal(this, options));
      if (typeof option == 'string') data[option](_relatedTarget);else if (options.show) data.show(_relatedTarget);
    });
  }

  var old = $.fn.modal;
  $.fn.modal = Plugin;
  $.fn.modal.Constructor = Modal; // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old;
    return this;
  }; // MODAL DATA-API
  // ==============


  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this = $(this);
    var href = $this.attr('href');
    var target = $this.attr('data-target') || href && href.replace(/.*(?=#[^\s]+$)/, ''); // strip for ie7

    var $target = $(document).find(target);
    var option = $target.data('bs.modal') ? 'toggle' : $.extend({
      remote: !/#/.test(href) && href
    }, $target.data(), $this.data());
    if ($this.is('a')) e.preventDefault();
    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return; // only register focus restorer if modal will actually get shown

      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus');
      });
    });
    Plugin.call($target, option, this);
  });
}(jQuery);
/* ========================================================================
 * Bootstrap: tooltip.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  'use strict';

  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn'];
  var uriAttrs = ['background', 'cite', 'href', 'itemtype', 'longdesc', 'poster', 'src', 'xlink:href'];
  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
  var DefaultWhitelist = {
    // Global attributes allowed on any supplied element below.
    '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
    a: ['target', 'href', 'title', 'rel'],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    div: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: ['src', 'alt', 'title', 'width', 'height'],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
  };
  /**
   * A pattern that recognizes a commonly useful subset of URLs that are safe.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */

  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi;
  /**
   * A pattern that matches safe data URLs. Only matches image, video and audio types.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */

  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i;

  function allowedAttribute(attr, allowedAttributeList) {
    var attrName = attr.nodeName.toLowerCase();

    if ($.inArray(attrName, allowedAttributeList) !== -1) {
      if ($.inArray(attrName, uriAttrs) !== -1) {
        return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN));
      }

      return true;
    }

    var regExp = $(allowedAttributeList).filter(function (index, value) {
      return value instanceof RegExp;
    }); // Check if a regular expression validates the attribute.

    for (var i = 0, l = regExp.length; i < l; i++) {
      if (attrName.match(regExp[i])) {
        return true;
      }
    }

    return false;
  }

  function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
    if (unsafeHtml.length === 0) {
      return unsafeHtml;
    }

    if (sanitizeFn && typeof sanitizeFn === 'function') {
      return sanitizeFn(unsafeHtml);
    } // IE 8 and below don't support createHTMLDocument


    if (!document.implementation || !document.implementation.createHTMLDocument) {
      return unsafeHtml;
    }

    var createdDocument = document.implementation.createHTMLDocument('sanitization');
    createdDocument.body.innerHTML = unsafeHtml;
    var whitelistKeys = $.map(whiteList, function (el, i) {
      return i;
    });
    var elements = $(createdDocument.body).find('*');

    for (var i = 0, len = elements.length; i < len; i++) {
      var el = elements[i];
      var elName = el.nodeName.toLowerCase();

      if ($.inArray(elName, whitelistKeys) === -1) {
        el.parentNode.removeChild(el);
        continue;
      }

      var attributeList = $.map(el.attributes, function (el) {
        return el;
      });
      var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || []);

      for (var j = 0, len2 = attributeList.length; j < len2; j++) {
        if (!allowedAttribute(attributeList[j], whitelistedAttributes)) {
          el.removeAttribute(attributeList[j].nodeName);
        }
      }
    }

    return createdDocument.body.innerHTML;
  } // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================


  var Tooltip = function Tooltip(element, options) {
    this.type = null;
    this.options = null;
    this.enabled = null;
    this.timeout = null;
    this.hoverState = null;
    this.$element = null;
    this.inState = null;
    this.init('tooltip', element, options);
  };

  Tooltip.VERSION = '3.4.1';
  Tooltip.TRANSITION_DURATION = 150;
  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    },
    sanitize: true,
    sanitizeFn: null,
    whiteList: DefaultWhitelist
  };

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled = true;
    this.type = type;
    this.$element = $(element);
    this.options = this.getOptions(options);
    this.$viewport = this.options.viewport && $(document).find($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : this.options.viewport.selector || this.options.viewport);
    this.inState = {
      click: false,
      hover: false,
      focus: false
    };

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!');
    }

    var triggers = this.options.trigger.split(' ');

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i];

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this));
      } else if (trigger != 'manual') {
        var eventIn = trigger == 'hover' ? 'mouseenter' : 'focusin';
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout';
        this.$element.on(eventIn + '.' + this.type, this.options.selector, $.proxy(this.enter, this));
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this));
      }
    }

    this.options.selector ? this._options = $.extend({}, this.options, {
      trigger: 'manual',
      selector: ''
    }) : this.fixTitle();
  };

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS;
  };

  Tooltip.prototype.getOptions = function (options) {
    var dataAttributes = this.$element.data();

    for (var dataAttr in dataAttributes) {
      if (dataAttributes.hasOwnProperty(dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) {
        delete dataAttributes[dataAttr];
      }
    }

    options = $.extend({}, this.getDefaults(), dataAttributes, options);

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      };
    }

    if (options.sanitize) {
      options.template = sanitizeHtml(options.template, options.whiteList, options.sanitizeFn);
    }

    return options;
  };

  Tooltip.prototype.getDelegateOptions = function () {
    var options = {};
    var defaults = this.getDefaults();
    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value;
    });
    return options;
  };

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ? obj : $(obj.currentTarget).data('bs.' + this.type);

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
      $(obj.currentTarget).data('bs.' + this.type, self);
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true;
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
      self.hoverState = 'in';
      return;
    }

    clearTimeout(self.timeout);
    self.hoverState = 'in';
    if (!self.options.delay || !self.options.delay.show) return self.show();
    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show();
    }, self.options.delay.show);
  };

  Tooltip.prototype.isInStateTrue = function () {
    for (var key in this.inState) {
      if (this.inState[key]) return true;
    }

    return false;
  };

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ? obj : $(obj.currentTarget).data('bs.' + this.type);

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
      $(obj.currentTarget).data('bs.' + this.type, self);
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false;
    }

    if (self.isInStateTrue()) return;
    clearTimeout(self.timeout);
    self.hoverState = 'out';
    if (!self.options.delay || !self.options.delay.hide) return self.hide();
    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide();
    }, self.options.delay.hide);
  };

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type);

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e);
      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
      if (e.isDefaultPrevented() || !inDom) return;
      var that = this;
      var $tip = this.tip();
      var tipId = this.getUID(this.type);
      this.setContent();
      $tip.attr('id', tipId);
      this.$element.attr('aria-describedby', tipId);
      if (this.options.animation) $tip.addClass('fade');
      var placement = typeof this.options.placement == 'function' ? this.options.placement.call(this, $tip[0], this.$element[0]) : this.options.placement;
      var autoToken = /\s?auto?\s?/i;
      var autoPlace = autoToken.test(placement);
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top';
      $tip.detach().css({
        top: 0,
        left: 0,
        display: 'block'
      }).addClass(placement).data('bs.' + this.type, this);
      this.options.container ? $tip.appendTo($(document).find(this.options.container)) : $tip.insertAfter(this.$element);
      this.$element.trigger('inserted.bs.' + this.type);
      var pos = this.getPosition();
      var actualWidth = $tip[0].offsetWidth;
      var actualHeight = $tip[0].offsetHeight;

      if (autoPlace) {
        var orgPlacement = placement;
        var viewportDim = this.getPosition(this.$viewport);
        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top' : placement == 'top' && pos.top - actualHeight < viewportDim.top ? 'bottom' : placement == 'right' && pos.right + actualWidth > viewportDim.width ? 'left' : placement == 'left' && pos.left - actualWidth < viewportDim.left ? 'right' : placement;
        $tip.removeClass(orgPlacement).addClass(placement);
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight);
      this.applyPlacement(calculatedOffset, placement);

      var complete = function complete() {
        var prevHoverState = that.hoverState;
        that.$element.trigger('shown.bs.' + that.type);
        that.hoverState = null;
        if (prevHoverState == 'out') that.leave(that);
      };

      $.support.transition && this.$tip.hasClass('fade') ? $tip.one('bsTransitionEnd', complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();
    }
  };

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip = this.tip();
    var width = $tip[0].offsetWidth;
    var height = $tip[0].offsetHeight; // manually read margins because getBoundingClientRect includes difference

    var marginTop = parseInt($tip.css('margin-top'), 10);
    var marginLeft = parseInt($tip.css('margin-left'), 10); // we must check for NaN for ie 8/9

    if (isNaN(marginTop)) marginTop = 0;
    if (isNaN(marginLeft)) marginLeft = 0;
    offset.top += marginTop;
    offset.left += marginLeft; // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0

    $.offset.setOffset($tip[0], $.extend({
      using: function using(props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        });
      }
    }, offset), 0);
    $tip.addClass('in'); // check to see if placing tip in new offset caused the tip to resize itself

    var actualWidth = $tip[0].offsetWidth;
    var actualHeight = $tip[0].offsetHeight;

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight;
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight);
    if (delta.left) offset.left += delta.left;else offset.top += delta.top;
    var isVertical = /top|bottom/.test(placement);
    var arrowDelta = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight;
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight';
    $tip.offset(offset);
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical);
  };

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow().css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%').css(isVertical ? 'top' : 'left', '');
  };

  Tooltip.prototype.setContent = function () {
    var $tip = this.tip();
    var title = this.getTitle();

    if (this.options.html) {
      if (this.options.sanitize) {
        title = sanitizeHtml(title, this.options.whiteList, this.options.sanitizeFn);
      }

      $tip.find('.tooltip-inner').html(title);
    } else {
      $tip.find('.tooltip-inner').text(title);
    }

    $tip.removeClass('fade in top bottom left right');
  };

  Tooltip.prototype.hide = function (callback) {
    var that = this;
    var $tip = $(this.$tip);
    var e = $.Event('hide.bs.' + this.type);

    function complete() {
      if (that.hoverState != 'in') $tip.detach();

      if (that.$element) {
        // TODO: Check whether guarding this code with this `if` is really necessary.
        that.$element.removeAttr('aria-describedby').trigger('hidden.bs.' + that.type);
      }

      callback && callback();
    }

    this.$element.trigger(e);
    if (e.isDefaultPrevented()) return;
    $tip.removeClass('in');
    $.support.transition && $tip.hasClass('fade') ? $tip.one('bsTransitionEnd', complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();
    this.hoverState = null;
    return this;
  };

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element;

    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '');
    }
  };

  Tooltip.prototype.hasContent = function () {
    return this.getTitle();
  };

  Tooltip.prototype.getPosition = function ($element) {
    $element = $element || this.$element;
    var el = $element[0];
    var isBody = el.tagName == 'BODY';
    var elRect = el.getBoundingClientRect();

    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, {
        width: elRect.right - elRect.left,
        height: elRect.bottom - elRect.top
      });
    }

    var isSvg = window.SVGElement && el instanceof window.SVGElement; // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
    // See https://github.com/twbs/bootstrap/issues/20280

    var elOffset = isBody ? {
      top: 0,
      left: 0
    } : isSvg ? null : $element.offset();
    var scroll = {
      scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop()
    };
    var outerDims = isBody ? {
      width: $(window).width(),
      height: $(window).height()
    } : null;
    return $.extend({}, elRect, scroll, outerDims, elOffset);
  };

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? {
      top: pos.top + pos.height,
      left: pos.left + pos.width / 2 - actualWidth / 2
    } : placement == 'top' ? {
      top: pos.top - actualHeight,
      left: pos.left + pos.width / 2 - actualWidth / 2
    } : placement == 'left' ? {
      top: pos.top + pos.height / 2 - actualHeight / 2,
      left: pos.left - actualWidth
    } :
    /* placement == 'right' */
    {
      top: pos.top + pos.height / 2 - actualHeight / 2,
      left: pos.left + pos.width
    };
  };

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = {
      top: 0,
      left: 0
    };
    if (!this.$viewport) return delta;
    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0;
    var viewportDimensions = this.getPosition(this.$viewport);

    if (/right|left/.test(placement)) {
      var topEdgeOffset = pos.top - viewportPadding - viewportDimensions.scroll;
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight;

      if (topEdgeOffset < viewportDimensions.top) {
        // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset;
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) {
        // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset;
      }
    } else {
      var leftEdgeOffset = pos.left - viewportPadding;
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth;

      if (leftEdgeOffset < viewportDimensions.left) {
        // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset;
      } else if (rightEdgeOffset > viewportDimensions.right) {
        // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset;
      }
    }

    return delta;
  };

  Tooltip.prototype.getTitle = function () {
    var title;
    var $e = this.$element;
    var o = this.options;
    title = $e.attr('data-original-title') || (typeof o.title == 'function' ? o.title.call($e[0]) : o.title);
    return title;
  };

  Tooltip.prototype.getUID = function (prefix) {
    do {
      prefix += ~~(Math.random() * 1000000);
    } while (document.getElementById(prefix));

    return prefix;
  };

  Tooltip.prototype.tip = function () {
    if (!this.$tip) {
      this.$tip = $(this.options.template);

      if (this.$tip.length != 1) {
        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!');
      }
    }

    return this.$tip;
  };

  Tooltip.prototype.arrow = function () {
    return this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow');
  };

  Tooltip.prototype.enable = function () {
    this.enabled = true;
  };

  Tooltip.prototype.disable = function () {
    this.enabled = false;
  };

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled;
  };

  Tooltip.prototype.toggle = function (e) {
    var self = this;

    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type);

      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions());
        $(e.currentTarget).data('bs.' + this.type, self);
      }
    }

    if (e) {
      self.inState.click = !self.inState.click;
      if (self.isInStateTrue()) self.enter(self);else self.leave(self);
    } else {
      self.tip().hasClass('in') ? self.leave(self) : self.enter(self);
    }
  };

  Tooltip.prototype.destroy = function () {
    var that = this;
    clearTimeout(this.timeout);
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type);

      if (that.$tip) {
        that.$tip.detach();
      }

      that.$tip = null;
      that.$arrow = null;
      that.$viewport = null;
      that.$element = null;
    });
  };

  Tooltip.prototype.sanitizeHtml = function (unsafeHtml) {
    return sanitizeHtml(unsafeHtml, this.options.whiteList, this.options.sanitizeFn);
  }; // TOOLTIP PLUGIN DEFINITION
  // =========================


  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('bs.tooltip');
      var options = _typeof(option) == 'object' && option;
      if (!data && /destroy|hide/.test(option)) return;
      if (!data) $this.data('bs.tooltip', data = new Tooltip(this, options));
      if (typeof option == 'string') data[option]();
    });
  }

  var old = $.fn.tooltip;
  $.fn.tooltip = Plugin;
  $.fn.tooltip.Constructor = Tooltip; // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old;
    return this;
  };
}(jQuery);
/* ========================================================================
 * Bootstrap: popover.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  'use strict'; // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function Popover(element, options) {
    this.init('popover', element, options);
  };

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js');
  Popover.VERSION = '3.4.1';
  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  }); // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype);
  Popover.prototype.constructor = Popover;

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS;
  };

  Popover.prototype.setContent = function () {
    var $tip = this.tip();
    var title = this.getTitle();
    var content = this.getContent();

    if (this.options.html) {
      var typeContent = _typeof(content);

      if (this.options.sanitize) {
        title = this.sanitizeHtml(title);

        if (typeContent === 'string') {
          content = this.sanitizeHtml(content);
        }
      }

      $tip.find('.popover-title').html(title);
      $tip.find('.popover-content').children().detach().end()[typeContent === 'string' ? 'html' : 'append'](content);
    } else {
      $tip.find('.popover-title').text(title);
      $tip.find('.popover-content').children().detach().end().text(content);
    }

    $tip.removeClass('fade top bottom left right in'); // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.

    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide();
  };

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent();
  };

  Popover.prototype.getContent = function () {
    var $e = this.$element;
    var o = this.options;
    return $e.attr('data-content') || (typeof o.content == 'function' ? o.content.call($e[0]) : o.content);
  };

  Popover.prototype.arrow = function () {
    return this.$arrow = this.$arrow || this.tip().find('.arrow');
  }; // POPOVER PLUGIN DEFINITION
  // =========================


  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('bs.popover');
      var options = _typeof(option) == 'object' && option;
      if (!data && /destroy|hide/.test(option)) return;
      if (!data) $this.data('bs.popover', data = new Popover(this, options));
      if (typeof option == 'string') data[option]();
    });
  }

  var old = $.fn.popover;
  $.fn.popover = Plugin;
  $.fn.popover.Constructor = Popover; // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old;
    return this;
  };
}(jQuery);
/* ========================================================================
 * Bootstrap: scrollspy.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#scrollspy
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  'use strict'; // SCROLLSPY CLASS DEFINITION
  // ==========================

  function ScrollSpy(element, options) {
    this.$body = $(document.body);
    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element);
    this.options = $.extend({}, ScrollSpy.DEFAULTS, options);
    this.selector = (this.options.target || '') + ' .nav li > a';
    this.offsets = [];
    this.targets = [];
    this.activeTarget = null;
    this.scrollHeight = 0;
    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this));
    this.refresh();
    this.process();
  }

  ScrollSpy.VERSION = '3.4.1';
  ScrollSpy.DEFAULTS = {
    offset: 10
  };

  ScrollSpy.prototype.getScrollHeight = function () {
    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight);
  };

  ScrollSpy.prototype.refresh = function () {
    var that = this;
    var offsetMethod = 'offset';
    var offsetBase = 0;
    this.offsets = [];
    this.targets = [];
    this.scrollHeight = this.getScrollHeight();

    if (!$.isWindow(this.$scrollElement[0])) {
      offsetMethod = 'position';
      offsetBase = this.$scrollElement.scrollTop();
    }

    this.$body.find(this.selector).map(function () {
      var $el = $(this);
      var href = $el.data('target') || $el.attr('href');
      var $href = /^#./.test(href) && $(href);
      return $href && $href.length && $href.is(':visible') && [[$href[offsetMethod]().top + offsetBase, href]] || null;
    }).sort(function (a, b) {
      return a[0] - b[0];
    }).each(function () {
      that.offsets.push(this[0]);
      that.targets.push(this[1]);
    });
  };

  ScrollSpy.prototype.process = function () {
    var scrollTop = this.$scrollElement.scrollTop() + this.options.offset;
    var scrollHeight = this.getScrollHeight();
    var maxScroll = this.options.offset + scrollHeight - this.$scrollElement.height();
    var offsets = this.offsets;
    var targets = this.targets;
    var activeTarget = this.activeTarget;
    var i;

    if (this.scrollHeight != scrollHeight) {
      this.refresh();
    }

    if (scrollTop >= maxScroll) {
      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i);
    }

    if (activeTarget && scrollTop < offsets[0]) {
      this.activeTarget = null;
      return this.clear();
    }

    for (i = offsets.length; i--;) {
      activeTarget != targets[i] && scrollTop >= offsets[i] && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1]) && this.activate(targets[i]);
    }
  };

  ScrollSpy.prototype.activate = function (target) {
    this.activeTarget = target;
    this.clear();
    var selector = this.selector + '[data-target="' + target + '"],' + this.selector + '[href="' + target + '"]';
    var active = $(selector).parents('li').addClass('active');

    if (active.parent('.dropdown-menu').length) {
      active = active.closest('li.dropdown').addClass('active');
    }

    active.trigger('activate.bs.scrollspy');
  };

  ScrollSpy.prototype.clear = function () {
    $(this.selector).parentsUntil(this.options.target, '.active').removeClass('active');
  }; // SCROLLSPY PLUGIN DEFINITION
  // ===========================


  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('bs.scrollspy');
      var options = _typeof(option) == 'object' && option;
      if (!data) $this.data('bs.scrollspy', data = new ScrollSpy(this, options));
      if (typeof option == 'string') data[option]();
    });
  }

  var old = $.fn.scrollspy;
  $.fn.scrollspy = Plugin;
  $.fn.scrollspy.Constructor = ScrollSpy; // SCROLLSPY NO CONFLICT
  // =====================

  $.fn.scrollspy.noConflict = function () {
    $.fn.scrollspy = old;
    return this;
  }; // SCROLLSPY DATA-API
  // ==================


  $(window).on('load.bs.scrollspy.data-api', function () {
    $('[data-spy="scroll"]').each(function () {
      var $spy = $(this);
      Plugin.call($spy, $spy.data());
    });
  });
}(jQuery);
/* ========================================================================
 * Bootstrap: tab.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  'use strict'; // TAB CLASS DEFINITION
  // ====================

  var Tab = function Tab(element) {
    // jscs:disable requireDollarBeforejQueryAssignment
    this.element = $(element); // jscs:enable requireDollarBeforejQueryAssignment
  };

  Tab.VERSION = '3.4.1';
  Tab.TRANSITION_DURATION = 150;

  Tab.prototype.show = function () {
    var $this = this.element;
    var $ul = $this.closest('ul:not(.dropdown-menu)');
    var selector = $this.data('target');

    if (!selector) {
      selector = $this.attr('href');
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, ''); // strip for ie7
    }

    if ($this.parent('li').hasClass('active')) return;
    var $previous = $ul.find('.active:last a');
    var hideEvent = $.Event('hide.bs.tab', {
      relatedTarget: $this[0]
    });
    var showEvent = $.Event('show.bs.tab', {
      relatedTarget: $previous[0]
    });
    $previous.trigger(hideEvent);
    $this.trigger(showEvent);
    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return;
    var $target = $(document).find(selector);
    this.activate($this.closest('li'), $ul);
    this.activate($target, $target.parent(), function () {
      $previous.trigger({
        type: 'hidden.bs.tab',
        relatedTarget: $this[0]
      });
      $this.trigger({
        type: 'shown.bs.tab',
        relatedTarget: $previous[0]
      });
    });
  };

  Tab.prototype.activate = function (element, container, callback) {
    var $active = container.find('> .active');
    var transition = callback && $.support.transition && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length);

    function next() {
      $active.removeClass('active').find('> .dropdown-menu > .active').removeClass('active').end().find('[data-toggle="tab"]').attr('aria-expanded', false);
      element.addClass('active').find('[data-toggle="tab"]').attr('aria-expanded', true);

      if (transition) {
        element[0].offsetWidth; // reflow for transition

        element.addClass('in');
      } else {
        element.removeClass('fade');
      }

      if (element.parent('.dropdown-menu').length) {
        element.closest('li.dropdown').addClass('active').end().find('[data-toggle="tab"]').attr('aria-expanded', true);
      }

      callback && callback();
    }

    $active.length && transition ? $active.one('bsTransitionEnd', next).emulateTransitionEnd(Tab.TRANSITION_DURATION) : next();
    $active.removeClass('in');
  }; // TAB PLUGIN DEFINITION
  // =====================


  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('bs.tab');
      if (!data) $this.data('bs.tab', data = new Tab(this));
      if (typeof option == 'string') data[option]();
    });
  }

  var old = $.fn.tab;
  $.fn.tab = Plugin;
  $.fn.tab.Constructor = Tab; // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old;
    return this;
  }; // TAB DATA-API
  // ============


  var clickHandler = function clickHandler(e) {
    e.preventDefault();
    Plugin.call($(this), 'show');
  };

  $(document).on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler).on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler);
}(jQuery);
/* ========================================================================
 * Bootstrap: affix.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#affix
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  'use strict'; // AFFIX CLASS DEFINITION
  // ======================

  var Affix = function Affix(element, options) {
    this.options = $.extend({}, Affix.DEFAULTS, options);
    var target = this.options.target === Affix.DEFAULTS.target ? $(this.options.target) : $(document).find(this.options.target);
    this.$target = target.on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this)).on('click.bs.affix.data-api', $.proxy(this.checkPositionWithEventLoop, this));
    this.$element = $(element);
    this.affixed = null;
    this.unpin = null;
    this.pinnedOffset = null;
    this.checkPosition();
  };

  Affix.VERSION = '3.4.1';
  Affix.RESET = 'affix affix-top affix-bottom';
  Affix.DEFAULTS = {
    offset: 0,
    target: window
  };

  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
    var scrollTop = this.$target.scrollTop();
    var position = this.$element.offset();
    var targetHeight = this.$target.height();
    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false;

    if (this.affixed == 'bottom') {
      if (offsetTop != null) return scrollTop + this.unpin <= position.top ? false : 'bottom';
      return scrollTop + targetHeight <= scrollHeight - offsetBottom ? false : 'bottom';
    }

    var initializing = this.affixed == null;
    var colliderTop = initializing ? scrollTop : position.top;
    var colliderHeight = initializing ? targetHeight : height;
    if (offsetTop != null && scrollTop <= offsetTop) return 'top';
    if (offsetBottom != null && colliderTop + colliderHeight >= scrollHeight - offsetBottom) return 'bottom';
    return false;
  };

  Affix.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset;
    this.$element.removeClass(Affix.RESET).addClass('affix');
    var scrollTop = this.$target.scrollTop();
    var position = this.$element.offset();
    return this.pinnedOffset = position.top - scrollTop;
  };

  Affix.prototype.checkPositionWithEventLoop = function () {
    setTimeout($.proxy(this.checkPosition, this), 1);
  };

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(':visible')) return;
    var height = this.$element.height();
    var offset = this.options.offset;
    var offsetTop = offset.top;
    var offsetBottom = offset.bottom;
    var scrollHeight = Math.max($(document).height(), $(document.body).height());
    if (_typeof(offset) != 'object') offsetBottom = offsetTop = offset;
    if (typeof offsetTop == 'function') offsetTop = offset.top(this.$element);
    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element);
    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom);

    if (this.affixed != affix) {
      if (this.unpin != null) this.$element.css('top', '');
      var affixType = 'affix' + (affix ? '-' + affix : '');
      var e = $.Event(affixType + '.bs.affix');
      this.$element.trigger(e);
      if (e.isDefaultPrevented()) return;
      this.affixed = affix;
      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null;
      this.$element.removeClass(Affix.RESET).addClass(affixType).trigger(affixType.replace('affix', 'affixed') + '.bs.affix');
    }

    if (affix == 'bottom') {
      this.$element.offset({
        top: scrollHeight - height - offsetBottom
      });
    }
  }; // AFFIX PLUGIN DEFINITION
  // =======================


  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('bs.affix');
      var options = _typeof(option) == 'object' && option;
      if (!data) $this.data('bs.affix', data = new Affix(this, options));
      if (typeof option == 'string') data[option]();
    });
  }

  var old = $.fn.affix;
  $.fn.affix = Plugin;
  $.fn.affix.Constructor = Affix; // AFFIX NO CONFLICT
  // =================

  $.fn.affix.noConflict = function () {
    $.fn.affix = old;
    return this;
  }; // AFFIX DATA-API
  // ==============


  $(window).on('load', function () {
    $('[data-spy="affix"]').each(function () {
      var $spy = $(this);
      var data = $spy.data();
      data.offset = data.offset || {};
      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom;
      if (data.offsetTop != null) data.offset.top = data.offsetTop;
      Plugin.call($spy, data);
    });
  });
}(jQuery);

var checkCustomInputs = function checkCustomInputs() {
  var classPrefix = 'ci';
  $('input[type=checkbox], input[type=radio]').each(function () {
    var $input = $(this);

    if ($input.hasClass('no-ci')) {
      return;
    }

    if ($input.hasClass(classPrefix + '-enabled')) {
      return;
    }

    if ($input.closest('label').length == 0) {
      $input.wrap('<label/>');
    }

    $input.wrap('<span class="' + classPrefix + '"/>');
    $input.after('<span class="' + classPrefix + '-input"/>');
    $input.addClass(classPrefix + '-enabled');
    $input.on('click', function (e) {
      if ($input.attr('readonly')) {
        e.preventDefault();
      }
    });
  });
  checkCustomInputLabels();
};

var checkCustomInputLabels = function checkCustomInputLabels() {
  var classPrefix = 'ci';
  $('.' + classPrefix + '-enabled').each(function () {
    var $label = $(this).closest('label');

    if ($(this).prop('disabled')) {
      $label.addClass('input-disabled');
    } else {
      $label.removeClass('input-disabled');
    }

    if ($(this).prop('readonly')) {
      $label.addClass('input-readonly');
    } else {
      $label.removeClass('input-readonly');
    }
  });
};

+function ($) {
  var imageLoader = function imageLoader(element, options) {
    var self = this;
    var $element = $(element);
    var settings = $.extend({
      onLoad: false,
      onAllStarted: false
    }, options);
    var imageType = $element.data('background') ? 'bg' : 'img';
    var autoload = $element.data('imageloader-autoload') || true;
    var imageUrl = imageType == 'bg' ? $element.data('background') : $element.data('src');
    var timeout = false;

    this.init = function () {
      if (imageUrl == undefined) {
        return;
      }

      $(window).on('resize', function () {
        if (timeout) {
          clearInterval(timeout);
        } // Only call loadImage() once every 500ms


        timeout = setTimeout(function () {
          self.loadImage();
        }, 500);
      });
      self.loadImage();
    };

    this.loadImage = function () {
      self.pixelRatio = window.devicePixelRatio || 1;
      self.elementWidth = $element.outerWidth();
      self.elementHeight = $element.outerHeight();
      var newWidth = getSize(self.elementWidth);
      var newHeight = getSize(self.elementHeight);
      var currentWidth = $element.data('imageloader-width') || 0;
      var currentHeight = $element.data('imageloader-height') || 0;

      if (newWidth > currentWidth || newHeight > currentHeight) {
        $element.data({
          'imageloader-width': newWidth,
          'imageloader-height': newHeight
        }).addClass('imageloader-loading');
        var imageSizeUrl = imageUrl + (imageUrl.indexOf('?') >= 0 ? '&' : '?') + 'w=' + newWidth + '&h=' + newHeight + '&r=' + self.pixelRatio;
        var image = new Image();

        if (imageType == 'img') {
          $element.data('src', imageSizeUrl);
        } else {
          $element.attr('data-background', imageSizeUrl);
        }

        $(image).on('error load', function () {
          if (autoload) {
            if (imageType == 'img') {
              $element.attr('src', imageSizeUrl);
            } else {
              $element.css('background-image', 'url(' + imageSizeUrl + ')');
            }
          }

          if (typeof settings.onLoad == 'function') {
            settings.onLoad(this);
          }
        });
        image.src = imageSizeUrl;
      }
    };

    var getSize = function getSize(size) {
      var result = 480;
      if (size > 480) result = 768;
      if (size > 768) result = 992;
      if (size > 992) result = 1200;
      if (size > 1200) result = 1400;
      if (size > 1400) result = 1600;
      if (size > 1600) result = 1800;
      if (size > 1800) result = 2000;
      return result;
    };
  };

  $.fn.imageLoader = function (options) {
    return this.each(function () {
      var loader = new imageLoader(this, options);
      loader.init();
    });
  };
}(jQuery); // Mobile Safari in standalone mode

if ("standalone" in window.navigator && window.navigator.standalone) {
  // If you want to prevent remote links in standalone web apps opening Mobile Safari, change 'remotes' to true
  var noddy,
      remotes = false;
  document.addEventListener('click', function (event) {
    noddy = event.target; // Bubble up until we hit link or top HTML element. Warning: BODY element is not compulsory so better to stop on HTML

    while (noddy.nodeName !== "A" && noddy.nodeName !== "HTML") {
      noddy = noddy.parentNode;
    }

    if ('href' in noddy && noddy.href.indexOf('http') !== -1 && (noddy.href.indexOf(document.location.host) !== -1 || remotes)) {
      event.preventDefault();
      document.location.href = noddy.href;
    }
  }, false);
}
/**
 * Swiper 3.4.2
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * 
 * http://www.idangero.us/swiper/
 * 
 * Copyright 2017, Vladimir Kharlampidi
 * The iDangero.us
 * http://www.idangero.us/
 * 
 * Licensed under MIT
 * 
 * Released on: March 10, 2017
 */


(function () {
  'use strict';

  var $;
  /*===========================
  Swiper
  ===========================*/

  var Swiper = function Swiper(container, params) {
    if (!(this instanceof Swiper)) return new Swiper(container, params);
    var defaults = {
      direction: 'horizontal',
      touchEventsTarget: 'container',
      initialSlide: 0,
      speed: 300,
      // autoplay
      autoplay: false,
      autoplayDisableOnInteraction: true,
      autoplayStopOnLast: false,
      // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
      iOSEdgeSwipeDetection: false,
      iOSEdgeSwipeThreshold: 20,
      // Free mode
      freeMode: false,
      freeModeMomentum: true,
      freeModeMomentumRatio: 1,
      freeModeMomentumBounce: true,
      freeModeMomentumBounceRatio: 1,
      freeModeMomentumVelocityRatio: 1,
      freeModeSticky: false,
      freeModeMinimumVelocity: 0.02,
      // Autoheight
      autoHeight: false,
      // Set wrapper width
      setWrapperSize: false,
      // Virtual Translate
      virtualTranslate: false,
      // Effects
      effect: 'slide',
      // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
      coverflow: {
        rotate: 50,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true
      },
      flip: {
        slideShadows: true,
        limitRotation: true
      },
      cube: {
        slideShadows: true,
        shadow: true,
        shadowOffset: 20,
        shadowScale: 0.94
      },
      fade: {
        crossFade: false
      },
      // Parallax
      parallax: false,
      // Zoom
      zoom: false,
      zoomMax: 3,
      zoomMin: 1,
      zoomToggle: true,
      // Scrollbar
      scrollbar: null,
      scrollbarHide: true,
      scrollbarDraggable: false,
      scrollbarSnapOnRelease: false,
      // Keyboard Mousewheel
      keyboardControl: false,
      mousewheelControl: false,
      mousewheelReleaseOnEdges: false,
      mousewheelInvert: false,
      mousewheelForceToAxis: false,
      mousewheelSensitivity: 1,
      mousewheelEventsTarged: 'container',
      // Hash Navigation
      hashnav: false,
      hashnavWatchState: false,
      // History
      history: false,
      // Commong Nav State
      replaceState: false,
      // Breakpoints
      breakpoints: undefined,
      // Slides grid
      spaceBetween: 0,
      slidesPerView: 1,
      slidesPerColumn: 1,
      slidesPerColumnFill: 'column',
      slidesPerGroup: 1,
      centeredSlides: false,
      slidesOffsetBefore: 0,
      // in px
      slidesOffsetAfter: 0,
      // in px
      // Round length
      roundLengths: false,
      // Touches
      touchRatio: 1,
      touchAngle: 45,
      simulateTouch: true,
      shortSwipes: true,
      longSwipes: true,
      longSwipesRatio: 0.5,
      longSwipesMs: 300,
      followFinger: true,
      onlyExternal: false,
      threshold: 0,
      touchMoveStopPropagation: true,
      touchReleaseOnEdges: false,
      // Unique Navigation Elements
      uniqueNavElements: true,
      // Pagination
      pagination: null,
      paginationElement: 'span',
      paginationClickable: false,
      paginationHide: false,
      paginationBulletRender: null,
      paginationProgressRender: null,
      paginationFractionRender: null,
      paginationCustomRender: null,
      paginationType: 'bullets',
      // 'bullets' or 'progress' or 'fraction' or 'custom'
      // Resistance
      resistance: true,
      resistanceRatio: 0.85,
      // Next/prev buttons
      nextButton: null,
      prevButton: null,
      // Progress
      watchSlidesProgress: false,
      watchSlidesVisibility: false,
      // Cursor
      grabCursor: false,
      // Clicks
      preventClicks: true,
      preventClicksPropagation: true,
      slideToClickedSlide: false,
      // Lazy Loading
      lazyLoading: false,
      lazyLoadingInPrevNext: false,
      lazyLoadingInPrevNextAmount: 1,
      lazyLoadingOnTransitionStart: false,
      // Images
      preloadImages: true,
      updateOnImagesReady: true,
      // loop
      loop: false,
      loopAdditionalSlides: 0,
      loopedSlides: null,
      // Control
      control: undefined,
      controlInverse: false,
      controlBy: 'slide',
      //or 'container'
      normalizeSlideIndex: true,
      // Swiping/no swiping
      allowSwipeToPrev: true,
      allowSwipeToNext: true,
      swipeHandler: null,
      //'.swipe-handler',
      noSwiping: true,
      noSwipingClass: 'swiper-no-swiping',
      // Passive Listeners
      passiveListeners: true,
      // NS
      containerModifierClass: 'swiper-container-',
      // NEW
      slideClass: 'swiper-slide',
      slideActiveClass: 'swiper-slide-active',
      slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
      slideVisibleClass: 'swiper-slide-visible',
      slideDuplicateClass: 'swiper-slide-duplicate',
      slideNextClass: 'swiper-slide-next',
      slideDuplicateNextClass: 'swiper-slide-duplicate-next',
      slidePrevClass: 'swiper-slide-prev',
      slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
      wrapperClass: 'swiper-wrapper',
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
      buttonDisabledClass: 'swiper-button-disabled',
      paginationCurrentClass: 'swiper-pagination-current',
      paginationTotalClass: 'swiper-pagination-total',
      paginationHiddenClass: 'swiper-pagination-hidden',
      paginationProgressbarClass: 'swiper-pagination-progressbar',
      paginationClickableClass: 'swiper-pagination-clickable',
      // NEW
      paginationModifierClass: 'swiper-pagination-',
      // NEW
      lazyLoadingClass: 'swiper-lazy',
      lazyStatusLoadingClass: 'swiper-lazy-loading',
      lazyStatusLoadedClass: 'swiper-lazy-loaded',
      lazyPreloaderClass: 'swiper-lazy-preloader',
      notificationClass: 'swiper-notification',
      preloaderClass: 'preloader',
      zoomContainerClass: 'swiper-zoom-container',
      // Observer
      observer: false,
      observeParents: false,
      // Accessibility
      a11y: false,
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}',
      // Callbacks
      runCallbacksOnInit: true
      /*
      Callbacks:
      onInit: function (swiper)
      onDestroy: function (swiper)
      onBeforeResize: function (swiper)
      onAfterResize: function (swiper)
      onClick: function (swiper, e)
      onTap: function (swiper, e)
      onDoubleTap: function (swiper, e)
      onSliderMove: function (swiper, e)
      onSlideChangeStart: function (swiper)
      onSlideChangeEnd: function (swiper)
      onTransitionStart: function (swiper)
      onTransitionEnd: function (swiper)
      onImagesReady: function (swiper)
      onProgress: function (swiper, progress)
      onTouchStart: function (swiper, e)
      onTouchMove: function (swiper, e)
      onTouchMoveOpposite: function (swiper, e)
      onTouchEnd: function (swiper, e)
      onReachBeginning: function (swiper)
      onReachEnd: function (swiper)
      onSetTransition: function (swiper, duration)
      onSetTranslate: function (swiper, translate)
      onAutoplayStart: function (swiper)
      onAutoplayStop: function (swiper),
      onLazyImageLoad: function (swiper, slide, image)
      onLazyImageReady: function (swiper, slide, image)
      onKeyPress: function (swiper, keyCode)
      */

    };
    var initialVirtualTranslate = params && params.virtualTranslate;
    params = params || {};
    var originalParams = {};

    for (var param in params) {
      if (_typeof(params[param]) === 'object' && params[param] !== null && !(params[param].nodeType || params[param] === window || params[param] === document || typeof Dom7 !== 'undefined' && params[param] instanceof Dom7 || typeof jQuery !== 'undefined' && params[param] instanceof jQuery)) {
        originalParams[param] = {};

        for (var deepParam in params[param]) {
          originalParams[param][deepParam] = params[param][deepParam];
        }
      } else {
        originalParams[param] = params[param];
      }
    }

    for (var def in defaults) {
      if (typeof params[def] === 'undefined') {
        params[def] = defaults[def];
      } else if (_typeof(params[def]) === 'object') {
        for (var deepDef in defaults[def]) {
          if (typeof params[def][deepDef] === 'undefined') {
            params[def][deepDef] = defaults[def][deepDef];
          }
        }
      }
    } // Swiper


    var s = this; // Params

    s.params = params;
    s.originalParams = originalParams; // Classname

    s.classNames = [];
    /*=========================
      Dom Library and plugins
      ===========================*/

    if (typeof $ !== 'undefined' && typeof Dom7 !== 'undefined') {
      $ = Dom7;
    }

    if (typeof $ === 'undefined') {
      if (typeof Dom7 === 'undefined') {
        $ = window.Dom7 || window.Zepto || window.jQuery;
      } else {
        $ = Dom7;
      }

      if (!$) return;
    } // Export it to Swiper instance


    s.$ = $;
    /*=========================
      Breakpoints
      ===========================*/

    s.currentBreakpoint = undefined;

    s.getActiveBreakpoint = function () {
      //Get breakpoint for window width
      if (!s.params.breakpoints) return false;
      var breakpoint = false;
      var points = [],
          point;

      for (point in s.params.breakpoints) {
        if (s.params.breakpoints.hasOwnProperty(point)) {
          points.push(point);
        }
      }

      points.sort(function (a, b) {
        return parseInt(a, 10) > parseInt(b, 10);
      });

      for (var i = 0; i < points.length; i++) {
        point = points[i];

        if (point >= window.innerWidth && !breakpoint) {
          breakpoint = point;
        }
      }

      return breakpoint || 'max';
    };

    s.setBreakpoint = function () {
      //Set breakpoint for window width and update parameters
      var breakpoint = s.getActiveBreakpoint();

      if (breakpoint && s.currentBreakpoint !== breakpoint) {
        var breakPointsParams = breakpoint in s.params.breakpoints ? s.params.breakpoints[breakpoint] : s.originalParams;
        var needsReLoop = s.params.loop && breakPointsParams.slidesPerView !== s.params.slidesPerView;

        for (var param in breakPointsParams) {
          s.params[param] = breakPointsParams[param];
        }

        s.currentBreakpoint = breakpoint;

        if (needsReLoop && s.destroyLoop) {
          s.reLoop(true);
        }
      }
    }; // Set breakpoint on load


    if (s.params.breakpoints) {
      s.setBreakpoint();
    }
    /*=========================
      Preparation - Define Container, Wrapper and Pagination
      ===========================*/


    s.container = $(container);
    if (s.container.length === 0) return;

    if (s.container.length > 1) {
      var swipers = [];
      s.container.each(function () {
        var container = this;
        swipers.push(new Swiper(this, params));
      });
      return swipers;
    } // Save instance in container HTML Element and in data


    s.container[0].swiper = s;
    s.container.data('swiper', s);
    s.classNames.push(s.params.containerModifierClass + s.params.direction);

    if (s.params.freeMode) {
      s.classNames.push(s.params.containerModifierClass + 'free-mode');
    }

    if (!s.support.flexbox) {
      s.classNames.push(s.params.containerModifierClass + 'no-flexbox');
      s.params.slidesPerColumn = 1;
    }

    if (s.params.autoHeight) {
      s.classNames.push(s.params.containerModifierClass + 'autoheight');
    } // Enable slides progress when required


    if (s.params.parallax || s.params.watchSlidesVisibility) {
      s.params.watchSlidesProgress = true;
    } // Max resistance when touchReleaseOnEdges


    if (s.params.touchReleaseOnEdges) {
      s.params.resistanceRatio = 0;
    } // Coverflow / 3D


    if (['cube', 'coverflow', 'flip'].indexOf(s.params.effect) >= 0) {
      if (s.support.transforms3d) {
        s.params.watchSlidesProgress = true;
        s.classNames.push(s.params.containerModifierClass + '3d');
      } else {
        s.params.effect = 'slide';
      }
    }

    if (s.params.effect !== 'slide') {
      s.classNames.push(s.params.containerModifierClass + s.params.effect);
    }

    if (s.params.effect === 'cube') {
      s.params.resistanceRatio = 0;
      s.params.slidesPerView = 1;
      s.params.slidesPerColumn = 1;
      s.params.slidesPerGroup = 1;
      s.params.centeredSlides = false;
      s.params.spaceBetween = 0;
      s.params.virtualTranslate = true;
    }

    if (s.params.effect === 'fade' || s.params.effect === 'flip') {
      s.params.slidesPerView = 1;
      s.params.slidesPerColumn = 1;
      s.params.slidesPerGroup = 1;
      s.params.watchSlidesProgress = true;
      s.params.spaceBetween = 0;

      if (typeof initialVirtualTranslate === 'undefined') {
        s.params.virtualTranslate = true;
      }
    } // Grab Cursor


    if (s.params.grabCursor && s.support.touch) {
      s.params.grabCursor = false;
    } // Wrapper


    s.wrapper = s.container.children('.' + s.params.wrapperClass); // Pagination

    if (s.params.pagination) {
      s.paginationContainer = $(s.params.pagination);

      if (s.params.uniqueNavElements && typeof s.params.pagination === 'string' && s.paginationContainer.length > 1 && s.container.find(s.params.pagination).length === 1) {
        s.paginationContainer = s.container.find(s.params.pagination);
      }

      if (s.params.paginationType === 'bullets' && s.params.paginationClickable) {
        s.paginationContainer.addClass(s.params.paginationModifierClass + 'clickable');
      } else {
        s.params.paginationClickable = false;
      }

      s.paginationContainer.addClass(s.params.paginationModifierClass + s.params.paginationType);
    } // Next/Prev Buttons


    if (s.params.nextButton || s.params.prevButton) {
      if (s.params.nextButton) {
        s.nextButton = $(s.params.nextButton);

        if (s.params.uniqueNavElements && typeof s.params.nextButton === 'string' && s.nextButton.length > 1 && s.container.find(s.params.nextButton).length === 1) {
          s.nextButton = s.container.find(s.params.nextButton);
        }
      }

      if (s.params.prevButton) {
        s.prevButton = $(s.params.prevButton);

        if (s.params.uniqueNavElements && typeof s.params.prevButton === 'string' && s.prevButton.length > 1 && s.container.find(s.params.prevButton).length === 1) {
          s.prevButton = s.container.find(s.params.prevButton);
        }
      }
    } // Is Horizontal


    s.isHorizontal = function () {
      return s.params.direction === 'horizontal';
    }; // s.isH = isH;
    // RTL


    s.rtl = s.isHorizontal() && (s.container[0].dir.toLowerCase() === 'rtl' || s.container.css('direction') === 'rtl');

    if (s.rtl) {
      s.classNames.push(s.params.containerModifierClass + 'rtl');
    } // Wrong RTL support


    if (s.rtl) {
      s.wrongRTL = s.wrapper.css('display') === '-webkit-box';
    } // Columns


    if (s.params.slidesPerColumn > 1) {
      s.classNames.push(s.params.containerModifierClass + 'multirow');
    } // Check for Android


    if (s.device.android) {
      s.classNames.push(s.params.containerModifierClass + 'android');
    } // Add classes


    s.container.addClass(s.classNames.join(' ')); // Translate

    s.translate = 0; // Progress

    s.progress = 0; // Velocity

    s.velocity = 0;
    /*=========================
      Locks, unlocks
      ===========================*/

    s.lockSwipeToNext = function () {
      s.params.allowSwipeToNext = false;

      if (s.params.allowSwipeToPrev === false && s.params.grabCursor) {
        s.unsetGrabCursor();
      }
    };

    s.lockSwipeToPrev = function () {
      s.params.allowSwipeToPrev = false;

      if (s.params.allowSwipeToNext === false && s.params.grabCursor) {
        s.unsetGrabCursor();
      }
    };

    s.lockSwipes = function () {
      s.params.allowSwipeToNext = s.params.allowSwipeToPrev = false;
      if (s.params.grabCursor) s.unsetGrabCursor();
    };

    s.unlockSwipeToNext = function () {
      s.params.allowSwipeToNext = true;

      if (s.params.allowSwipeToPrev === true && s.params.grabCursor) {
        s.setGrabCursor();
      }
    };

    s.unlockSwipeToPrev = function () {
      s.params.allowSwipeToPrev = true;

      if (s.params.allowSwipeToNext === true && s.params.grabCursor) {
        s.setGrabCursor();
      }
    };

    s.unlockSwipes = function () {
      s.params.allowSwipeToNext = s.params.allowSwipeToPrev = true;
      if (s.params.grabCursor) s.setGrabCursor();
    };
    /*=========================
      Round helper
      ===========================*/


    function round(a) {
      return Math.floor(a);
    }
    /*=========================
      Set grab cursor
      ===========================*/


    s.setGrabCursor = function (moving) {
      s.container[0].style.cursor = 'move';
      s.container[0].style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
      s.container[0].style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
      s.container[0].style.cursor = moving ? 'grabbing' : 'grab';
    };

    s.unsetGrabCursor = function () {
      s.container[0].style.cursor = '';
    };

    if (s.params.grabCursor) {
      s.setGrabCursor();
    }
    /*=========================
      Update on Images Ready
      ===========================*/


    s.imagesToLoad = [];
    s.imagesLoaded = 0;

    s.loadImage = function (imgElement, src, srcset, sizes, checkForComplete, callback) {
      var image;

      function onReady() {
        if (callback) callback();
      }

      if (!imgElement.complete || !checkForComplete) {
        if (src) {
          image = new window.Image();
          image.onload = onReady;
          image.onerror = onReady;

          if (sizes) {
            image.sizes = sizes;
          }

          if (srcset) {
            image.srcset = srcset;
          }

          if (src) {
            image.src = src;
          }
        } else {
          onReady();
        }
      } else {
        //image already loaded...
        onReady();
      }
    };

    s.preloadImages = function () {
      s.imagesToLoad = s.container.find('img');

      function _onReady() {
        if (typeof s === 'undefined' || s === null || !s) return;
        if (s.imagesLoaded !== undefined) s.imagesLoaded++;

        if (s.imagesLoaded === s.imagesToLoad.length) {
          if (s.params.updateOnImagesReady) s.update();
          s.emit('onImagesReady', s);
        }
      }

      for (var i = 0; i < s.imagesToLoad.length; i++) {
        s.loadImage(s.imagesToLoad[i], s.imagesToLoad[i].currentSrc || s.imagesToLoad[i].getAttribute('src'), s.imagesToLoad[i].srcset || s.imagesToLoad[i].getAttribute('srcset'), s.imagesToLoad[i].sizes || s.imagesToLoad[i].getAttribute('sizes'), true, _onReady);
      }
    };
    /*=========================
      Autoplay
      ===========================*/


    s.autoplayTimeoutId = undefined;
    s.autoplaying = false;
    s.autoplayPaused = false;

    function autoplay() {
      var autoplayDelay = s.params.autoplay;
      var activeSlide = s.slides.eq(s.activeIndex);

      if (activeSlide.attr('data-swiper-autoplay')) {
        autoplayDelay = activeSlide.attr('data-swiper-autoplay') || s.params.autoplay;
      }

      s.autoplayTimeoutId = setTimeout(function () {
        if (s.params.loop) {
          s.fixLoop();

          s._slideNext();

          s.emit('onAutoplay', s);
        } else {
          if (!s.isEnd) {
            s._slideNext();

            s.emit('onAutoplay', s);
          } else {
            if (!params.autoplayStopOnLast) {
              s._slideTo(0);

              s.emit('onAutoplay', s);
            } else {
              s.stopAutoplay();
            }
          }
        }
      }, autoplayDelay);
    }

    s.startAutoplay = function () {
      if (typeof s.autoplayTimeoutId !== 'undefined') return false;
      if (!s.params.autoplay) return false;
      if (s.autoplaying) return false;
      s.autoplaying = true;
      s.emit('onAutoplayStart', s);
      autoplay();
    };

    s.stopAutoplay = function (internal) {
      if (!s.autoplayTimeoutId) return;
      if (s.autoplayTimeoutId) clearTimeout(s.autoplayTimeoutId);
      s.autoplaying = false;
      s.autoplayTimeoutId = undefined;
      s.emit('onAutoplayStop', s);
    };

    s.pauseAutoplay = function (speed) {
      if (s.autoplayPaused) return;
      if (s.autoplayTimeoutId) clearTimeout(s.autoplayTimeoutId);
      s.autoplayPaused = true;

      if (speed === 0) {
        s.autoplayPaused = false;
        autoplay();
      } else {
        s.wrapper.transitionEnd(function () {
          if (!s) return;
          s.autoplayPaused = false;

          if (!s.autoplaying) {
            s.stopAutoplay();
          } else {
            autoplay();
          }
        });
      }
    };
    /*=========================
      Min/Max Translate
      ===========================*/


    s.minTranslate = function () {
      return -s.snapGrid[0];
    };

    s.maxTranslate = function () {
      return -s.snapGrid[s.snapGrid.length - 1];
    };
    /*=========================
      Slider/slides sizes
      ===========================*/


    s.updateAutoHeight = function () {
      var activeSlides = [];
      var newHeight = 0;
      var i; // Find slides currently in view

      if (s.params.slidesPerView !== 'auto' && s.params.slidesPerView > 1) {
        for (i = 0; i < Math.ceil(s.params.slidesPerView); i++) {
          var index = s.activeIndex + i;
          if (index > s.slides.length) break;
          activeSlides.push(s.slides.eq(index)[0]);
        }
      } else {
        activeSlides.push(s.slides.eq(s.activeIndex)[0]);
      } // Find new height from heighest slide in view


      for (i = 0; i < activeSlides.length; i++) {
        if (typeof activeSlides[i] !== 'undefined') {
          var height = activeSlides[i].offsetHeight;
          newHeight = height > newHeight ? height : newHeight;
        }
      } // Update Height


      if (newHeight) s.wrapper.css('height', newHeight + 'px');
    };

    s.updateContainerSize = function () {
      var width, height;

      if (typeof s.params.width !== 'undefined') {
        width = s.params.width;
      } else {
        width = s.container[0].clientWidth;
      }

      if (typeof s.params.height !== 'undefined') {
        height = s.params.height;
      } else {
        height = s.container[0].clientHeight;
      }

      if (width === 0 && s.isHorizontal() || height === 0 && !s.isHorizontal()) {
        return;
      } //Subtract paddings


      width = width - parseInt(s.container.css('padding-left'), 10) - parseInt(s.container.css('padding-right'), 10);
      height = height - parseInt(s.container.css('padding-top'), 10) - parseInt(s.container.css('padding-bottom'), 10); // Store values

      s.width = width;
      s.height = height;
      s.size = s.isHorizontal() ? s.width : s.height;
    };

    s.updateSlidesSize = function () {
      s.slides = s.wrapper.children('.' + s.params.slideClass);
      s.snapGrid = [];
      s.slidesGrid = [];
      s.slidesSizesGrid = [];
      var spaceBetween = s.params.spaceBetween,
          slidePosition = -s.params.slidesOffsetBefore,
          i,
          prevSlideSize = 0,
          index = 0;
      if (typeof s.size === 'undefined') return;

      if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
        spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * s.size;
      }

      s.virtualSize = -spaceBetween; // reset margins

      if (s.rtl) s.slides.css({
        marginLeft: '',
        marginTop: ''
      });else s.slides.css({
        marginRight: '',
        marginBottom: ''
      });
      var slidesNumberEvenToRows;

      if (s.params.slidesPerColumn > 1) {
        if (Math.floor(s.slides.length / s.params.slidesPerColumn) === s.slides.length / s.params.slidesPerColumn) {
          slidesNumberEvenToRows = s.slides.length;
        } else {
          slidesNumberEvenToRows = Math.ceil(s.slides.length / s.params.slidesPerColumn) * s.params.slidesPerColumn;
        }

        if (s.params.slidesPerView !== 'auto' && s.params.slidesPerColumnFill === 'row') {
          slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, s.params.slidesPerView * s.params.slidesPerColumn);
        }
      } // Calc slides


      var slideSize;
      var slidesPerColumn = s.params.slidesPerColumn;
      var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
      var numFullColumns = slidesPerRow - (s.params.slidesPerColumn * slidesPerRow - s.slides.length);

      for (i = 0; i < s.slides.length; i++) {
        slideSize = 0;
        var slide = s.slides.eq(i);

        if (s.params.slidesPerColumn > 1) {
          // Set slides order
          var newSlideOrderIndex;
          var column, row;

          if (s.params.slidesPerColumnFill === 'column') {
            column = Math.floor(i / slidesPerColumn);
            row = i - column * slidesPerColumn;

            if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
              if (++row >= slidesPerColumn) {
                row = 0;
                column++;
              }
            }

            newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
            slide.css({
              '-webkit-box-ordinal-group': newSlideOrderIndex,
              '-moz-box-ordinal-group': newSlideOrderIndex,
              '-ms-flex-order': newSlideOrderIndex,
              '-webkit-order': newSlideOrderIndex,
              'order': newSlideOrderIndex
            });
          } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
          }

          slide.css('margin-' + (s.isHorizontal() ? 'top' : 'left'), row !== 0 && s.params.spaceBetween && s.params.spaceBetween + 'px').attr('data-swiper-column', column).attr('data-swiper-row', row);
        }

        if (slide.css('display') === 'none') continue;

        if (s.params.slidesPerView === 'auto') {
          slideSize = s.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
          if (s.params.roundLengths) slideSize = round(slideSize);
        } else {
          slideSize = (s.size - (s.params.slidesPerView - 1) * spaceBetween) / s.params.slidesPerView;
          if (s.params.roundLengths) slideSize = round(slideSize);

          if (s.isHorizontal()) {
            s.slides[i].style.width = slideSize + 'px';
          } else {
            s.slides[i].style.height = slideSize + 'px';
          }
        }

        s.slides[i].swiperSlideSize = slideSize;
        s.slidesSizesGrid.push(slideSize);

        if (s.params.centeredSlides) {
          slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
          if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - s.size / 2 - spaceBetween;
          if (i === 0) slidePosition = slidePosition - s.size / 2 - spaceBetween;
          if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
          if (index % s.params.slidesPerGroup === 0) s.snapGrid.push(slidePosition);
          s.slidesGrid.push(slidePosition);
        } else {
          if (index % s.params.slidesPerGroup === 0) s.snapGrid.push(slidePosition);
          s.slidesGrid.push(slidePosition);
          slidePosition = slidePosition + slideSize + spaceBetween;
        }

        s.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index++;
      }

      s.virtualSize = Math.max(s.virtualSize, s.size) + s.params.slidesOffsetAfter;
      var newSlidesGrid;

      if (s.rtl && s.wrongRTL && (s.params.effect === 'slide' || s.params.effect === 'coverflow')) {
        s.wrapper.css({
          width: s.virtualSize + s.params.spaceBetween + 'px'
        });
      }

      if (!s.support.flexbox || s.params.setWrapperSize) {
        if (s.isHorizontal()) s.wrapper.css({
          width: s.virtualSize + s.params.spaceBetween + 'px'
        });else s.wrapper.css({
          height: s.virtualSize + s.params.spaceBetween + 'px'
        });
      }

      if (s.params.slidesPerColumn > 1) {
        s.virtualSize = (slideSize + s.params.spaceBetween) * slidesNumberEvenToRows;
        s.virtualSize = Math.ceil(s.virtualSize / s.params.slidesPerColumn) - s.params.spaceBetween;
        if (s.isHorizontal()) s.wrapper.css({
          width: s.virtualSize + s.params.spaceBetween + 'px'
        });else s.wrapper.css({
          height: s.virtualSize + s.params.spaceBetween + 'px'
        });

        if (s.params.centeredSlides) {
          newSlidesGrid = [];

          for (i = 0; i < s.snapGrid.length; i++) {
            if (s.snapGrid[i] < s.virtualSize + s.snapGrid[0]) newSlidesGrid.push(s.snapGrid[i]);
          }

          s.snapGrid = newSlidesGrid;
        }
      } // Remove last grid elements depending on width


      if (!s.params.centeredSlides) {
        newSlidesGrid = [];

        for (i = 0; i < s.snapGrid.length; i++) {
          if (s.snapGrid[i] <= s.virtualSize - s.size) {
            newSlidesGrid.push(s.snapGrid[i]);
          }
        }

        s.snapGrid = newSlidesGrid;

        if (Math.floor(s.virtualSize - s.size) - Math.floor(s.snapGrid[s.snapGrid.length - 1]) > 1) {
          s.snapGrid.push(s.virtualSize - s.size);
        }
      }

      if (s.snapGrid.length === 0) s.snapGrid = [0];

      if (s.params.spaceBetween !== 0) {
        if (s.isHorizontal()) {
          if (s.rtl) s.slides.css({
            marginLeft: spaceBetween + 'px'
          });else s.slides.css({
            marginRight: spaceBetween + 'px'
          });
        } else s.slides.css({
          marginBottom: spaceBetween + 'px'
        });
      }

      if (s.params.watchSlidesProgress) {
        s.updateSlidesOffset();
      }
    };

    s.updateSlidesOffset = function () {
      for (var i = 0; i < s.slides.length; i++) {
        s.slides[i].swiperSlideOffset = s.isHorizontal() ? s.slides[i].offsetLeft : s.slides[i].offsetTop;
      }
    };
    /*=========================
      Dynamic Slides Per View
      ===========================*/


    s.currentSlidesPerView = function () {
      var spv = 1,
          i,
          j;

      if (s.params.centeredSlides) {
        var size = s.slides[s.activeIndex].swiperSlideSize;
        var breakLoop;

        for (i = s.activeIndex + 1; i < s.slides.length; i++) {
          if (s.slides[i] && !breakLoop) {
            size += s.slides[i].swiperSlideSize;
            spv++;
            if (size > s.size) breakLoop = true;
          }
        }

        for (j = s.activeIndex - 1; j >= 0; j--) {
          if (s.slides[j] && !breakLoop) {
            size += s.slides[j].swiperSlideSize;
            spv++;
            if (size > s.size) breakLoop = true;
          }
        }
      } else {
        for (i = s.activeIndex + 1; i < s.slides.length; i++) {
          if (s.slidesGrid[i] - s.slidesGrid[s.activeIndex] < s.size) {
            spv++;
          }
        }
      }

      return spv;
    };
    /*=========================
      Slider/slides progress
      ===========================*/


    s.updateSlidesProgress = function (translate) {
      if (typeof translate === 'undefined') {
        translate = s.translate || 0;
      }

      if (s.slides.length === 0) return;
      if (typeof s.slides[0].swiperSlideOffset === 'undefined') s.updateSlidesOffset();
      var offsetCenter = -translate;
      if (s.rtl) offsetCenter = translate; // Visible Slides

      s.slides.removeClass(s.params.slideVisibleClass);

      for (var i = 0; i < s.slides.length; i++) {
        var slide = s.slides[i];
        var slideProgress = (offsetCenter + (s.params.centeredSlides ? s.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + s.params.spaceBetween);

        if (s.params.watchSlidesVisibility) {
          var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
          var slideAfter = slideBefore + s.slidesSizesGrid[i];
          var isVisible = slideBefore >= 0 && slideBefore < s.size || slideAfter > 0 && slideAfter <= s.size || slideBefore <= 0 && slideAfter >= s.size;

          if (isVisible) {
            s.slides.eq(i).addClass(s.params.slideVisibleClass);
          }
        }

        slide.progress = s.rtl ? -slideProgress : slideProgress;
      }
    };

    s.updateProgress = function (translate) {
      if (typeof translate === 'undefined') {
        translate = s.translate || 0;
      }

      var translatesDiff = s.maxTranslate() - s.minTranslate();
      var wasBeginning = s.isBeginning;
      var wasEnd = s.isEnd;

      if (translatesDiff === 0) {
        s.progress = 0;
        s.isBeginning = s.isEnd = true;
      } else {
        s.progress = (translate - s.minTranslate()) / translatesDiff;
        s.isBeginning = s.progress <= 0;
        s.isEnd = s.progress >= 1;
      }

      if (s.isBeginning && !wasBeginning) s.emit('onReachBeginning', s);
      if (s.isEnd && !wasEnd) s.emit('onReachEnd', s);
      if (s.params.watchSlidesProgress) s.updateSlidesProgress(translate);
      s.emit('onProgress', s, s.progress);
    };

    s.updateActiveIndex = function () {
      var translate = s.rtl ? s.translate : -s.translate;
      var newActiveIndex, i, snapIndex;

      for (i = 0; i < s.slidesGrid.length; i++) {
        if (typeof s.slidesGrid[i + 1] !== 'undefined') {
          if (translate >= s.slidesGrid[i] && translate < s.slidesGrid[i + 1] - (s.slidesGrid[i + 1] - s.slidesGrid[i]) / 2) {
            newActiveIndex = i;
          } else if (translate >= s.slidesGrid[i] && translate < s.slidesGrid[i + 1]) {
            newActiveIndex = i + 1;
          }
        } else {
          if (translate >= s.slidesGrid[i]) {
            newActiveIndex = i;
          }
        }
      } // Normalize slideIndex


      if (s.params.normalizeSlideIndex) {
        if (newActiveIndex < 0 || typeof newActiveIndex === 'undefined') newActiveIndex = 0;
      } // for (i = 0; i < s.slidesGrid.length; i++) {
      // if (- translate >= s.slidesGrid[i]) {
      // newActiveIndex = i;
      // }
      // }


      snapIndex = Math.floor(newActiveIndex / s.params.slidesPerGroup);
      if (snapIndex >= s.snapGrid.length) snapIndex = s.snapGrid.length - 1;

      if (newActiveIndex === s.activeIndex) {
        return;
      }

      s.snapIndex = snapIndex;
      s.previousIndex = s.activeIndex;
      s.activeIndex = newActiveIndex;
      s.updateClasses();
      s.updateRealIndex();
    };

    s.updateRealIndex = function () {
      s.realIndex = parseInt(s.slides.eq(s.activeIndex).attr('data-swiper-slide-index') || s.activeIndex, 10);
    };
    /*=========================
      Classes
      ===========================*/


    s.updateClasses = function () {
      s.slides.removeClass(s.params.slideActiveClass + ' ' + s.params.slideNextClass + ' ' + s.params.slidePrevClass + ' ' + s.params.slideDuplicateActiveClass + ' ' + s.params.slideDuplicateNextClass + ' ' + s.params.slideDuplicatePrevClass);
      var activeSlide = s.slides.eq(s.activeIndex); // Active classes

      activeSlide.addClass(s.params.slideActiveClass);

      if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(s.params.slideDuplicateClass)) {
          s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + s.realIndex + '"]').addClass(s.params.slideDuplicateActiveClass);
        } else {
          s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + s.realIndex + '"]').addClass(s.params.slideDuplicateActiveClass);
        }
      } // Next Slide


      var nextSlide = activeSlide.next('.' + s.params.slideClass).addClass(s.params.slideNextClass);

      if (s.params.loop && nextSlide.length === 0) {
        nextSlide = s.slides.eq(0);
        nextSlide.addClass(s.params.slideNextClass);
      } // Prev Slide


      var prevSlide = activeSlide.prev('.' + s.params.slideClass).addClass(s.params.slidePrevClass);

      if (s.params.loop && prevSlide.length === 0) {
        prevSlide = s.slides.eq(-1);
        prevSlide.addClass(s.params.slidePrevClass);
      }

      if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(s.params.slideDuplicateClass)) {
          s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + nextSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicateNextClass);
        } else {
          s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + nextSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicateNextClass);
        }

        if (prevSlide.hasClass(s.params.slideDuplicateClass)) {
          s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + prevSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicatePrevClass);
        } else {
          s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + prevSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicatePrevClass);
        }
      } // Pagination


      if (s.paginationContainer && s.paginationContainer.length > 0) {
        // Current/Total
        var current,
            total = s.params.loop ? Math.ceil((s.slides.length - s.loopedSlides * 2) / s.params.slidesPerGroup) : s.snapGrid.length;

        if (s.params.loop) {
          current = Math.ceil((s.activeIndex - s.loopedSlides) / s.params.slidesPerGroup);

          if (current > s.slides.length - 1 - s.loopedSlides * 2) {
            current = current - (s.slides.length - s.loopedSlides * 2);
          }

          if (current > total - 1) current = current - total;
          if (current < 0 && s.params.paginationType !== 'bullets') current = total + current;
        } else {
          if (typeof s.snapIndex !== 'undefined') {
            current = s.snapIndex;
          } else {
            current = s.activeIndex || 0;
          }
        } // Types


        if (s.params.paginationType === 'bullets' && s.bullets && s.bullets.length > 0) {
          s.bullets.removeClass(s.params.bulletActiveClass);

          if (s.paginationContainer.length > 1) {
            s.bullets.each(function () {
              if ($(this).index() === current) $(this).addClass(s.params.bulletActiveClass);
            });
          } else {
            s.bullets.eq(current).addClass(s.params.bulletActiveClass);
          }
        }

        if (s.params.paginationType === 'fraction') {
          s.paginationContainer.find('.' + s.params.paginationCurrentClass).text(current + 1);
          s.paginationContainer.find('.' + s.params.paginationTotalClass).text(total);
        }

        if (s.params.paginationType === 'progress') {
          var scale = (current + 1) / total,
              scaleX = scale,
              scaleY = 1;

          if (!s.isHorizontal()) {
            scaleY = scale;
            scaleX = 1;
          }

          s.paginationContainer.find('.' + s.params.paginationProgressbarClass).transform('translate3d(0,0,0) scaleX(' + scaleX + ') scaleY(' + scaleY + ')').transition(s.params.speed);
        }

        if (s.params.paginationType === 'custom' && s.params.paginationCustomRender) {
          s.paginationContainer.html(s.params.paginationCustomRender(s, current + 1, total));
          s.emit('onPaginationRendered', s, s.paginationContainer[0]);
        }
      } // Next/active buttons


      if (!s.params.loop) {
        if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
          if (s.isBeginning) {
            s.prevButton.addClass(s.params.buttonDisabledClass);
            if (s.params.a11y && s.a11y) s.a11y.disable(s.prevButton);
          } else {
            s.prevButton.removeClass(s.params.buttonDisabledClass);
            if (s.params.a11y && s.a11y) s.a11y.enable(s.prevButton);
          }
        }

        if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
          if (s.isEnd) {
            s.nextButton.addClass(s.params.buttonDisabledClass);
            if (s.params.a11y && s.a11y) s.a11y.disable(s.nextButton);
          } else {
            s.nextButton.removeClass(s.params.buttonDisabledClass);
            if (s.params.a11y && s.a11y) s.a11y.enable(s.nextButton);
          }
        }
      }
    };
    /*=========================
      Pagination
      ===========================*/


    s.updatePagination = function () {
      if (!s.params.pagination) return;

      if (s.paginationContainer && s.paginationContainer.length > 0) {
        var paginationHTML = '';

        if (s.params.paginationType === 'bullets') {
          var numberOfBullets = s.params.loop ? Math.ceil((s.slides.length - s.loopedSlides * 2) / s.params.slidesPerGroup) : s.snapGrid.length;

          for (var i = 0; i < numberOfBullets; i++) {
            if (s.params.paginationBulletRender) {
              paginationHTML += s.params.paginationBulletRender(s, i, s.params.bulletClass);
            } else {
              paginationHTML += '<' + s.params.paginationElement + ' class="' + s.params.bulletClass + '"></' + s.params.paginationElement + '>';
            }
          }

          s.paginationContainer.html(paginationHTML);
          s.bullets = s.paginationContainer.find('.' + s.params.bulletClass);

          if (s.params.paginationClickable && s.params.a11y && s.a11y) {
            s.a11y.initPagination();
          }
        }

        if (s.params.paginationType === 'fraction') {
          if (s.params.paginationFractionRender) {
            paginationHTML = s.params.paginationFractionRender(s, s.params.paginationCurrentClass, s.params.paginationTotalClass);
          } else {
            paginationHTML = '<span class="' + s.params.paginationCurrentClass + '"></span>' + ' / ' + '<span class="' + s.params.paginationTotalClass + '"></span>';
          }

          s.paginationContainer.html(paginationHTML);
        }

        if (s.params.paginationType === 'progress') {
          if (s.params.paginationProgressRender) {
            paginationHTML = s.params.paginationProgressRender(s, s.params.paginationProgressbarClass);
          } else {
            paginationHTML = '<span class="' + s.params.paginationProgressbarClass + '"></span>';
          }

          s.paginationContainer.html(paginationHTML);
        }

        if (s.params.paginationType !== 'custom') {
          s.emit('onPaginationRendered', s, s.paginationContainer[0]);
        }
      }
    };
    /*=========================
      Common update method
      ===========================*/


    s.update = function (updateTranslate) {
      if (!s) return;
      s.updateContainerSize();
      s.updateSlidesSize();
      s.updateProgress();
      s.updatePagination();
      s.updateClasses();

      if (s.params.scrollbar && s.scrollbar) {
        s.scrollbar.set();
      }

      var newTranslate;

      function forceSetTranslate() {
        var translate = s.rtl ? -s.translate : s.translate;
        newTranslate = Math.min(Math.max(s.translate, s.maxTranslate()), s.minTranslate());
        s.setWrapperTranslate(newTranslate);
        s.updateActiveIndex();
        s.updateClasses();
      }

      if (updateTranslate) {
        var translated;

        if (s.controller && s.controller.spline) {
          s.controller.spline = undefined;
        }

        if (s.params.freeMode) {
          forceSetTranslate();

          if (s.params.autoHeight) {
            s.updateAutoHeight();
          }
        } else {
          if ((s.params.slidesPerView === 'auto' || s.params.slidesPerView > 1) && s.isEnd && !s.params.centeredSlides) {
            translated = s.slideTo(s.slides.length - 1, 0, false, true);
          } else {
            translated = s.slideTo(s.activeIndex, 0, false, true);
          }

          if (!translated) {
            forceSetTranslate();
          }
        }
      } else if (s.params.autoHeight) {
        s.updateAutoHeight();
      }
    };
    /*=========================
      Resize Handler
      ===========================*/


    s.onResize = function (forceUpdatePagination) {
      if (s.params.onBeforeResize) s.params.onBeforeResize(s); //Breakpoints

      if (s.params.breakpoints) {
        s.setBreakpoint();
      } // Disable locks on resize


      var allowSwipeToPrev = s.params.allowSwipeToPrev;
      var allowSwipeToNext = s.params.allowSwipeToNext;
      s.params.allowSwipeToPrev = s.params.allowSwipeToNext = true;
      s.updateContainerSize();
      s.updateSlidesSize();
      if (s.params.slidesPerView === 'auto' || s.params.freeMode || forceUpdatePagination) s.updatePagination();

      if (s.params.scrollbar && s.scrollbar) {
        s.scrollbar.set();
      }

      if (s.controller && s.controller.spline) {
        s.controller.spline = undefined;
      }

      var slideChangedBySlideTo = false;

      if (s.params.freeMode) {
        var newTranslate = Math.min(Math.max(s.translate, s.maxTranslate()), s.minTranslate());
        s.setWrapperTranslate(newTranslate);
        s.updateActiveIndex();
        s.updateClasses();

        if (s.params.autoHeight) {
          s.updateAutoHeight();
        }
      } else {
        s.updateClasses();

        if ((s.params.slidesPerView === 'auto' || s.params.slidesPerView > 1) && s.isEnd && !s.params.centeredSlides) {
          slideChangedBySlideTo = s.slideTo(s.slides.length - 1, 0, false, true);
        } else {
          slideChangedBySlideTo = s.slideTo(s.activeIndex, 0, false, true);
        }
      }

      if (s.params.lazyLoading && !slideChangedBySlideTo && s.lazy) {
        s.lazy.load();
      } // Return locks after resize


      s.params.allowSwipeToPrev = allowSwipeToPrev;
      s.params.allowSwipeToNext = allowSwipeToNext;
      if (s.params.onAfterResize) s.params.onAfterResize(s);
    };
    /*=========================
      Events
      ===========================*/
    //Define Touch Events


    s.touchEventsDesktop = {
      start: 'mousedown',
      move: 'mousemove',
      end: 'mouseup'
    };
    if (window.navigator.pointerEnabled) s.touchEventsDesktop = {
      start: 'pointerdown',
      move: 'pointermove',
      end: 'pointerup'
    };else if (window.navigator.msPointerEnabled) s.touchEventsDesktop = {
      start: 'MSPointerDown',
      move: 'MSPointerMove',
      end: 'MSPointerUp'
    };
    s.touchEvents = {
      start: s.support.touch || !s.params.simulateTouch ? 'touchstart' : s.touchEventsDesktop.start,
      move: s.support.touch || !s.params.simulateTouch ? 'touchmove' : s.touchEventsDesktop.move,
      end: s.support.touch || !s.params.simulateTouch ? 'touchend' : s.touchEventsDesktop.end
    }; // WP8 Touch Events Fix

    if (window.navigator.pointerEnabled || window.navigator.msPointerEnabled) {
      (s.params.touchEventsTarget === 'container' ? s.container : s.wrapper).addClass('swiper-wp8-' + s.params.direction);
    } // Attach/detach events


    s.initEvents = function (detach) {
      var actionDom = detach ? 'off' : 'on';
      var action = detach ? 'removeEventListener' : 'addEventListener';
      var touchEventsTarget = s.params.touchEventsTarget === 'container' ? s.container[0] : s.wrapper[0];
      var target = s.support.touch ? touchEventsTarget : document;
      var moveCapture = s.params.nested ? true : false; //Touch Events

      if (s.browser.ie) {
        touchEventsTarget[action](s.touchEvents.start, s.onTouchStart, false);
        target[action](s.touchEvents.move, s.onTouchMove, moveCapture);
        target[action](s.touchEvents.end, s.onTouchEnd, false);
      } else {
        if (s.support.touch) {
          var passiveListener = s.touchEvents.start === 'touchstart' && s.support.passiveListener && s.params.passiveListeners ? {
            passive: true,
            capture: false
          } : false;
          touchEventsTarget[action](s.touchEvents.start, s.onTouchStart, passiveListener);
          touchEventsTarget[action](s.touchEvents.move, s.onTouchMove, moveCapture);
          touchEventsTarget[action](s.touchEvents.end, s.onTouchEnd, passiveListener);
        }

        if (params.simulateTouch && !s.device.ios && !s.device.android || params.simulateTouch && !s.support.touch && s.device.ios) {
          touchEventsTarget[action]('mousedown', s.onTouchStart, false);
          document[action]('mousemove', s.onTouchMove, moveCapture);
          document[action]('mouseup', s.onTouchEnd, false);
        }
      }

      window[action]('resize', s.onResize); // Next, Prev, Index

      if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
        s.nextButton[actionDom]('click', s.onClickNext);
        if (s.params.a11y && s.a11y) s.nextButton[actionDom]('keydown', s.a11y.onEnterKey);
      }

      if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
        s.prevButton[actionDom]('click', s.onClickPrev);
        if (s.params.a11y && s.a11y) s.prevButton[actionDom]('keydown', s.a11y.onEnterKey);
      }

      if (s.params.pagination && s.params.paginationClickable) {
        s.paginationContainer[actionDom]('click', '.' + s.params.bulletClass, s.onClickIndex);
        if (s.params.a11y && s.a11y) s.paginationContainer[actionDom]('keydown', '.' + s.params.bulletClass, s.a11y.onEnterKey);
      } // Prevent Links Clicks


      if (s.params.preventClicks || s.params.preventClicksPropagation) touchEventsTarget[action]('click', s.preventClicks, true);
    };

    s.attachEvents = function () {
      s.initEvents();
    };

    s.detachEvents = function () {
      s.initEvents(true);
    };
    /*=========================
      Handle Clicks
      ===========================*/
    // Prevent Clicks


    s.allowClick = true;

    s.preventClicks = function (e) {
      if (!s.allowClick) {
        if (s.params.preventClicks) e.preventDefault();

        if (s.params.preventClicksPropagation && s.animating) {
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
      }
    }; // Clicks


    s.onClickNext = function (e) {
      e.preventDefault();
      if (s.isEnd && !s.params.loop) return;
      s.slideNext();
    };

    s.onClickPrev = function (e) {
      e.preventDefault();
      if (s.isBeginning && !s.params.loop) return;
      s.slidePrev();
    };

    s.onClickIndex = function (e) {
      e.preventDefault();
      var index = $(this).index() * s.params.slidesPerGroup;
      if (s.params.loop) index = index + s.loopedSlides;
      s.slideTo(index);
    };
    /*=========================
      Handle Touches
      ===========================*/


    function findElementInEvent(e, selector) {
      var el = $(e.target);

      if (!el.is(selector)) {
        if (typeof selector === 'string') {
          el = el.parents(selector);
        } else if (selector.nodeType) {
          var found;
          el.parents().each(function (index, _el) {
            if (_el === selector) found = selector;
          });
          if (!found) return undefined;else return selector;
        }
      }

      if (el.length === 0) {
        return undefined;
      }

      return el[0];
    }

    s.updateClickedSlide = function (e) {
      var slide = findElementInEvent(e, '.' + s.params.slideClass);
      var slideFound = false;

      if (slide) {
        for (var i = 0; i < s.slides.length; i++) {
          if (s.slides[i] === slide) slideFound = true;
        }
      }

      if (slide && slideFound) {
        s.clickedSlide = slide;
        s.clickedIndex = $(slide).index();
      } else {
        s.clickedSlide = undefined;
        s.clickedIndex = undefined;
        return;
      }

      if (s.params.slideToClickedSlide && s.clickedIndex !== undefined && s.clickedIndex !== s.activeIndex) {
        var slideToIndex = s.clickedIndex,
            realIndex,
            duplicatedSlides,
            slidesPerView = s.params.slidesPerView === 'auto' ? s.currentSlidesPerView() : s.params.slidesPerView;

        if (s.params.loop) {
          if (s.animating) return;
          realIndex = parseInt($(s.clickedSlide).attr('data-swiper-slide-index'), 10);

          if (s.params.centeredSlides) {
            if (slideToIndex < s.loopedSlides - slidesPerView / 2 || slideToIndex > s.slides.length - s.loopedSlides + slidesPerView / 2) {
              s.fixLoop();
              slideToIndex = s.wrapper.children('.' + s.params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + s.params.slideDuplicateClass + ')').eq(0).index();
              setTimeout(function () {
                s.slideTo(slideToIndex);
              }, 0);
            } else {
              s.slideTo(slideToIndex);
            }
          } else {
            if (slideToIndex > s.slides.length - slidesPerView) {
              s.fixLoop();
              slideToIndex = s.wrapper.children('.' + s.params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + s.params.slideDuplicateClass + ')').eq(0).index();
              setTimeout(function () {
                s.slideTo(slideToIndex);
              }, 0);
            } else {
              s.slideTo(slideToIndex);
            }
          }
        } else {
          s.slideTo(slideToIndex);
        }
      }
    };

    var isTouched,
        isMoved,
        allowTouchCallbacks,
        touchStartTime,
        isScrolling,
        currentTranslate,
        startTranslate,
        allowThresholdMove,
        // Form elements to match
    formElements = 'input, select, textarea, button, video',
        // Last click time
    lastClickTime = Date.now(),
        clickTimeout,
        //Velocities
    velocities = [],
        allowMomentumBounce; // Animating Flag

    s.animating = false; // Touches information

    s.touches = {
      startX: 0,
      startY: 0,
      currentX: 0,
      currentY: 0,
      diff: 0
    }; // Touch handlers

    var isTouchEvent, startMoving;

    s.onTouchStart = function (e) {
      if (e.originalEvent) e = e.originalEvent;
      isTouchEvent = e.type === 'touchstart';
      if (!isTouchEvent && 'which' in e && e.which === 3) return;

      if (s.params.noSwiping && findElementInEvent(e, '.' + s.params.noSwipingClass)) {
        s.allowClick = true;
        return;
      }

      if (s.params.swipeHandler) {
        if (!findElementInEvent(e, s.params.swipeHandler)) return;
      }

      var startX = s.touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
      var startY = s.touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore

      if (s.device.ios && s.params.iOSEdgeSwipeDetection && startX <= s.params.iOSEdgeSwipeThreshold) {
        return;
      }

      isTouched = true;
      isMoved = false;
      allowTouchCallbacks = true;
      isScrolling = undefined;
      startMoving = undefined;
      s.touches.startX = startX;
      s.touches.startY = startY;
      touchStartTime = Date.now();
      s.allowClick = true;
      s.updateContainerSize();
      s.swipeDirection = undefined;
      if (s.params.threshold > 0) allowThresholdMove = false;

      if (e.type !== 'touchstart') {
        var preventDefault = true;
        if ($(e.target).is(formElements)) preventDefault = false;

        if (document.activeElement && $(document.activeElement).is(formElements)) {
          document.activeElement.blur();
        }

        if (preventDefault) {
          e.preventDefault();
        }
      }

      s.emit('onTouchStart', s, e);
    };

    s.onTouchMove = function (e) {
      if (e.originalEvent) e = e.originalEvent;
      if (isTouchEvent && e.type === 'mousemove') return;

      if (e.preventedByNestedSwiper) {
        s.touches.startX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
        s.touches.startY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
        return;
      }

      if (s.params.onlyExternal) {
        // isMoved = true;
        s.allowClick = false;

        if (isTouched) {
          s.touches.startX = s.touches.currentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
          s.touches.startY = s.touches.currentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
          touchStartTime = Date.now();
        }

        return;
      }

      if (isTouchEvent && s.params.touchReleaseOnEdges && !s.params.loop) {
        if (!s.isHorizontal()) {
          // Vertical
          if (s.touches.currentY < s.touches.startY && s.translate <= s.maxTranslate() || s.touches.currentY > s.touches.startY && s.translate >= s.minTranslate()) {
            return;
          }
        } else {
          if (s.touches.currentX < s.touches.startX && s.translate <= s.maxTranslate() || s.touches.currentX > s.touches.startX && s.translate >= s.minTranslate()) {
            return;
          }
        }
      }

      if (isTouchEvent && document.activeElement) {
        if (e.target === document.activeElement && $(e.target).is(formElements)) {
          isMoved = true;
          s.allowClick = false;
          return;
        }
      }

      if (allowTouchCallbacks) {
        s.emit('onTouchMove', s, e);
      }

      if (e.targetTouches && e.targetTouches.length > 1) return;
      s.touches.currentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
      s.touches.currentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

      if (typeof isScrolling === 'undefined') {
        var touchAngle;

        if (s.isHorizontal() && s.touches.currentY === s.touches.startY || !s.isHorizontal() && s.touches.currentX === s.touches.startX) {
          isScrolling = false;
        } else {
          touchAngle = Math.atan2(Math.abs(s.touches.currentY - s.touches.startY), Math.abs(s.touches.currentX - s.touches.startX)) * 180 / Math.PI;
          isScrolling = s.isHorizontal() ? touchAngle > s.params.touchAngle : 90 - touchAngle > s.params.touchAngle;
        }
      }

      if (isScrolling) {
        s.emit('onTouchMoveOpposite', s, e);
      }

      if (typeof startMoving === 'undefined') {
        if (s.touches.currentX !== s.touches.startX || s.touches.currentY !== s.touches.startY) {
          startMoving = true;
        }
      }

      if (!isTouched) return;

      if (isScrolling) {
        isTouched = false;
        return;
      }

      if (!startMoving) {
        return;
      }

      s.allowClick = false;
      s.emit('onSliderMove', s, e);
      e.preventDefault();

      if (s.params.touchMoveStopPropagation && !s.params.nested) {
        e.stopPropagation();
      }

      if (!isMoved) {
        if (params.loop) {
          s.fixLoop();
        }

        startTranslate = s.getWrapperTranslate();
        s.setWrapperTransition(0);

        if (s.animating) {
          s.wrapper.trigger('webkitTransitionEnd transitionend oTransitionEnd MSTransitionEnd msTransitionEnd');
        }

        if (s.params.autoplay && s.autoplaying) {
          if (s.params.autoplayDisableOnInteraction) {
            s.stopAutoplay();
          } else {
            s.pauseAutoplay();
          }
        }

        allowMomentumBounce = false; //Grab Cursor

        if (s.params.grabCursor && (s.params.allowSwipeToNext === true || s.params.allowSwipeToPrev === true)) {
          s.setGrabCursor(true);
        }
      }

      isMoved = true;
      var diff = s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY - s.touches.startY;
      diff = diff * s.params.touchRatio;
      if (s.rtl) diff = -diff;
      s.swipeDirection = diff > 0 ? 'prev' : 'next';
      currentTranslate = diff + startTranslate;
      var disableParentSwiper = true;

      if (diff > 0 && currentTranslate > s.minTranslate()) {
        disableParentSwiper = false;
        if (s.params.resistance) currentTranslate = s.minTranslate() - 1 + Math.pow(-s.minTranslate() + startTranslate + diff, s.params.resistanceRatio);
      } else if (diff < 0 && currentTranslate < s.maxTranslate()) {
        disableParentSwiper = false;
        if (s.params.resistance) currentTranslate = s.maxTranslate() + 1 - Math.pow(s.maxTranslate() - startTranslate - diff, s.params.resistanceRatio);
      }

      if (disableParentSwiper) {
        e.preventedByNestedSwiper = true;
      } // Directions locks


      if (!s.params.allowSwipeToNext && s.swipeDirection === 'next' && currentTranslate < startTranslate) {
        currentTranslate = startTranslate;
      }

      if (!s.params.allowSwipeToPrev && s.swipeDirection === 'prev' && currentTranslate > startTranslate) {
        currentTranslate = startTranslate;
      } // Threshold


      if (s.params.threshold > 0) {
        if (Math.abs(diff) > s.params.threshold || allowThresholdMove) {
          if (!allowThresholdMove) {
            allowThresholdMove = true;
            s.touches.startX = s.touches.currentX;
            s.touches.startY = s.touches.currentY;
            currentTranslate = startTranslate;
            s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY - s.touches.startY;
            return;
          }
        } else {
          currentTranslate = startTranslate;
          return;
        }
      }

      if (!s.params.followFinger) return; // Update active index in free mode

      if (s.params.freeMode || s.params.watchSlidesProgress) {
        s.updateActiveIndex();
      }

      if (s.params.freeMode) {
        //Velocity
        if (velocities.length === 0) {
          velocities.push({
            position: s.touches[s.isHorizontal() ? 'startX' : 'startY'],
            time: touchStartTime
          });
        }

        velocities.push({
          position: s.touches[s.isHorizontal() ? 'currentX' : 'currentY'],
          time: new window.Date().getTime()
        });
      } // Update progress


      s.updateProgress(currentTranslate); // Update translate

      s.setWrapperTranslate(currentTranslate);
    };

    s.onTouchEnd = function (e) {
      if (e.originalEvent) e = e.originalEvent;

      if (allowTouchCallbacks) {
        s.emit('onTouchEnd', s, e);
      }

      allowTouchCallbacks = false;
      if (!isTouched) return; //Return Grab Cursor

      if (s.params.grabCursor && isMoved && isTouched && (s.params.allowSwipeToNext === true || s.params.allowSwipeToPrev === true)) {
        s.setGrabCursor(false);
      } // Time diff


      var touchEndTime = Date.now();
      var timeDiff = touchEndTime - touchStartTime; // Tap, doubleTap, Click

      if (s.allowClick) {
        s.updateClickedSlide(e);
        s.emit('onTap', s, e);

        if (timeDiff < 300 && touchEndTime - lastClickTime > 300) {
          if (clickTimeout) clearTimeout(clickTimeout);
          clickTimeout = setTimeout(function () {
            if (!s) return;

            if (s.params.paginationHide && s.paginationContainer.length > 0 && !$(e.target).hasClass(s.params.bulletClass)) {
              s.paginationContainer.toggleClass(s.params.paginationHiddenClass);
            }

            s.emit('onClick', s, e);
          }, 300);
        }

        if (timeDiff < 300 && touchEndTime - lastClickTime < 300) {
          if (clickTimeout) clearTimeout(clickTimeout);
          s.emit('onDoubleTap', s, e);
        }
      }

      lastClickTime = Date.now();
      setTimeout(function () {
        if (s) s.allowClick = true;
      }, 0);

      if (!isTouched || !isMoved || !s.swipeDirection || s.touches.diff === 0 || currentTranslate === startTranslate) {
        isTouched = isMoved = false;
        return;
      }

      isTouched = isMoved = false;
      var currentPos;

      if (s.params.followFinger) {
        currentPos = s.rtl ? s.translate : -s.translate;
      } else {
        currentPos = -currentTranslate;
      }

      if (s.params.freeMode) {
        if (currentPos < -s.minTranslate()) {
          s.slideTo(s.activeIndex);
          return;
        } else if (currentPos > -s.maxTranslate()) {
          if (s.slides.length < s.snapGrid.length) {
            s.slideTo(s.snapGrid.length - 1);
          } else {
            s.slideTo(s.slides.length - 1);
          }

          return;
        }

        if (s.params.freeModeMomentum) {
          if (velocities.length > 1) {
            var lastMoveEvent = velocities.pop(),
                velocityEvent = velocities.pop();
            var distance = lastMoveEvent.position - velocityEvent.position;
            var time = lastMoveEvent.time - velocityEvent.time;
            s.velocity = distance / time;
            s.velocity = s.velocity / 2;

            if (Math.abs(s.velocity) < s.params.freeModeMinimumVelocity) {
              s.velocity = 0;
            } // this implies that the user stopped moving a finger then released.
            // There would be no events with distance zero, so the last event is stale.


            if (time > 150 || new window.Date().getTime() - lastMoveEvent.time > 300) {
              s.velocity = 0;
            }
          } else {
            s.velocity = 0;
          }

          s.velocity = s.velocity * s.params.freeModeMomentumVelocityRatio;
          velocities.length = 0;
          var momentumDuration = 1000 * s.params.freeModeMomentumRatio;
          var momentumDistance = s.velocity * momentumDuration;
          var newPosition = s.translate + momentumDistance;
          if (s.rtl) newPosition = -newPosition;
          var doBounce = false;
          var afterBouncePosition;
          var bounceAmount = Math.abs(s.velocity) * 20 * s.params.freeModeMomentumBounceRatio;

          if (newPosition < s.maxTranslate()) {
            if (s.params.freeModeMomentumBounce) {
              if (newPosition + s.maxTranslate() < -bounceAmount) {
                newPosition = s.maxTranslate() - bounceAmount;
              }

              afterBouncePosition = s.maxTranslate();
              doBounce = true;
              allowMomentumBounce = true;
            } else {
              newPosition = s.maxTranslate();
            }
          } else if (newPosition > s.minTranslate()) {
            if (s.params.freeModeMomentumBounce) {
              if (newPosition - s.minTranslate() > bounceAmount) {
                newPosition = s.minTranslate() + bounceAmount;
              }

              afterBouncePosition = s.minTranslate();
              doBounce = true;
              allowMomentumBounce = true;
            } else {
              newPosition = s.minTranslate();
            }
          } else if (s.params.freeModeSticky) {
            var j = 0,
                nextSlide;

            for (j = 0; j < s.snapGrid.length; j += 1) {
              if (s.snapGrid[j] > -newPosition) {
                nextSlide = j;
                break;
              }
            }

            if (Math.abs(s.snapGrid[nextSlide] - newPosition) < Math.abs(s.snapGrid[nextSlide - 1] - newPosition) || s.swipeDirection === 'next') {
              newPosition = s.snapGrid[nextSlide];
            } else {
              newPosition = s.snapGrid[nextSlide - 1];
            }

            if (!s.rtl) newPosition = -newPosition;
          } //Fix duration


          if (s.velocity !== 0) {
            if (s.rtl) {
              momentumDuration = Math.abs((-newPosition - s.translate) / s.velocity);
            } else {
              momentumDuration = Math.abs((newPosition - s.translate) / s.velocity);
            }
          } else if (s.params.freeModeSticky) {
            s.slideReset();
            return;
          }

          if (s.params.freeModeMomentumBounce && doBounce) {
            s.updateProgress(afterBouncePosition);
            s.setWrapperTransition(momentumDuration);
            s.setWrapperTranslate(newPosition);
            s.onTransitionStart();
            s.animating = true;
            s.wrapper.transitionEnd(function () {
              if (!s || !allowMomentumBounce) return;
              s.emit('onMomentumBounce', s);
              s.setWrapperTransition(s.params.speed);
              s.setWrapperTranslate(afterBouncePosition);
              s.wrapper.transitionEnd(function () {
                if (!s) return;
                s.onTransitionEnd();
              });
            });
          } else if (s.velocity) {
            s.updateProgress(newPosition);
            s.setWrapperTransition(momentumDuration);
            s.setWrapperTranslate(newPosition);
            s.onTransitionStart();

            if (!s.animating) {
              s.animating = true;
              s.wrapper.transitionEnd(function () {
                if (!s) return;
                s.onTransitionEnd();
              });
            }
          } else {
            s.updateProgress(newPosition);
          }

          s.updateActiveIndex();
        }

        if (!s.params.freeModeMomentum || timeDiff >= s.params.longSwipesMs) {
          s.updateProgress();
          s.updateActiveIndex();
        }

        return;
      } // Find current slide


      var i,
          stopIndex = 0,
          groupSize = s.slidesSizesGrid[0];

      for (i = 0; i < s.slidesGrid.length; i += s.params.slidesPerGroup) {
        if (typeof s.slidesGrid[i + s.params.slidesPerGroup] !== 'undefined') {
          if (currentPos >= s.slidesGrid[i] && currentPos < s.slidesGrid[i + s.params.slidesPerGroup]) {
            stopIndex = i;
            groupSize = s.slidesGrid[i + s.params.slidesPerGroup] - s.slidesGrid[i];
          }
        } else {
          if (currentPos >= s.slidesGrid[i]) {
            stopIndex = i;
            groupSize = s.slidesGrid[s.slidesGrid.length - 1] - s.slidesGrid[s.slidesGrid.length - 2];
          }
        }
      } // Find current slide size


      var ratio = (currentPos - s.slidesGrid[stopIndex]) / groupSize;

      if (timeDiff > s.params.longSwipesMs) {
        // Long touches
        if (!s.params.longSwipes) {
          s.slideTo(s.activeIndex);
          return;
        }

        if (s.swipeDirection === 'next') {
          if (ratio >= s.params.longSwipesRatio) s.slideTo(stopIndex + s.params.slidesPerGroup);else s.slideTo(stopIndex);
        }

        if (s.swipeDirection === 'prev') {
          if (ratio > 1 - s.params.longSwipesRatio) s.slideTo(stopIndex + s.params.slidesPerGroup);else s.slideTo(stopIndex);
        }
      } else {
        // Short swipes
        if (!s.params.shortSwipes) {
          s.slideTo(s.activeIndex);
          return;
        }

        if (s.swipeDirection === 'next') {
          s.slideTo(stopIndex + s.params.slidesPerGroup);
        }

        if (s.swipeDirection === 'prev') {
          s.slideTo(stopIndex);
        }
      }
    };
    /*=========================
      Transitions
      ===========================*/


    s._slideTo = function (slideIndex, speed) {
      return s.slideTo(slideIndex, speed, true, true);
    };

    s.slideTo = function (slideIndex, speed, runCallbacks, internal) {
      if (typeof runCallbacks === 'undefined') runCallbacks = true;
      if (typeof slideIndex === 'undefined') slideIndex = 0;
      if (slideIndex < 0) slideIndex = 0;
      s.snapIndex = Math.floor(slideIndex / s.params.slidesPerGroup);
      if (s.snapIndex >= s.snapGrid.length) s.snapIndex = s.snapGrid.length - 1;
      var translate = -s.snapGrid[s.snapIndex]; // Stop autoplay

      if (s.params.autoplay && s.autoplaying) {
        if (internal || !s.params.autoplayDisableOnInteraction) {
          s.pauseAutoplay(speed);
        } else {
          s.stopAutoplay();
        }
      } // Update progress


      s.updateProgress(translate); // Normalize slideIndex

      if (s.params.normalizeSlideIndex) {
        for (var i = 0; i < s.slidesGrid.length; i++) {
          if (-Math.floor(translate * 100) >= Math.floor(s.slidesGrid[i] * 100)) {
            slideIndex = i;
          }
        }
      } // Directions locks


      if (!s.params.allowSwipeToNext && translate < s.translate && translate < s.minTranslate()) {
        return false;
      }

      if (!s.params.allowSwipeToPrev && translate > s.translate && translate > s.maxTranslate()) {
        if ((s.activeIndex || 0) !== slideIndex) return false;
      } // Update Index


      if (typeof speed === 'undefined') speed = s.params.speed;
      s.previousIndex = s.activeIndex || 0;
      s.activeIndex = slideIndex;
      s.updateRealIndex();

      if (s.rtl && -translate === s.translate || !s.rtl && translate === s.translate) {
        // Update Height
        if (s.params.autoHeight) {
          s.updateAutoHeight();
        }

        s.updateClasses();

        if (s.params.effect !== 'slide') {
          s.setWrapperTranslate(translate);
        }

        return false;
      }

      s.updateClasses();
      s.onTransitionStart(runCallbacks);

      if (speed === 0 || s.browser.lteIE9) {
        s.setWrapperTranslate(translate);
        s.setWrapperTransition(0);
        s.onTransitionEnd(runCallbacks);
      } else {
        s.setWrapperTranslate(translate);
        s.setWrapperTransition(speed);

        if (!s.animating) {
          s.animating = true;
          s.wrapper.transitionEnd(function () {
            if (!s) return;
            s.onTransitionEnd(runCallbacks);
          });
        }
      }

      return true;
    };

    s.onTransitionStart = function (runCallbacks) {
      if (typeof runCallbacks === 'undefined') runCallbacks = true;

      if (s.params.autoHeight) {
        s.updateAutoHeight();
      }

      if (s.lazy) s.lazy.onTransitionStart();

      if (runCallbacks) {
        s.emit('onTransitionStart', s);

        if (s.activeIndex !== s.previousIndex) {
          s.emit('onSlideChangeStart', s);

          if (s.activeIndex > s.previousIndex) {
            s.emit('onSlideNextStart', s);
          } else {
            s.emit('onSlidePrevStart', s);
          }
        }
      }
    };

    s.onTransitionEnd = function (runCallbacks) {
      s.animating = false;
      s.setWrapperTransition(0);
      if (typeof runCallbacks === 'undefined') runCallbacks = true;
      if (s.lazy) s.lazy.onTransitionEnd();

      if (runCallbacks) {
        s.emit('onTransitionEnd', s);

        if (s.activeIndex !== s.previousIndex) {
          s.emit('onSlideChangeEnd', s);

          if (s.activeIndex > s.previousIndex) {
            s.emit('onSlideNextEnd', s);
          } else {
            s.emit('onSlidePrevEnd', s);
          }
        }
      }

      if (s.params.history && s.history) {
        s.history.setHistory(s.params.history, s.activeIndex);
      }

      if (s.params.hashnav && s.hashnav) {
        s.hashnav.setHash();
      }
    };

    s.slideNext = function (runCallbacks, speed, internal) {
      if (s.params.loop) {
        if (s.animating) return false;
        s.fixLoop();
        var clientLeft = s.container[0].clientLeft;
        return s.slideTo(s.activeIndex + s.params.slidesPerGroup, speed, runCallbacks, internal);
      } else return s.slideTo(s.activeIndex + s.params.slidesPerGroup, speed, runCallbacks, internal);
    };

    s._slideNext = function (speed) {
      return s.slideNext(true, speed, true);
    };

    s.slidePrev = function (runCallbacks, speed, internal) {
      if (s.params.loop) {
        if (s.animating) return false;
        s.fixLoop();
        var clientLeft = s.container[0].clientLeft;
        return s.slideTo(s.activeIndex - 1, speed, runCallbacks, internal);
      } else return s.slideTo(s.activeIndex - 1, speed, runCallbacks, internal);
    };

    s._slidePrev = function (speed) {
      return s.slidePrev(true, speed, true);
    };

    s.slideReset = function (runCallbacks, speed, internal) {
      return s.slideTo(s.activeIndex, speed, runCallbacks);
    };

    s.disableTouchControl = function () {
      s.params.onlyExternal = true;
      return true;
    };

    s.enableTouchControl = function () {
      s.params.onlyExternal = false;
      return true;
    };
    /*=========================
      Translate/transition helpers
      ===========================*/


    s.setWrapperTransition = function (duration, byController) {
      s.wrapper.transition(duration);

      if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
        s.effects[s.params.effect].setTransition(duration);
      }

      if (s.params.parallax && s.parallax) {
        s.parallax.setTransition(duration);
      }

      if (s.params.scrollbar && s.scrollbar) {
        s.scrollbar.setTransition(duration);
      }

      if (s.params.control && s.controller) {
        s.controller.setTransition(duration, byController);
      }

      s.emit('onSetTransition', s, duration);
    };

    s.setWrapperTranslate = function (translate, updateActiveIndex, byController) {
      var x = 0,
          y = 0,
          z = 0;

      if (s.isHorizontal()) {
        x = s.rtl ? -translate : translate;
      } else {
        y = translate;
      }

      if (s.params.roundLengths) {
        x = round(x);
        y = round(y);
      }

      if (!s.params.virtualTranslate) {
        if (s.support.transforms3d) s.wrapper.transform('translate3d(' + x + 'px, ' + y + 'px, ' + z + 'px)');else s.wrapper.transform('translate(' + x + 'px, ' + y + 'px)');
      }

      s.translate = s.isHorizontal() ? x : y; // Check if we need to update progress

      var progress;
      var translatesDiff = s.maxTranslate() - s.minTranslate();

      if (translatesDiff === 0) {
        progress = 0;
      } else {
        progress = (translate - s.minTranslate()) / translatesDiff;
      }

      if (progress !== s.progress) {
        s.updateProgress(translate);
      }

      if (updateActiveIndex) s.updateActiveIndex();

      if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
        s.effects[s.params.effect].setTranslate(s.translate);
      }

      if (s.params.parallax && s.parallax) {
        s.parallax.setTranslate(s.translate);
      }

      if (s.params.scrollbar && s.scrollbar) {
        s.scrollbar.setTranslate(s.translate);
      }

      if (s.params.control && s.controller) {
        s.controller.setTranslate(s.translate, byController);
      }

      s.emit('onSetTranslate', s, s.translate);
    };

    s.getTranslate = function (el, axis) {
      var matrix, curTransform, curStyle, transformMatrix; // automatic axis detection

      if (typeof axis === 'undefined') {
        axis = 'x';
      }

      if (s.params.virtualTranslate) {
        return s.rtl ? -s.translate : s.translate;
      }

      curStyle = window.getComputedStyle(el, null);

      if (window.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;

        if (curTransform.split(',').length > 6) {
          curTransform = curTransform.split(', ').map(function (a) {
            return a.replace(',', '.');
          }).join(', ');
        } // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case


        transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
      } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
      }

      if (axis === 'x') {
        //Latest Chrome and webkits Fix
        if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; //Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); //Normal Browsers
        else curTransform = parseFloat(matrix[4]);
      }

      if (axis === 'y') {
        //Latest Chrome and webkits Fix
        if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; //Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); //Normal Browsers
        else curTransform = parseFloat(matrix[5]);
      }

      if (s.rtl && curTransform) curTransform = -curTransform;
      return curTransform || 0;
    };

    s.getWrapperTranslate = function (axis) {
      if (typeof axis === 'undefined') {
        axis = s.isHorizontal() ? 'x' : 'y';
      }

      return s.getTranslate(s.wrapper[0], axis);
    };
    /*=========================
      Observer
      ===========================*/


    s.observers = [];

    function initObserver(target, options) {
      options = options || {}; // create an observer instance

      var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
      var observer = new ObserverFunc(function (mutations) {
        mutations.forEach(function (mutation) {
          s.onResize(true);
          s.emit('onObserverUpdate', s, mutation);
        });
      });
      observer.observe(target, {
        attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
        childList: typeof options.childList === 'undefined' ? true : options.childList,
        characterData: typeof options.characterData === 'undefined' ? true : options.characterData
      });
      s.observers.push(observer);
    }

    s.initObservers = function () {
      if (s.params.observeParents) {
        var containerParents = s.container.parents();

        for (var i = 0; i < containerParents.length; i++) {
          initObserver(containerParents[i]);
        }
      } // Observe container


      initObserver(s.container[0], {
        childList: false
      }); // Observe wrapper

      initObserver(s.wrapper[0], {
        attributes: false
      });
    };

    s.disconnectObservers = function () {
      for (var i = 0; i < s.observers.length; i++) {
        s.observers[i].disconnect();
      }

      s.observers = [];
    };
    /*=========================
      Loop
      ===========================*/
    // Create looped slides


    s.createLoop = function () {
      // Remove duplicated slides
      s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass).remove();
      var slides = s.wrapper.children('.' + s.params.slideClass);
      if (s.params.slidesPerView === 'auto' && !s.params.loopedSlides) s.params.loopedSlides = slides.length;
      s.loopedSlides = parseInt(s.params.loopedSlides || s.params.slidesPerView, 10);
      s.loopedSlides = s.loopedSlides + s.params.loopAdditionalSlides;

      if (s.loopedSlides > slides.length) {
        s.loopedSlides = slides.length;
      }

      var prependSlides = [],
          appendSlides = [],
          i;
      slides.each(function (index, el) {
        var slide = $(this);
        if (index < s.loopedSlides) appendSlides.push(el);
        if (index < slides.length && index >= slides.length - s.loopedSlides) prependSlides.push(el);
        slide.attr('data-swiper-slide-index', index);
      });

      for (i = 0; i < appendSlides.length; i++) {
        s.wrapper.append($(appendSlides[i].cloneNode(true)).addClass(s.params.slideDuplicateClass));
      }

      for (i = prependSlides.length - 1; i >= 0; i--) {
        s.wrapper.prepend($(prependSlides[i].cloneNode(true)).addClass(s.params.slideDuplicateClass));
      }
    };

    s.destroyLoop = function () {
      s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass).remove();
      s.slides.removeAttr('data-swiper-slide-index');
    };

    s.reLoop = function (updatePosition) {
      var oldIndex = s.activeIndex - s.loopedSlides;
      s.destroyLoop();
      s.createLoop();
      s.updateSlidesSize();

      if (updatePosition) {
        s.slideTo(oldIndex + s.loopedSlides, 0, false);
      }
    };

    s.fixLoop = function () {
      var newIndex; //Fix For Negative Oversliding

      if (s.activeIndex < s.loopedSlides) {
        newIndex = s.slides.length - s.loopedSlides * 3 + s.activeIndex;
        newIndex = newIndex + s.loopedSlides;
        s.slideTo(newIndex, 0, false, true);
      } //Fix For Positive Oversliding
      else if (s.params.slidesPerView === 'auto' && s.activeIndex >= s.loopedSlides * 2 || s.activeIndex > s.slides.length - s.params.slidesPerView * 2) {
        newIndex = -s.slides.length + s.activeIndex + s.loopedSlides;
        newIndex = newIndex + s.loopedSlides;
        s.slideTo(newIndex, 0, false, true);
      }
    };
    /*=========================
      Append/Prepend/Remove Slides
      ===========================*/


    s.appendSlide = function (slides) {
      if (s.params.loop) {
        s.destroyLoop();
      }

      if (_typeof(slides) === 'object' && slides.length) {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i]) s.wrapper.append(slides[i]);
        }
      } else {
        s.wrapper.append(slides);
      }

      if (s.params.loop) {
        s.createLoop();
      }

      if (!(s.params.observer && s.support.observer)) {
        s.update(true);
      }
    };

    s.prependSlide = function (slides) {
      if (s.params.loop) {
        s.destroyLoop();
      }

      var newActiveIndex = s.activeIndex + 1;

      if (_typeof(slides) === 'object' && slides.length) {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i]) s.wrapper.prepend(slides[i]);
        }

        newActiveIndex = s.activeIndex + slides.length;
      } else {
        s.wrapper.prepend(slides);
      }

      if (s.params.loop) {
        s.createLoop();
      }

      if (!(s.params.observer && s.support.observer)) {
        s.update(true);
      }

      s.slideTo(newActiveIndex, 0, false);
    };

    s.removeSlide = function (slidesIndexes) {
      if (s.params.loop) {
        s.destroyLoop();
        s.slides = s.wrapper.children('.' + s.params.slideClass);
      }

      var newActiveIndex = s.activeIndex,
          indexToRemove;

      if (_typeof(slidesIndexes) === 'object' && slidesIndexes.length) {
        for (var i = 0; i < slidesIndexes.length; i++) {
          indexToRemove = slidesIndexes[i];
          if (s.slides[indexToRemove]) s.slides.eq(indexToRemove).remove();
          if (indexToRemove < newActiveIndex) newActiveIndex--;
        }

        newActiveIndex = Math.max(newActiveIndex, 0);
      } else {
        indexToRemove = slidesIndexes;
        if (s.slides[indexToRemove]) s.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex--;
        newActiveIndex = Math.max(newActiveIndex, 0);
      }

      if (s.params.loop) {
        s.createLoop();
      }

      if (!(s.params.observer && s.support.observer)) {
        s.update(true);
      }

      if (s.params.loop) {
        s.slideTo(newActiveIndex + s.loopedSlides, 0, false);
      } else {
        s.slideTo(newActiveIndex, 0, false);
      }
    };

    s.removeAllSlides = function () {
      var slidesIndexes = [];

      for (var i = 0; i < s.slides.length; i++) {
        slidesIndexes.push(i);
      }

      s.removeSlide(slidesIndexes);
    };
    /*=========================
      Effects
      ===========================*/


    s.effects = {
      fade: {
        setTranslate: function setTranslate() {
          for (var i = 0; i < s.slides.length; i++) {
            var slide = s.slides.eq(i);
            var offset = slide[0].swiperSlideOffset;
            var tx = -offset;
            if (!s.params.virtualTranslate) tx = tx - s.translate;
            var ty = 0;

            if (!s.isHorizontal()) {
              ty = tx;
              tx = 0;
            }

            var slideOpacity = s.params.fade.crossFade ? Math.max(1 - Math.abs(slide[0].progress), 0) : 1 + Math.min(Math.max(slide[0].progress, -1), 0);
            slide.css({
              opacity: slideOpacity
            }).transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px)');
          }
        },
        setTransition: function setTransition(duration) {
          s.slides.transition(duration);

          if (s.params.virtualTranslate && duration !== 0) {
            var eventTriggered = false;
            s.slides.transitionEnd(function () {
              if (eventTriggered) return;
              if (!s) return;
              eventTriggered = true;
              s.animating = false;
              var triggerEvents = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'];

              for (var i = 0; i < triggerEvents.length; i++) {
                s.wrapper.trigger(triggerEvents[i]);
              }
            });
          }
        }
      },
      flip: {
        setTranslate: function setTranslate() {
          for (var i = 0; i < s.slides.length; i++) {
            var slide = s.slides.eq(i);
            var progress = slide[0].progress;

            if (s.params.flip.limitRotation) {
              progress = Math.max(Math.min(slide[0].progress, 1), -1);
            }

            var offset = slide[0].swiperSlideOffset;
            var rotate = -180 * progress,
                rotateY = rotate,
                rotateX = 0,
                tx = -offset,
                ty = 0;

            if (!s.isHorizontal()) {
              ty = tx;
              tx = 0;
              rotateX = -rotateY;
              rotateY = 0;
            } else if (s.rtl) {
              rotateY = -rotateY;
            }

            slide[0].style.zIndex = -Math.abs(Math.round(progress)) + s.slides.length;

            if (s.params.flip.slideShadows) {
              //Set shadows
              var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
              var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');

              if (shadowBefore.length === 0) {
                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
                slide.append(shadowBefore);
              }

              if (shadowAfter.length === 0) {
                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
                slide.append(shadowAfter);
              }

              if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
              if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
            }

            slide.transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)');
          }
        },
        setTransition: function setTransition(duration) {
          s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);

          if (s.params.virtualTranslate && duration !== 0) {
            var eventTriggered = false;
            s.slides.eq(s.activeIndex).transitionEnd(function () {
              if (eventTriggered) return;
              if (!s) return;
              if (!$(this).hasClass(s.params.slideActiveClass)) return;
              eventTriggered = true;
              s.animating = false;
              var triggerEvents = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'];

              for (var i = 0; i < triggerEvents.length; i++) {
                s.wrapper.trigger(triggerEvents[i]);
              }
            });
          }
        }
      },
      cube: {
        setTranslate: function setTranslate() {
          var wrapperRotate = 0,
              cubeShadow;

          if (s.params.cube.shadow) {
            if (s.isHorizontal()) {
              cubeShadow = s.wrapper.find('.swiper-cube-shadow');

              if (cubeShadow.length === 0) {
                cubeShadow = $('<div class="swiper-cube-shadow"></div>');
                s.wrapper.append(cubeShadow);
              }

              cubeShadow.css({
                height: s.width + 'px'
              });
            } else {
              cubeShadow = s.container.find('.swiper-cube-shadow');

              if (cubeShadow.length === 0) {
                cubeShadow = $('<div class="swiper-cube-shadow"></div>');
                s.container.append(cubeShadow);
              }
            }
          }

          for (var i = 0; i < s.slides.length; i++) {
            var slide = s.slides.eq(i);
            var slideAngle = i * 90;
            var round = Math.floor(slideAngle / 360);

            if (s.rtl) {
              slideAngle = -slideAngle;
              round = Math.floor(-slideAngle / 360);
            }

            var progress = Math.max(Math.min(slide[0].progress, 1), -1);
            var tx = 0,
                ty = 0,
                tz = 0;

            if (i % 4 === 0) {
              tx = -round * 4 * s.size;
              tz = 0;
            } else if ((i - 1) % 4 === 0) {
              tx = 0;
              tz = -round * 4 * s.size;
            } else if ((i - 2) % 4 === 0) {
              tx = s.size + round * 4 * s.size;
              tz = s.size;
            } else if ((i - 3) % 4 === 0) {
              tx = -s.size;
              tz = 3 * s.size + s.size * 4 * round;
            }

            if (s.rtl) {
              tx = -tx;
            }

            if (!s.isHorizontal()) {
              ty = tx;
              tx = 0;
            }

            var transform = 'rotateX(' + (s.isHorizontal() ? 0 : -slideAngle) + 'deg) rotateY(' + (s.isHorizontal() ? slideAngle : 0) + 'deg) translate3d(' + tx + 'px, ' + ty + 'px, ' + tz + 'px)';

            if (progress <= 1 && progress > -1) {
              wrapperRotate = i * 90 + progress * 90;
              if (s.rtl) wrapperRotate = -i * 90 - progress * 90;
            }

            slide.transform(transform);

            if (s.params.cube.slideShadows) {
              //Set shadows
              var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
              var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');

              if (shadowBefore.length === 0) {
                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
                slide.append(shadowBefore);
              }

              if (shadowAfter.length === 0) {
                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
                slide.append(shadowAfter);
              }

              if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
              if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
            }
          }

          s.wrapper.css({
            '-webkit-transform-origin': '50% 50% -' + s.size / 2 + 'px',
            '-moz-transform-origin': '50% 50% -' + s.size / 2 + 'px',
            '-ms-transform-origin': '50% 50% -' + s.size / 2 + 'px',
            'transform-origin': '50% 50% -' + s.size / 2 + 'px'
          });

          if (s.params.cube.shadow) {
            if (s.isHorizontal()) {
              cubeShadow.transform('translate3d(0px, ' + (s.width / 2 + s.params.cube.shadowOffset) + 'px, ' + -s.width / 2 + 'px) rotateX(90deg) rotateZ(0deg) scale(' + s.params.cube.shadowScale + ')');
            } else {
              var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
              var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
              var scale1 = s.params.cube.shadowScale,
                  scale2 = s.params.cube.shadowScale / multiplier,
                  offset = s.params.cube.shadowOffset;
              cubeShadow.transform('scale3d(' + scale1 + ', 1, ' + scale2 + ') translate3d(0px, ' + (s.height / 2 + offset) + 'px, ' + -s.height / 2 / scale2 + 'px) rotateX(-90deg)');
            }
          }

          var zFactor = s.isSafari || s.isUiWebView ? -s.size / 2 : 0;
          s.wrapper.transform('translate3d(0px,0,' + zFactor + 'px) rotateX(' + (s.isHorizontal() ? 0 : wrapperRotate) + 'deg) rotateY(' + (s.isHorizontal() ? -wrapperRotate : 0) + 'deg)');
        },
        setTransition: function setTransition(duration) {
          s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);

          if (s.params.cube.shadow && !s.isHorizontal()) {
            s.container.find('.swiper-cube-shadow').transition(duration);
          }
        }
      },
      coverflow: {
        setTranslate: function setTranslate() {
          var transform = s.translate;
          var center = s.isHorizontal() ? -transform + s.width / 2 : -transform + s.height / 2;
          var rotate = s.isHorizontal() ? s.params.coverflow.rotate : -s.params.coverflow.rotate;
          var translate = s.params.coverflow.depth; //Each slide offset from center

          for (var i = 0, length = s.slides.length; i < length; i++) {
            var slide = s.slides.eq(i);
            var slideSize = s.slidesSizesGrid[i];
            var slideOffset = slide[0].swiperSlideOffset;
            var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * s.params.coverflow.modifier;
            var rotateY = s.isHorizontal() ? rotate * offsetMultiplier : 0;
            var rotateX = s.isHorizontal() ? 0 : rotate * offsetMultiplier; // var rotateZ = 0

            var translateZ = -translate * Math.abs(offsetMultiplier);
            var translateY = s.isHorizontal() ? 0 : s.params.coverflow.stretch * offsetMultiplier;
            var translateX = s.isHorizontal() ? s.params.coverflow.stretch * offsetMultiplier : 0; //Fix for ultra small values

            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            var slideTransform = 'translate3d(' + translateX + 'px,' + translateY + 'px,' + translateZ + 'px)  rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
            slide.transform(slideTransform);
            slide[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;

            if (s.params.coverflow.slideShadows) {
              //Set shadows
              var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
              var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');

              if (shadowBefore.length === 0) {
                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
                slide.append(shadowBefore);
              }

              if (shadowAfter.length === 0) {
                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
                slide.append(shadowAfter);
              }

              if (shadowBefore.length) shadowBefore[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
              if (shadowAfter.length) shadowAfter[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
          } //Set correct perspective for IE10


          if (s.browser.ie) {
            var ws = s.wrapper[0].style;
            ws.perspectiveOrigin = center + 'px 50%';
          }
        },
        setTransition: function setTransition(duration) {
          s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
        }
      }
    };
    /*=========================
      Images Lazy Loading
      ===========================*/

    s.lazy = {
      initialImageLoaded: false,
      loadImageInSlide: function loadImageInSlide(index, loadInDuplicate) {
        if (typeof index === 'undefined') return;
        if (typeof loadInDuplicate === 'undefined') loadInDuplicate = true;
        if (s.slides.length === 0) return;
        var slide = s.slides.eq(index);
        var img = slide.find('.' + s.params.lazyLoadingClass + ':not(.' + s.params.lazyStatusLoadedClass + '):not(.' + s.params.lazyStatusLoadingClass + ')');

        if (slide.hasClass(s.params.lazyLoadingClass) && !slide.hasClass(s.params.lazyStatusLoadedClass) && !slide.hasClass(s.params.lazyStatusLoadingClass)) {
          img = img.add(slide[0]);
        }

        if (img.length === 0) return;
        img.each(function () {
          var _img = $(this);

          _img.addClass(s.params.lazyStatusLoadingClass);

          var background = _img.attr('data-background');

          var src = _img.attr('data-src'),
              srcset = _img.attr('data-srcset'),
              sizes = _img.attr('data-sizes');

          s.loadImage(_img[0], src || background, srcset, sizes, false, function () {
            if (typeof s === 'undefined' || s === null || !s) return;

            if (background) {
              _img.css('background-image', 'url("' + background + '")');

              _img.removeAttr('data-background');
            } else {
              if (srcset) {
                _img.attr('srcset', srcset);

                _img.removeAttr('data-srcset');
              }

              if (sizes) {
                _img.attr('sizes', sizes);

                _img.removeAttr('data-sizes');
              }

              if (src) {
                _img.attr('src', src);

                _img.removeAttr('data-src');
              }
            }

            _img.addClass(s.params.lazyStatusLoadedClass).removeClass(s.params.lazyStatusLoadingClass);

            slide.find('.' + s.params.lazyPreloaderClass + ', .' + s.params.preloaderClass).remove();

            if (s.params.loop && loadInDuplicate) {
              var slideOriginalIndex = slide.attr('data-swiper-slide-index');

              if (slide.hasClass(s.params.slideDuplicateClass)) {
                var originalSlide = s.wrapper.children('[data-swiper-slide-index="' + slideOriginalIndex + '"]:not(.' + s.params.slideDuplicateClass + ')');
                s.lazy.loadImageInSlide(originalSlide.index(), false);
              } else {
                var duplicatedSlide = s.wrapper.children('.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + slideOriginalIndex + '"]');
                s.lazy.loadImageInSlide(duplicatedSlide.index(), false);
              }
            }

            s.emit('onLazyImageReady', s, slide[0], _img[0]);
          });
          s.emit('onLazyImageLoad', s, slide[0], _img[0]);
        });
      },
      load: function load() {
        var i;
        var slidesPerView = s.params.slidesPerView;

        if (slidesPerView === 'auto') {
          slidesPerView = 0;
        }

        if (!s.lazy.initialImageLoaded) s.lazy.initialImageLoaded = true;

        if (s.params.watchSlidesVisibility) {
          s.wrapper.children('.' + s.params.slideVisibleClass).each(function () {
            s.lazy.loadImageInSlide($(this).index());
          });
        } else {
          if (slidesPerView > 1) {
            for (i = s.activeIndex; i < s.activeIndex + slidesPerView; i++) {
              if (s.slides[i]) s.lazy.loadImageInSlide(i);
            }
          } else {
            s.lazy.loadImageInSlide(s.activeIndex);
          }
        }

        if (s.params.lazyLoadingInPrevNext) {
          if (slidesPerView > 1 || s.params.lazyLoadingInPrevNextAmount && s.params.lazyLoadingInPrevNextAmount > 1) {
            var amount = s.params.lazyLoadingInPrevNextAmount;
            var spv = slidesPerView;
            var maxIndex = Math.min(s.activeIndex + spv + Math.max(amount, spv), s.slides.length);
            var minIndex = Math.max(s.activeIndex - Math.max(spv, amount), 0); // Next Slides

            for (i = s.activeIndex + slidesPerView; i < maxIndex; i++) {
              if (s.slides[i]) s.lazy.loadImageInSlide(i);
            } // Prev Slides


            for (i = minIndex; i < s.activeIndex; i++) {
              if (s.slides[i]) s.lazy.loadImageInSlide(i);
            }
          } else {
            var nextSlide = s.wrapper.children('.' + s.params.slideNextClass);
            if (nextSlide.length > 0) s.lazy.loadImageInSlide(nextSlide.index());
            var prevSlide = s.wrapper.children('.' + s.params.slidePrevClass);
            if (prevSlide.length > 0) s.lazy.loadImageInSlide(prevSlide.index());
          }
        }
      },
      onTransitionStart: function onTransitionStart() {
        if (s.params.lazyLoading) {
          if (s.params.lazyLoadingOnTransitionStart || !s.params.lazyLoadingOnTransitionStart && !s.lazy.initialImageLoaded) {
            s.lazy.load();
          }
        }
      },
      onTransitionEnd: function onTransitionEnd() {
        if (s.params.lazyLoading && !s.params.lazyLoadingOnTransitionStart) {
          s.lazy.load();
        }
      }
    };
    /*=========================
      Scrollbar
      ===========================*/

    s.scrollbar = {
      isTouched: false,
      setDragPosition: function setDragPosition(e) {
        var sb = s.scrollbar;
        var x = 0,
            y = 0;
        var translate;
        var pointerPosition = s.isHorizontal() ? e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX || e.clientX : e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY || e.clientY;
        var position = pointerPosition - sb.track.offset()[s.isHorizontal() ? 'left' : 'top'] - sb.dragSize / 2;
        var positionMin = -s.minTranslate() * sb.moveDivider;
        var positionMax = -s.maxTranslate() * sb.moveDivider;

        if (position < positionMin) {
          position = positionMin;
        } else if (position > positionMax) {
          position = positionMax;
        }

        position = -position / sb.moveDivider;
        s.updateProgress(position);
        s.setWrapperTranslate(position, true);
      },
      dragStart: function dragStart(e) {
        var sb = s.scrollbar;
        sb.isTouched = true;
        e.preventDefault();
        e.stopPropagation();
        sb.setDragPosition(e);
        clearTimeout(sb.dragTimeout);
        sb.track.transition(0);

        if (s.params.scrollbarHide) {
          sb.track.css('opacity', 1);
        }

        s.wrapper.transition(100);
        sb.drag.transition(100);
        s.emit('onScrollbarDragStart', s);
      },
      dragMove: function dragMove(e) {
        var sb = s.scrollbar;
        if (!sb.isTouched) return;
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
        sb.setDragPosition(e);
        s.wrapper.transition(0);
        sb.track.transition(0);
        sb.drag.transition(0);
        s.emit('onScrollbarDragMove', s);
      },
      dragEnd: function dragEnd(e) {
        var sb = s.scrollbar;
        if (!sb.isTouched) return;
        sb.isTouched = false;

        if (s.params.scrollbarHide) {
          clearTimeout(sb.dragTimeout);
          sb.dragTimeout = setTimeout(function () {
            sb.track.css('opacity', 0);
            sb.track.transition(400);
          }, 1000);
        }

        s.emit('onScrollbarDragEnd', s);

        if (s.params.scrollbarSnapOnRelease) {
          s.slideReset();
        }
      },
      draggableEvents: function () {
        if (s.params.simulateTouch === false && !s.support.touch) return s.touchEventsDesktop;else return s.touchEvents;
      }(),
      enableDraggable: function enableDraggable() {
        var sb = s.scrollbar;
        var target = s.support.touch ? sb.track : document;
        $(sb.track).on(sb.draggableEvents.start, sb.dragStart);
        $(target).on(sb.draggableEvents.move, sb.dragMove);
        $(target).on(sb.draggableEvents.end, sb.dragEnd);
      },
      disableDraggable: function disableDraggable() {
        var sb = s.scrollbar;
        var target = s.support.touch ? sb.track : document;
        $(sb.track).off(sb.draggableEvents.start, sb.dragStart);
        $(target).off(sb.draggableEvents.move, sb.dragMove);
        $(target).off(sb.draggableEvents.end, sb.dragEnd);
      },
      set: function set() {
        if (!s.params.scrollbar) return;
        var sb = s.scrollbar;
        sb.track = $(s.params.scrollbar);

        if (s.params.uniqueNavElements && typeof s.params.scrollbar === 'string' && sb.track.length > 1 && s.container.find(s.params.scrollbar).length === 1) {
          sb.track = s.container.find(s.params.scrollbar);
        }

        sb.drag = sb.track.find('.swiper-scrollbar-drag');

        if (sb.drag.length === 0) {
          sb.drag = $('<div class="swiper-scrollbar-drag"></div>');
          sb.track.append(sb.drag);
        }

        sb.drag[0].style.width = '';
        sb.drag[0].style.height = '';
        sb.trackSize = s.isHorizontal() ? sb.track[0].offsetWidth : sb.track[0].offsetHeight;
        sb.divider = s.size / s.virtualSize;
        sb.moveDivider = sb.divider * (sb.trackSize / s.size);
        sb.dragSize = sb.trackSize * sb.divider;

        if (s.isHorizontal()) {
          sb.drag[0].style.width = sb.dragSize + 'px';
        } else {
          sb.drag[0].style.height = sb.dragSize + 'px';
        }

        if (sb.divider >= 1) {
          sb.track[0].style.display = 'none';
        } else {
          sb.track[0].style.display = '';
        }

        if (s.params.scrollbarHide) {
          sb.track[0].style.opacity = 0;
        }
      },
      setTranslate: function setTranslate() {
        if (!s.params.scrollbar) return;
        var diff;
        var sb = s.scrollbar;
        var translate = s.translate || 0;
        var newPos;
        var newSize = sb.dragSize;
        newPos = (sb.trackSize - sb.dragSize) * s.progress;

        if (s.rtl && s.isHorizontal()) {
          newPos = -newPos;

          if (newPos > 0) {
            newSize = sb.dragSize - newPos;
            newPos = 0;
          } else if (-newPos + sb.dragSize > sb.trackSize) {
            newSize = sb.trackSize + newPos;
          }
        } else {
          if (newPos < 0) {
            newSize = sb.dragSize + newPos;
            newPos = 0;
          } else if (newPos + sb.dragSize > sb.trackSize) {
            newSize = sb.trackSize - newPos;
          }
        }

        if (s.isHorizontal()) {
          if (s.support.transforms3d) {
            sb.drag.transform('translate3d(' + newPos + 'px, 0, 0)');
          } else {
            sb.drag.transform('translateX(' + newPos + 'px)');
          }

          sb.drag[0].style.width = newSize + 'px';
        } else {
          if (s.support.transforms3d) {
            sb.drag.transform('translate3d(0px, ' + newPos + 'px, 0)');
          } else {
            sb.drag.transform('translateY(' + newPos + 'px)');
          }

          sb.drag[0].style.height = newSize + 'px';
        }

        if (s.params.scrollbarHide) {
          clearTimeout(sb.timeout);
          sb.track[0].style.opacity = 1;
          sb.timeout = setTimeout(function () {
            sb.track[0].style.opacity = 0;
            sb.track.transition(400);
          }, 1000);
        }
      },
      setTransition: function setTransition(duration) {
        if (!s.params.scrollbar) return;
        s.scrollbar.drag.transition(duration);
      }
    };
    /*=========================
      Controller
      ===========================*/

    s.controller = {
      LinearSpline: function LinearSpline(x, y) {
        var binarySearch = function () {
          var maxIndex, minIndex, guess;
          return function (array, val) {
            minIndex = -1;
            maxIndex = array.length;

            while (maxIndex - minIndex > 1) {
              if (array[guess = maxIndex + minIndex >> 1] <= val) {
                minIndex = guess;
              } else {
                maxIndex = guess;
              }
            }

            return maxIndex;
          };
        }();

        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.

        var i1, i3;
        var l = this.x.length;

        this.interpolate = function (x2) {
          if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):

          i3 = binarySearch(this.x, x2);
          i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
          // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1

          return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
      },
      //xxx: for now i will just save one spline function to to
      getInterpolateFunction: function getInterpolateFunction(c) {
        if (!s.controller.spline) s.controller.spline = s.params.loop ? new s.controller.LinearSpline(s.slidesGrid, c.slidesGrid) : new s.controller.LinearSpline(s.snapGrid, c.snapGrid);
      },
      setTranslate: function setTranslate(translate, byController) {
        var controlled = s.params.control;
        var multiplier, controlledTranslate;

        function setControlledTranslate(c) {
          // this will create an Interpolate function based on the snapGrids
          // x is the Grid of the scrolled scroller and y will be the controlled scroller
          // it makes sense to create this only once and recall it for the interpolation
          // the function does a lot of value caching for performance
          translate = c.rtl && c.params.direction === 'horizontal' ? -s.translate : s.translate;

          if (s.params.controlBy === 'slide') {
            s.controller.getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
            // but it did not work out

            controlledTranslate = -s.controller.spline.interpolate(-translate);
          }

          if (!controlledTranslate || s.params.controlBy === 'container') {
            multiplier = (c.maxTranslate() - c.minTranslate()) / (s.maxTranslate() - s.minTranslate());
            controlledTranslate = (translate - s.minTranslate()) * multiplier + c.minTranslate();
          }

          if (s.params.controlInverse) {
            controlledTranslate = c.maxTranslate() - controlledTranslate;
          }

          c.updateProgress(controlledTranslate);
          c.setWrapperTranslate(controlledTranslate, false, s);
          c.updateActiveIndex();
        }

        if (Array.isArray(controlled)) {
          for (var i = 0; i < controlled.length; i++) {
            if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
              setControlledTranslate(controlled[i]);
            }
          }
        } else if (controlled instanceof Swiper && byController !== controlled) {
          setControlledTranslate(controlled);
        }
      },
      setTransition: function setTransition(duration, byController) {
        var controlled = s.params.control;
        var i;

        function setControlledTransition(c) {
          c.setWrapperTransition(duration, s);

          if (duration !== 0) {
            c.onTransitionStart();
            c.wrapper.transitionEnd(function () {
              if (!controlled) return;

              if (c.params.loop && s.params.controlBy === 'slide') {
                c.fixLoop();
              }

              c.onTransitionEnd();
            });
          }
        }

        if (Array.isArray(controlled)) {
          for (i = 0; i < controlled.length; i++) {
            if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
              setControlledTransition(controlled[i]);
            }
          }
        } else if (controlled instanceof Swiper && byController !== controlled) {
          setControlledTransition(controlled);
        }
      }
    };
    /*=========================
      Hash Navigation
      ===========================*/

    s.hashnav = {
      onHashCange: function onHashCange(e, a) {
        var newHash = document.location.hash.replace('#', '');
        var activeSlideHash = s.slides.eq(s.activeIndex).attr('data-hash');

        if (newHash !== activeSlideHash) {
          s.slideTo(s.wrapper.children('.' + s.params.slideClass + '[data-hash="' + newHash + '"]').index());
        }
      },
      attachEvents: function attachEvents(detach) {
        var action = detach ? 'off' : 'on';
        $(window)[action]('hashchange', s.hashnav.onHashCange);
      },
      setHash: function setHash() {
        if (!s.hashnav.initialized || !s.params.hashnav) return;

        if (s.params.replaceState && window.history && window.history.replaceState) {
          window.history.replaceState(null, null, '#' + s.slides.eq(s.activeIndex).attr('data-hash') || '');
        } else {
          var slide = s.slides.eq(s.activeIndex);
          var hash = slide.attr('data-hash') || slide.attr('data-history');
          document.location.hash = hash || '';
        }
      },
      init: function init() {
        if (!s.params.hashnav || s.params.history) return;
        s.hashnav.initialized = true;
        var hash = document.location.hash.replace('#', '');

        if (hash) {
          var speed = 0;

          for (var i = 0, length = s.slides.length; i < length; i++) {
            var slide = s.slides.eq(i);
            var slideHash = slide.attr('data-hash') || slide.attr('data-history');

            if (slideHash === hash && !slide.hasClass(s.params.slideDuplicateClass)) {
              var index = slide.index();
              s.slideTo(index, speed, s.params.runCallbacksOnInit, true);
            }
          }
        }

        if (s.params.hashnavWatchState) s.hashnav.attachEvents();
      },
      destroy: function destroy() {
        if (s.params.hashnavWatchState) s.hashnav.attachEvents(true);
      }
    };
    /*=========================
      History Api with fallback to Hashnav
      ===========================*/

    s.history = {
      init: function init() {
        if (!s.params.history) return;

        if (!window.history || !window.history.pushState) {
          s.params.history = false;
          s.params.hashnav = true;
          return;
        }

        s.history.initialized = true;
        this.paths = this.getPathValues();
        if (!this.paths.key && !this.paths.value) return;
        this.scrollToSlide(0, this.paths.value, s.params.runCallbacksOnInit);

        if (!s.params.replaceState) {
          window.addEventListener('popstate', this.setHistoryPopState);
        }
      },
      setHistoryPopState: function setHistoryPopState() {
        s.history.paths = s.history.getPathValues();
        s.history.scrollToSlide(s.params.speed, s.history.paths.value, false);
      },
      getPathValues: function getPathValues() {
        var pathArray = window.location.pathname.slice(1).split('/');
        var total = pathArray.length;
        var key = pathArray[total - 2];
        var value = pathArray[total - 1];
        return {
          key: key,
          value: value
        };
      },
      setHistory: function setHistory(key, index) {
        if (!s.history.initialized || !s.params.history) return;
        var slide = s.slides.eq(index);
        var value = this.slugify(slide.attr('data-history'));

        if (!window.location.pathname.includes(key)) {
          value = key + '/' + value;
        }

        if (s.params.replaceState) {
          window.history.replaceState(null, null, value);
        } else {
          window.history.pushState(null, null, value);
        }
      },
      slugify: function slugify(text) {
        return text.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '').replace(/\-\-+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
      },
      scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
        if (value) {
          for (var i = 0, length = s.slides.length; i < length; i++) {
            var slide = s.slides.eq(i);
            var slideHistory = this.slugify(slide.attr('data-history'));

            if (slideHistory === value && !slide.hasClass(s.params.slideDuplicateClass)) {
              var index = slide.index();
              s.slideTo(index, speed, runCallbacks);
            }
          }
        } else {
          s.slideTo(0, speed, runCallbacks);
        }
      }
    };
    /*=========================
      Keyboard Control
      ===========================*/

    function handleKeyboard(e) {
      if (e.originalEvent) e = e.originalEvent; //jquery fix

      var kc = e.keyCode || e.charCode; // Directions locks

      if (!s.params.allowSwipeToNext && (s.isHorizontal() && kc === 39 || !s.isHorizontal() && kc === 40)) {
        return false;
      }

      if (!s.params.allowSwipeToPrev && (s.isHorizontal() && kc === 37 || !s.isHorizontal() && kc === 38)) {
        return false;
      }

      if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
        return;
      }

      if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) {
        return;
      }

      if (kc === 37 || kc === 39 || kc === 38 || kc === 40) {
        var inView = false; //Check that swiper should be inside of visible area of window

        if (s.container.parents('.' + s.params.slideClass).length > 0 && s.container.parents('.' + s.params.slideActiveClass).length === 0) {
          return;
        }

        var windowScroll = {
          left: window.pageXOffset,
          top: window.pageYOffset
        };
        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;
        var swiperOffset = s.container.offset();
        if (s.rtl) swiperOffset.left = swiperOffset.left - s.container[0].scrollLeft;
        var swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + s.width, swiperOffset.top], [swiperOffset.left, swiperOffset.top + s.height], [swiperOffset.left + s.width, swiperOffset.top + s.height]];

        for (var i = 0; i < swiperCoord.length; i++) {
          var point = swiperCoord[i];

          if (point[0] >= windowScroll.left && point[0] <= windowScroll.left + windowWidth && point[1] >= windowScroll.top && point[1] <= windowScroll.top + windowHeight) {
            inView = true;
          }
        }

        if (!inView) return;
      }

      if (s.isHorizontal()) {
        if (kc === 37 || kc === 39) {
          if (e.preventDefault) e.preventDefault();else e.returnValue = false;
        }

        if (kc === 39 && !s.rtl || kc === 37 && s.rtl) s.slideNext();
        if (kc === 37 && !s.rtl || kc === 39 && s.rtl) s.slidePrev();
      } else {
        if (kc === 38 || kc === 40) {
          if (e.preventDefault) e.preventDefault();else e.returnValue = false;
        }

        if (kc === 40) s.slideNext();
        if (kc === 38) s.slidePrev();
      }

      s.emit('onKeyPress', s, kc);
    }

    s.disableKeyboardControl = function () {
      s.params.keyboardControl = false;
      $(document).off('keydown', handleKeyboard);
    };

    s.enableKeyboardControl = function () {
      s.params.keyboardControl = true;
      $(document).on('keydown', handleKeyboard);
    };
    /*=========================
      Mousewheel Control
      ===========================*/


    s.mousewheel = {
      event: false,
      lastScrollTime: new window.Date().getTime()
    };

    function isEventSupported() {
      var eventName = 'onwheel';
      var isSupported = (eventName in document);

      if (!isSupported) {
        var element = document.createElement('div');
        element.setAttribute(eventName, 'return;');
        isSupported = typeof element[eventName] === 'function';
      }

      if (!isSupported && document.implementation && document.implementation.hasFeature && // always returns true in newer browsers as per the standard.
      // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
      document.implementation.hasFeature('', '') !== true) {
        // This is the only way to test support for the `wheel` event in IE9+.
        isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
      }

      return isSupported;
    }
    /**
     * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
     * complicated, thus this doc is long and (hopefully) detailed enough to answer
     * your questions.
     *
     * If you need to react to the mouse wheel in a predictable way, this code is
     * like your bestest friend. * hugs *
     *
     * As of today, there are 4 DOM event types you can listen to:
     *
     *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
     *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
     *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
     *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
     *
     * So what to do?  The is the best:
     *
     *   normalizeWheel.getEventType();
     *
     * In your event callback, use this code to get sane interpretation of the
     * deltas.  This code will return an object with properties:
     *
     *   spinX   -- normalized spin speed (use for zoom) - x plane
     *   spinY   -- " - y plane
     *   pixelX  -- normalized distance (to pixels) - x plane
     *   pixelY  -- " - y plane
     *
     * Wheel values are provided by the browser assuming you are using the wheel to
     * scroll a web page by a number of lines or pixels (or pages).  Values can vary
     * significantly on different platforms and browsers, forgetting that you can
     * scroll at different speeds.  Some devices (like trackpads) emit more events
     * at smaller increments with fine granularity, and some emit massive jumps with
     * linear speed or acceleration.
     *
     * This code does its best to normalize the deltas for you:
     *
     *   - spin is trying to normalize how far the wheel was spun (or trackpad
     *     dragged).  This is super useful for zoom support where you want to
     *     throw away the chunky scroll steps on the PC and make those equal to
     *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
     *     resolve a single slow step on a wheel to 1.
     *
     *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
     *     get the crazy differences between browsers, but at least it'll be in
     *     pixels!
     *
     *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
     *     should translate to positive value zooming IN, negative zooming OUT.
     *     This matches the newer 'wheel' event.
     *
     * Why are there spinX, spinY (or pixels)?
     *
     *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
     *     with a mouse.  It results in side-scrolling in the browser by default.
     *
     *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
     *
     *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
     *     probably is by browsers in conjunction with fancy 3D controllers .. but
     *     you know.
     *
     * Implementation info:
     *
     * Examples of 'wheel' event if you scroll slowly (down) by one step with an
     * average mouse:
     *
     *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
     *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
     *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
     *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
     *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
     *
     * On the trackpad:
     *
     *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
     *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
     *
     * On other/older browsers.. it's more complicated as there can be multiple and
     * also missing delta values.
     *
     * The 'wheel' event is more standard:
     *
     * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
     *
     * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
     * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
     * backward compatibility with older events.  Those other values help us
     * better normalize spin speed.  Example of what the browsers provide:
     *
     *                          | event.wheelDelta | event.detail
     *        ------------------+------------------+--------------
     *          Safari v5/OS X  |       -120       |       0
     *          Safari v5/Win7  |       -120       |       0
     *         Chrome v17/OS X  |       -120       |       0
     *         Chrome v17/Win7  |       -120       |       0
     *                IE9/Win7  |       -120       |   undefined
     *         Firefox v4/OS X  |     undefined    |       1
     *         Firefox v4/Win7  |     undefined    |       3
     *
     */


    function normalizeWheel(
    /*object*/
    event)
    /*object*/
    {
      // Reasonable defaults
      var PIXEL_STEP = 10;
      var LINE_HEIGHT = 40;
      var PAGE_HEIGHT = 800;
      var sX = 0,
          sY = 0,
          // spinX, spinY
      pX = 0,
          pY = 0; // pixelX, pixelY
      // Legacy

      if ('detail' in event) {
        sY = event.detail;
      }

      if ('wheelDelta' in event) {
        sY = -event.wheelDelta / 120;
      }

      if ('wheelDeltaY' in event) {
        sY = -event.wheelDeltaY / 120;
      }

      if ('wheelDeltaX' in event) {
        sX = -event.wheelDeltaX / 120;
      } // side scrolling on FF with DOMMouseScroll


      if ('axis' in event && event.axis === event.HORIZONTAL_AXIS) {
        sX = sY;
        sY = 0;
      }

      pX = sX * PIXEL_STEP;
      pY = sY * PIXEL_STEP;

      if ('deltaY' in event) {
        pY = event.deltaY;
      }

      if ('deltaX' in event) {
        pX = event.deltaX;
      }

      if ((pX || pY) && event.deltaMode) {
        if (event.deltaMode === 1) {
          // delta in LINE units
          pX *= LINE_HEIGHT;
          pY *= LINE_HEIGHT;
        } else {
          // delta in PAGE units
          pX *= PAGE_HEIGHT;
          pY *= PAGE_HEIGHT;
        }
      } // Fall-back if spin cannot be determined


      if (pX && !sX) {
        sX = pX < 1 ? -1 : 1;
      }

      if (pY && !sY) {
        sY = pY < 1 ? -1 : 1;
      }

      return {
        spinX: sX,
        spinY: sY,
        pixelX: pX,
        pixelY: pY
      };
    }

    if (s.params.mousewheelControl) {
      /**
       * The best combination if you prefer spinX + spinY normalization.  It favors
       * the older DOMMouseScroll for Firefox, as FF does not include wheelDelta with
       * 'wheel' event, making spin speed determination impossible.
       */
      s.mousewheel.event = navigator.userAgent.indexOf('firefox') > -1 ? 'DOMMouseScroll' : isEventSupported() ? 'wheel' : 'mousewheel';
    }

    function handleMousewheel(e) {
      if (e.originalEvent) e = e.originalEvent; //jquery fix

      var delta = 0;
      var rtlFactor = s.rtl ? -1 : 1;
      var data = normalizeWheel(e);

      if (s.params.mousewheelForceToAxis) {
        if (s.isHorizontal()) {
          if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = data.pixelX * rtlFactor;else return;
        } else {
          if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = data.pixelY;else return;
        }
      } else {
        delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
      }

      if (delta === 0) return;
      if (s.params.mousewheelInvert) delta = -delta;

      if (!s.params.freeMode) {
        if (new window.Date().getTime() - s.mousewheel.lastScrollTime > 60) {
          if (delta < 0) {
            if ((!s.isEnd || s.params.loop) && !s.animating) {
              s.slideNext();
              s.emit('onScroll', s, e);
            } else if (s.params.mousewheelReleaseOnEdges) return true;
          } else {
            if ((!s.isBeginning || s.params.loop) && !s.animating) {
              s.slidePrev();
              s.emit('onScroll', s, e);
            } else if (s.params.mousewheelReleaseOnEdges) return true;
          }
        }

        s.mousewheel.lastScrollTime = new window.Date().getTime();
      } else {
        //Freemode or scrollContainer:
        var position = s.getWrapperTranslate() + delta * s.params.mousewheelSensitivity;
        var wasBeginning = s.isBeginning,
            wasEnd = s.isEnd;
        if (position >= s.minTranslate()) position = s.minTranslate();
        if (position <= s.maxTranslate()) position = s.maxTranslate();
        s.setWrapperTransition(0);
        s.setWrapperTranslate(position);
        s.updateProgress();
        s.updateActiveIndex();

        if (!wasBeginning && s.isBeginning || !wasEnd && s.isEnd) {
          s.updateClasses();
        }

        if (s.params.freeModeSticky) {
          clearTimeout(s.mousewheel.timeout);
          s.mousewheel.timeout = setTimeout(function () {
            s.slideReset();
          }, 300);
        } else {
          if (s.params.lazyLoading && s.lazy) {
            s.lazy.load();
          }
        } // Emit event


        s.emit('onScroll', s, e); // Stop autoplay

        if (s.params.autoplay && s.params.autoplayDisableOnInteraction) s.stopAutoplay(); // Return page scroll on edge positions

        if (position === 0 || position === s.maxTranslate()) return;
      }

      if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      return false;
    }

    s.disableMousewheelControl = function () {
      if (!s.mousewheel.event) return false;
      var target = s.container;

      if (s.params.mousewheelEventsTarged !== 'container') {
        target = $(s.params.mousewheelEventsTarged);
      }

      target.off(s.mousewheel.event, handleMousewheel);
      s.params.mousewheelControl = false;
      return true;
    };

    s.enableMousewheelControl = function () {
      if (!s.mousewheel.event) return false;
      var target = s.container;

      if (s.params.mousewheelEventsTarged !== 'container') {
        target = $(s.params.mousewheelEventsTarged);
      }

      target.on(s.mousewheel.event, handleMousewheel);
      s.params.mousewheelControl = true;
      return true;
    };
    /*=========================
      Parallax
      ===========================*/


    function setParallaxTransform(el, progress) {
      el = $(el);
      var p, pX, pY;
      var rtlFactor = s.rtl ? -1 : 1;
      p = el.attr('data-swiper-parallax') || '0';
      pX = el.attr('data-swiper-parallax-x');
      pY = el.attr('data-swiper-parallax-y');

      if (pX || pY) {
        pX = pX || '0';
        pY = pY || '0';
      } else {
        if (s.isHorizontal()) {
          pX = p;
          pY = '0';
        } else {
          pY = p;
          pX = '0';
        }
      }

      if (pX.indexOf('%') >= 0) {
        pX = parseInt(pX, 10) * progress * rtlFactor + '%';
      } else {
        pX = pX * progress * rtlFactor + 'px';
      }

      if (pY.indexOf('%') >= 0) {
        pY = parseInt(pY, 10) * progress + '%';
      } else {
        pY = pY * progress + 'px';
      }

      el.transform('translate3d(' + pX + ', ' + pY + ',0px)');
    }

    s.parallax = {
      setTranslate: function setTranslate() {
        s.container.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function () {
          setParallaxTransform(this, s.progress);
        });
        s.slides.each(function () {
          var slide = $(this);
          slide.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function () {
            var progress = Math.min(Math.max(slide[0].progress, -1), 1);
            setParallaxTransform(this, progress);
          });
        });
      },
      setTransition: function setTransition(duration) {
        if (typeof duration === 'undefined') duration = s.params.speed;
        s.container.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function () {
          var el = $(this);
          var parallaxDuration = parseInt(el.attr('data-swiper-parallax-duration'), 10) || duration;
          if (duration === 0) parallaxDuration = 0;
          el.transition(parallaxDuration);
        });
      }
    };
    /*=========================
      Zoom
      ===========================*/

    s.zoom = {
      // "Global" Props
      scale: 1,
      currentScale: 1,
      isScaling: false,
      gesture: {
        slide: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        image: undefined,
        imageWrap: undefined,
        zoomMax: s.params.zoomMax
      },
      image: {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
      },
      velocity: {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
      },
      // Calc Scale From Multi-touches
      getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) return 1;
        var x1 = e.targetTouches[0].pageX,
            y1 = e.targetTouches[0].pageY,
            x2 = e.targetTouches[1].pageX,
            y2 = e.targetTouches[1].pageY;
        var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
        return distance;
      },
      // Events
      onGestureStart: function onGestureStart(e) {
        var z = s.zoom;

        if (!s.support.gestures) {
          if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
            return;
          }

          z.gesture.scaleStart = z.getDistanceBetweenTouches(e);
        }

        if (!z.gesture.slide || !z.gesture.slide.length) {
          z.gesture.slide = $(this);
          if (z.gesture.slide.length === 0) z.gesture.slide = s.slides.eq(s.activeIndex);
          z.gesture.image = z.gesture.slide.find('img, svg, canvas');
          z.gesture.imageWrap = z.gesture.image.parent('.' + s.params.zoomContainerClass);
          z.gesture.zoomMax = z.gesture.imageWrap.attr('data-swiper-zoom') || s.params.zoomMax;

          if (z.gesture.imageWrap.length === 0) {
            z.gesture.image = undefined;
            return;
          }
        }

        z.gesture.image.transition(0);
        z.isScaling = true;
      },
      onGestureChange: function onGestureChange(e) {
        var z = s.zoom;

        if (!s.support.gestures) {
          if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
            return;
          }

          z.gesture.scaleMove = z.getDistanceBetweenTouches(e);
        }

        if (!z.gesture.image || z.gesture.image.length === 0) return;

        if (s.support.gestures) {
          z.scale = e.scale * z.currentScale;
        } else {
          z.scale = z.gesture.scaleMove / z.gesture.scaleStart * z.currentScale;
        }

        if (z.scale > z.gesture.zoomMax) {
          z.scale = z.gesture.zoomMax - 1 + Math.pow(z.scale - z.gesture.zoomMax + 1, 0.5);
        }

        if (z.scale < s.params.zoomMin) {
          z.scale = s.params.zoomMin + 1 - Math.pow(s.params.zoomMin - z.scale + 1, 0.5);
        }

        z.gesture.image.transform('translate3d(0,0,0) scale(' + z.scale + ')');
      },
      onGestureEnd: function onGestureEnd(e) {
        var z = s.zoom;

        if (!s.support.gestures) {
          if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2) {
            return;
          }
        }

        if (!z.gesture.image || z.gesture.image.length === 0) return;
        z.scale = Math.max(Math.min(z.scale, z.gesture.zoomMax), s.params.zoomMin);
        z.gesture.image.transition(s.params.speed).transform('translate3d(0,0,0) scale(' + z.scale + ')');
        z.currentScale = z.scale;
        z.isScaling = false;
        if (z.scale === 1) z.gesture.slide = undefined;
      },
      onTouchStart: function onTouchStart(s, e) {
        var z = s.zoom;
        if (!z.gesture.image || z.gesture.image.length === 0) return;
        if (z.image.isTouched) return;
        if (s.device.os === 'android') e.preventDefault();
        z.image.isTouched = true;
        z.image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
        z.image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
      },
      onTouchMove: function onTouchMove(e) {
        var z = s.zoom;
        if (!z.gesture.image || z.gesture.image.length === 0) return;
        s.allowClick = false;
        if (!z.image.isTouched || !z.gesture.slide) return;

        if (!z.image.isMoved) {
          z.image.width = z.gesture.image[0].offsetWidth;
          z.image.height = z.gesture.image[0].offsetHeight;
          z.image.startX = s.getTranslate(z.gesture.imageWrap[0], 'x') || 0;
          z.image.startY = s.getTranslate(z.gesture.imageWrap[0], 'y') || 0;
          z.gesture.slideWidth = z.gesture.slide[0].offsetWidth;
          z.gesture.slideHeight = z.gesture.slide[0].offsetHeight;
          z.gesture.imageWrap.transition(0);
          if (s.rtl) z.image.startX = -z.image.startX;
          if (s.rtl) z.image.startY = -z.image.startY;
        } // Define if we need image drag


        var scaledWidth = z.image.width * z.scale;
        var scaledHeight = z.image.height * z.scale;
        if (scaledWidth < z.gesture.slideWidth && scaledHeight < z.gesture.slideHeight) return;
        z.image.minX = Math.min(z.gesture.slideWidth / 2 - scaledWidth / 2, 0);
        z.image.maxX = -z.image.minX;
        z.image.minY = Math.min(z.gesture.slideHeight / 2 - scaledHeight / 2, 0);
        z.image.maxY = -z.image.minY;
        z.image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
        z.image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

        if (!z.image.isMoved && !z.isScaling) {
          if (s.isHorizontal() && Math.floor(z.image.minX) === Math.floor(z.image.startX) && z.image.touchesCurrent.x < z.image.touchesStart.x || Math.floor(z.image.maxX) === Math.floor(z.image.startX) && z.image.touchesCurrent.x > z.image.touchesStart.x) {
            z.image.isTouched = false;
            return;
          } else if (!s.isHorizontal() && Math.floor(z.image.minY) === Math.floor(z.image.startY) && z.image.touchesCurrent.y < z.image.touchesStart.y || Math.floor(z.image.maxY) === Math.floor(z.image.startY) && z.image.touchesCurrent.y > z.image.touchesStart.y) {
            z.image.isTouched = false;
            return;
          }
        }

        e.preventDefault();
        e.stopPropagation();
        z.image.isMoved = true;
        z.image.currentX = z.image.touchesCurrent.x - z.image.touchesStart.x + z.image.startX;
        z.image.currentY = z.image.touchesCurrent.y - z.image.touchesStart.y + z.image.startY;

        if (z.image.currentX < z.image.minX) {
          z.image.currentX = z.image.minX + 1 - Math.pow(z.image.minX - z.image.currentX + 1, 0.8);
        }

        if (z.image.currentX > z.image.maxX) {
          z.image.currentX = z.image.maxX - 1 + Math.pow(z.image.currentX - z.image.maxX + 1, 0.8);
        }

        if (z.image.currentY < z.image.minY) {
          z.image.currentY = z.image.minY + 1 - Math.pow(z.image.minY - z.image.currentY + 1, 0.8);
        }

        if (z.image.currentY > z.image.maxY) {
          z.image.currentY = z.image.maxY - 1 + Math.pow(z.image.currentY - z.image.maxY + 1, 0.8);
        } //Velocity


        if (!z.velocity.prevPositionX) z.velocity.prevPositionX = z.image.touchesCurrent.x;
        if (!z.velocity.prevPositionY) z.velocity.prevPositionY = z.image.touchesCurrent.y;
        if (!z.velocity.prevTime) z.velocity.prevTime = Date.now();
        z.velocity.x = (z.image.touchesCurrent.x - z.velocity.prevPositionX) / (Date.now() - z.velocity.prevTime) / 2;
        z.velocity.y = (z.image.touchesCurrent.y - z.velocity.prevPositionY) / (Date.now() - z.velocity.prevTime) / 2;
        if (Math.abs(z.image.touchesCurrent.x - z.velocity.prevPositionX) < 2) z.velocity.x = 0;
        if (Math.abs(z.image.touchesCurrent.y - z.velocity.prevPositionY) < 2) z.velocity.y = 0;
        z.velocity.prevPositionX = z.image.touchesCurrent.x;
        z.velocity.prevPositionY = z.image.touchesCurrent.y;
        z.velocity.prevTime = Date.now();
        z.gesture.imageWrap.transform('translate3d(' + z.image.currentX + 'px, ' + z.image.currentY + 'px,0)');
      },
      onTouchEnd: function onTouchEnd(s, e) {
        var z = s.zoom;
        if (!z.gesture.image || z.gesture.image.length === 0) return;

        if (!z.image.isTouched || !z.image.isMoved) {
          z.image.isTouched = false;
          z.image.isMoved = false;
          return;
        }

        z.image.isTouched = false;
        z.image.isMoved = false;
        var momentumDurationX = 300;
        var momentumDurationY = 300;
        var momentumDistanceX = z.velocity.x * momentumDurationX;
        var newPositionX = z.image.currentX + momentumDistanceX;
        var momentumDistanceY = z.velocity.y * momentumDurationY;
        var newPositionY = z.image.currentY + momentumDistanceY; //Fix duration

        if (z.velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - z.image.currentX) / z.velocity.x);
        if (z.velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - z.image.currentY) / z.velocity.y);
        var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        z.image.currentX = newPositionX;
        z.image.currentY = newPositionY; // Define if we need image drag

        var scaledWidth = z.image.width * z.scale;
        var scaledHeight = z.image.height * z.scale;
        z.image.minX = Math.min(z.gesture.slideWidth / 2 - scaledWidth / 2, 0);
        z.image.maxX = -z.image.minX;
        z.image.minY = Math.min(z.gesture.slideHeight / 2 - scaledHeight / 2, 0);
        z.image.maxY = -z.image.minY;
        z.image.currentX = Math.max(Math.min(z.image.currentX, z.image.maxX), z.image.minX);
        z.image.currentY = Math.max(Math.min(z.image.currentY, z.image.maxY), z.image.minY);
        z.gesture.imageWrap.transition(momentumDuration).transform('translate3d(' + z.image.currentX + 'px, ' + z.image.currentY + 'px,0)');
      },
      onTransitionEnd: function onTransitionEnd(s) {
        var z = s.zoom;

        if (z.gesture.slide && s.previousIndex !== s.activeIndex) {
          z.gesture.image.transform('translate3d(0,0,0) scale(1)');
          z.gesture.imageWrap.transform('translate3d(0,0,0)');
          z.gesture.slide = z.gesture.image = z.gesture.imageWrap = undefined;
          z.scale = z.currentScale = 1;
        }
      },
      // Toggle Zoom
      toggleZoom: function toggleZoom(s, e) {
        var z = s.zoom;

        if (!z.gesture.slide) {
          z.gesture.slide = s.clickedSlide ? $(s.clickedSlide) : s.slides.eq(s.activeIndex);
          z.gesture.image = z.gesture.slide.find('img, svg, canvas');
          z.gesture.imageWrap = z.gesture.image.parent('.' + s.params.zoomContainerClass);
        }

        if (!z.gesture.image || z.gesture.image.length === 0) return;
        var touchX, touchY, offsetX, offsetY, diffX, diffY, translateX, translateY, imageWidth, imageHeight, scaledWidth, scaledHeight, translateMinX, translateMinY, translateMaxX, translateMaxY, slideWidth, slideHeight;

        if (typeof z.image.touchesStart.x === 'undefined' && e) {
          touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
          touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
        } else {
          touchX = z.image.touchesStart.x;
          touchY = z.image.touchesStart.y;
        }

        if (z.scale && z.scale !== 1) {
          // Zoom Out
          z.scale = z.currentScale = 1;
          z.gesture.imageWrap.transition(300).transform('translate3d(0,0,0)');
          z.gesture.image.transition(300).transform('translate3d(0,0,0) scale(1)');
          z.gesture.slide = undefined;
        } else {
          // Zoom In
          z.scale = z.currentScale = z.gesture.imageWrap.attr('data-swiper-zoom') || s.params.zoomMax;

          if (e) {
            slideWidth = z.gesture.slide[0].offsetWidth;
            slideHeight = z.gesture.slide[0].offsetHeight;
            offsetX = z.gesture.slide.offset().left;
            offsetY = z.gesture.slide.offset().top;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = z.gesture.image[0].offsetWidth;
            imageHeight = z.gesture.image[0].offsetHeight;
            scaledWidth = imageWidth * z.scale;
            scaledHeight = imageHeight * z.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * z.scale;
            translateY = diffY * z.scale;

            if (translateX < translateMinX) {
              translateX = translateMinX;
            }

            if (translateX > translateMaxX) {
              translateX = translateMaxX;
            }

            if (translateY < translateMinY) {
              translateY = translateMinY;
            }

            if (translateY > translateMaxY) {
              translateY = translateMaxY;
            }
          } else {
            translateX = 0;
            translateY = 0;
          }

          z.gesture.imageWrap.transition(300).transform('translate3d(' + translateX + 'px, ' + translateY + 'px,0)');
          z.gesture.image.transition(300).transform('translate3d(0,0,0) scale(' + z.scale + ')');
        }
      },
      // Attach/Detach Events
      attachEvents: function attachEvents(detach) {
        var action = detach ? 'off' : 'on';

        if (s.params.zoom) {
          var target = s.slides;
          var passiveListener = s.touchEvents.start === 'touchstart' && s.support.passiveListener && s.params.passiveListeners ? {
            passive: true,
            capture: false
          } : false; // Scale image

          if (s.support.gestures) {
            s.slides[action]('gesturestart', s.zoom.onGestureStart, passiveListener);
            s.slides[action]('gesturechange', s.zoom.onGestureChange, passiveListener);
            s.slides[action]('gestureend', s.zoom.onGestureEnd, passiveListener);
          } else if (s.touchEvents.start === 'touchstart') {
            s.slides[action](s.touchEvents.start, s.zoom.onGestureStart, passiveListener);
            s.slides[action](s.touchEvents.move, s.zoom.onGestureChange, passiveListener);
            s.slides[action](s.touchEvents.end, s.zoom.onGestureEnd, passiveListener);
          } // Move image


          s[action]('touchStart', s.zoom.onTouchStart);
          s.slides.each(function (index, slide) {
            if ($(slide).find('.' + s.params.zoomContainerClass).length > 0) {
              $(slide)[action](s.touchEvents.move, s.zoom.onTouchMove);
            }
          });
          s[action]('touchEnd', s.zoom.onTouchEnd); // Scale Out

          s[action]('transitionEnd', s.zoom.onTransitionEnd);

          if (s.params.zoomToggle) {
            s.on('doubleTap', s.zoom.toggleZoom);
          }
        }
      },
      init: function init() {
        s.zoom.attachEvents();
      },
      destroy: function destroy() {
        s.zoom.attachEvents(true);
      }
    };
    /*=========================
      Plugins API. Collect all and init all plugins
      ===========================*/

    s._plugins = [];

    for (var plugin in s.plugins) {
      var p = s.plugins[plugin](s, s.params[plugin]);
      if (p) s._plugins.push(p);
    } // Method to call all plugins event/method


    s.callPlugins = function (eventName) {
      for (var i = 0; i < s._plugins.length; i++) {
        if (eventName in s._plugins[i]) {
          s._plugins[i][eventName](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
        }
      }
    };
    /*=========================
      Events/Callbacks/Plugins Emitter
      ===========================*/


    function normalizeEventName(eventName) {
      if (eventName.indexOf('on') !== 0) {
        if (eventName[0] !== eventName[0].toUpperCase()) {
          eventName = 'on' + eventName[0].toUpperCase() + eventName.substring(1);
        } else {
          eventName = 'on' + eventName;
        }
      }

      return eventName;
    }

    s.emitterEventListeners = {};

    s.emit = function (eventName) {
      // Trigger callbacks
      if (s.params[eventName]) {
        s.params[eventName](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
      }

      var i; // Trigger events

      if (s.emitterEventListeners[eventName]) {
        for (i = 0; i < s.emitterEventListeners[eventName].length; i++) {
          s.emitterEventListeners[eventName][i](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
        }
      } // Trigger plugins


      if (s.callPlugins) s.callPlugins(eventName, arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
    };

    s.on = function (eventName, handler) {
      eventName = normalizeEventName(eventName);
      if (!s.emitterEventListeners[eventName]) s.emitterEventListeners[eventName] = [];
      s.emitterEventListeners[eventName].push(handler);
      return s;
    };

    s.off = function (eventName, handler) {
      var i;
      eventName = normalizeEventName(eventName);

      if (typeof handler === 'undefined') {
        // Remove all handlers for such event
        s.emitterEventListeners[eventName] = [];
        return s;
      }

      if (!s.emitterEventListeners[eventName] || s.emitterEventListeners[eventName].length === 0) return;

      for (i = 0; i < s.emitterEventListeners[eventName].length; i++) {
        if (s.emitterEventListeners[eventName][i] === handler) s.emitterEventListeners[eventName].splice(i, 1);
      }

      return s;
    };

    s.once = function (eventName, handler) {
      eventName = normalizeEventName(eventName);

      var _handler = function _handler() {
        handler(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
        s.off(eventName, _handler);
      };

      s.on(eventName, _handler);
      return s;
    }; // Accessibility tools


    s.a11y = {
      makeFocusable: function makeFocusable($el) {
        $el.attr('tabIndex', '0');
        return $el;
      },
      addRole: function addRole($el, role) {
        $el.attr('role', role);
        return $el;
      },
      addLabel: function addLabel($el, label) {
        $el.attr('aria-label', label);
        return $el;
      },
      disable: function disable($el) {
        $el.attr('aria-disabled', true);
        return $el;
      },
      enable: function enable($el) {
        $el.attr('aria-disabled', false);
        return $el;
      },
      onEnterKey: function onEnterKey(event) {
        if (event.keyCode !== 13) return;

        if ($(event.target).is(s.params.nextButton)) {
          s.onClickNext(event);

          if (s.isEnd) {
            s.a11y.notify(s.params.lastSlideMessage);
          } else {
            s.a11y.notify(s.params.nextSlideMessage);
          }
        } else if ($(event.target).is(s.params.prevButton)) {
          s.onClickPrev(event);

          if (s.isBeginning) {
            s.a11y.notify(s.params.firstSlideMessage);
          } else {
            s.a11y.notify(s.params.prevSlideMessage);
          }
        }

        if ($(event.target).is('.' + s.params.bulletClass)) {
          $(event.target)[0].click();
        }
      },
      liveRegion: $('<span class="' + s.params.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>'),
      notify: function notify(message) {
        var notification = s.a11y.liveRegion;
        if (notification.length === 0) return;
        notification.html('');
        notification.html(message);
      },
      init: function init() {
        // Setup accessibility
        if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
          s.a11y.makeFocusable(s.nextButton);
          s.a11y.addRole(s.nextButton, 'button');
          s.a11y.addLabel(s.nextButton, s.params.nextSlideMessage);
        }

        if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
          s.a11y.makeFocusable(s.prevButton);
          s.a11y.addRole(s.prevButton, 'button');
          s.a11y.addLabel(s.prevButton, s.params.prevSlideMessage);
        }

        $(s.container).append(s.a11y.liveRegion);
      },
      initPagination: function initPagination() {
        if (s.params.pagination && s.params.paginationClickable && s.bullets && s.bullets.length) {
          s.bullets.each(function () {
            var bullet = $(this);
            s.a11y.makeFocusable(bullet);
            s.a11y.addRole(bullet, 'button');
            s.a11y.addLabel(bullet, s.params.paginationBulletMessage.replace(/{{index}}/, bullet.index() + 1));
          });
        }
      },
      destroy: function destroy() {
        if (s.a11y.liveRegion && s.a11y.liveRegion.length > 0) s.a11y.liveRegion.remove();
      }
    };
    /*=========================
      Init/Destroy
      ===========================*/

    s.init = function () {
      if (s.params.loop) s.createLoop();
      s.updateContainerSize();
      s.updateSlidesSize();
      s.updatePagination();

      if (s.params.scrollbar && s.scrollbar) {
        s.scrollbar.set();

        if (s.params.scrollbarDraggable) {
          s.scrollbar.enableDraggable();
        }
      }

      if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
        if (!s.params.loop) s.updateProgress();
        s.effects[s.params.effect].setTranslate();
      }

      if (s.params.loop) {
        s.slideTo(s.params.initialSlide + s.loopedSlides, 0, s.params.runCallbacksOnInit);
      } else {
        s.slideTo(s.params.initialSlide, 0, s.params.runCallbacksOnInit);

        if (s.params.initialSlide === 0) {
          if (s.parallax && s.params.parallax) s.parallax.setTranslate();

          if (s.lazy && s.params.lazyLoading) {
            s.lazy.load();
            s.lazy.initialImageLoaded = true;
          }
        }
      }

      s.attachEvents();

      if (s.params.observer && s.support.observer) {
        s.initObservers();
      }

      if (s.params.preloadImages && !s.params.lazyLoading) {
        s.preloadImages();
      }

      if (s.params.zoom && s.zoom) {
        s.zoom.init();
      }

      if (s.params.autoplay) {
        s.startAutoplay();
      }

      if (s.params.keyboardControl) {
        if (s.enableKeyboardControl) s.enableKeyboardControl();
      }

      if (s.params.mousewheelControl) {
        if (s.enableMousewheelControl) s.enableMousewheelControl();
      } // Deprecated hashnavReplaceState changed to replaceState for use in hashnav and history


      if (s.params.hashnavReplaceState) {
        s.params.replaceState = s.params.hashnavReplaceState;
      }

      if (s.params.history) {
        if (s.history) s.history.init();
      }

      if (s.params.hashnav) {
        if (s.hashnav) s.hashnav.init();
      }

      if (s.params.a11y && s.a11y) s.a11y.init();
      s.emit('onInit', s);
    }; // Cleanup dynamic styles


    s.cleanupStyles = function () {
      // Container
      s.container.removeClass(s.classNames.join(' ')).removeAttr('style'); // Wrapper

      s.wrapper.removeAttr('style'); // Slides

      if (s.slides && s.slides.length) {
        s.slides.removeClass([s.params.slideVisibleClass, s.params.slideActiveClass, s.params.slideNextClass, s.params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-column').removeAttr('data-swiper-row');
      } // Pagination/Bullets


      if (s.paginationContainer && s.paginationContainer.length) {
        s.paginationContainer.removeClass(s.params.paginationHiddenClass);
      }

      if (s.bullets && s.bullets.length) {
        s.bullets.removeClass(s.params.bulletActiveClass);
      } // Buttons


      if (s.params.prevButton) $(s.params.prevButton).removeClass(s.params.buttonDisabledClass);
      if (s.params.nextButton) $(s.params.nextButton).removeClass(s.params.buttonDisabledClass); // Scrollbar

      if (s.params.scrollbar && s.scrollbar) {
        if (s.scrollbar.track && s.scrollbar.track.length) s.scrollbar.track.removeAttr('style');
        if (s.scrollbar.drag && s.scrollbar.drag.length) s.scrollbar.drag.removeAttr('style');
      }
    }; // Destroy


    s.destroy = function (deleteInstance, cleanupStyles) {
      // Detach evebts
      s.detachEvents(); // Stop autoplay

      s.stopAutoplay(); // Disable draggable

      if (s.params.scrollbar && s.scrollbar) {
        if (s.params.scrollbarDraggable) {
          s.scrollbar.disableDraggable();
        }
      } // Destroy loop


      if (s.params.loop) {
        s.destroyLoop();
      } // Cleanup styles


      if (cleanupStyles) {
        s.cleanupStyles();
      } // Disconnect observer


      s.disconnectObservers(); // Destroy zoom

      if (s.params.zoom && s.zoom) {
        s.zoom.destroy();
      } // Disable keyboard/mousewheel


      if (s.params.keyboardControl) {
        if (s.disableKeyboardControl) s.disableKeyboardControl();
      }

      if (s.params.mousewheelControl) {
        if (s.disableMousewheelControl) s.disableMousewheelControl();
      } // Disable a11y


      if (s.params.a11y && s.a11y) s.a11y.destroy(); // Delete history popstate

      if (s.params.history && !s.params.replaceState) {
        window.removeEventListener('popstate', s.history.setHistoryPopState);
      }

      if (s.params.hashnav && s.hashnav) {
        s.hashnav.destroy();
      } // Destroy callback


      s.emit('onDestroy'); // Delete instance

      if (deleteInstance !== false) s = null;
    };

    s.init(); // Return swiper instance

    return s;
  };
  /*==================================================
      Prototype
  ====================================================*/


  Swiper.prototype = {
    isSafari: function () {
      var ua = window.navigator.userAgent.toLowerCase();
      return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }(),
    isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent),
    isArray: function isArray(arr) {
      return Object.prototype.toString.apply(arr) === '[object Array]';
    },

    /*==================================================
    Browser
    ====================================================*/
    browser: {
      ie: window.navigator.pointerEnabled || window.navigator.msPointerEnabled,
      ieTouch: window.navigator.msPointerEnabled && window.navigator.msMaxTouchPoints > 1 || window.navigator.pointerEnabled && window.navigator.maxTouchPoints > 1,
      lteIE9: function () {
        // create temporary DIV
        var div = document.createElement('div'); // add content to tmp DIV which is wrapped into the IE HTML conditional statement

        div.innerHTML = '<!--[if lte IE 9]><i></i><![endif]-->'; // return true / false value based on what will browser render

        return div.getElementsByTagName('i').length === 1;
      }()
    },

    /*==================================================
    Devices
    ====================================================*/
    device: function () {
      var ua = window.navigator.userAgent;
      var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
      var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
      var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
      var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
      return {
        ios: ipad || iphone || ipod,
        android: android
      };
    }(),

    /*==================================================
    Feature Detection
    ====================================================*/
    support: {
      touch: window.Modernizr && Modernizr.touch === true || function () {
        return !!('ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch);
      }(),
      transforms3d: window.Modernizr && Modernizr.csstransforms3d === true || function () {
        var div = document.createElement('div').style;
        return 'webkitPerspective' in div || 'MozPerspective' in div || 'OPerspective' in div || 'MsPerspective' in div || 'perspective' in div;
      }(),
      flexbox: function () {
        var div = document.createElement('div').style;
        var styles = 'alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient'.split(' ');

        for (var i = 0; i < styles.length; i++) {
          if (styles[i] in div) return true;
        }
      }(),
      observer: function () {
        return 'MutationObserver' in window || 'WebkitMutationObserver' in window;
      }(),
      passiveListener: function () {
        var supportsPassive = false;

        try {
          var opts = Object.defineProperty({}, 'passive', {
            get: function get() {
              supportsPassive = true;
            }
          });
          window.addEventListener('testPassiveListener', null, opts);
        } catch (e) {}

        return supportsPassive;
      }(),
      gestures: function () {
        return 'ongesturestart' in window;
      }()
    },

    /*==================================================
    Plugins
    ====================================================*/
    plugins: {}
  };
  /*===========================
   Get Dom libraries
   ===========================*/

  var swiperDomPlugins = ['jQuery', 'Zepto', 'Dom7'];

  for (var i = 0; i < swiperDomPlugins.length; i++) {
    if (window[swiperDomPlugins[i]]) {
      addLibraryPlugin(window[swiperDomPlugins[i]]);
    }
  } // Required DOM Plugins


  var domLib;

  if (typeof Dom7 === 'undefined') {
    domLib = window.Dom7 || window.Zepto || window.jQuery;
  } else {
    domLib = Dom7;
  }
  /*===========================
  Add .swiper plugin from Dom libraries
  ===========================*/


  function addLibraryPlugin(lib) {
    lib.fn.swiper = function (params) {
      var firstInstance;
      lib(this).each(function () {
        var s = new Swiper(this, params);
        if (!firstInstance) firstInstance = s;
      });
      return firstInstance;
    };
  }

  if (domLib) {
    if (!('transitionEnd' in domLib.fn)) {
      domLib.fn.transitionEnd = function (callback) {
        var events = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'],
            i,
            j,
            dom = this;

        function fireCallBack(e) {
          /*jshint validthis:true */
          if (e.target !== this) return;
          callback.call(this, e);

          for (i = 0; i < events.length; i++) {
            dom.off(events[i], fireCallBack);
          }
        }

        if (callback) {
          for (i = 0; i < events.length; i++) {
            dom.on(events[i], fireCallBack);
          }
        }

        return this;
      };
    }

    if (!('transform' in domLib.fn)) {
      domLib.fn.transform = function (transform) {
        for (var i = 0; i < this.length; i++) {
          var elStyle = this[i].style;
          elStyle.webkitTransform = elStyle.MsTransform = elStyle.msTransform = elStyle.MozTransform = elStyle.OTransform = elStyle.transform = transform;
        }

        return this;
      };
    }

    if (!('transition' in domLib.fn)) {
      domLib.fn.transition = function (duration) {
        if (typeof duration !== 'string') {
          duration = duration + 'ms';
        }

        for (var i = 0; i < this.length; i++) {
          var elStyle = this[i].style;
          elStyle.webkitTransitionDuration = elStyle.MsTransitionDuration = elStyle.msTransitionDuration = elStyle.MozTransitionDuration = elStyle.OTransitionDuration = elStyle.transitionDuration = duration;
        }

        return this;
      };
    }

    if (!('outerWidth' in domLib.fn)) {
      domLib.fn.outerWidth = function (includeMargins) {
        if (this.length > 0) {
          if (includeMargins) return this[0].offsetWidth + parseFloat(this.css('margin-right')) + parseFloat(this.css('margin-left'));else return this[0].offsetWidth;
        } else return null;
      };
    }
  }

  window.Swiper = Swiper;
})();
/*===========================
Swiper AMD Export
===========================*/


if (typeof module !== 'undefined') {
  module.exports = window.Swiper;
} else if (typeof define === 'function' && define.amd) {
  define([], function () {
    'use strict';

    return window.Swiper;
  });
} // Ion.RangeSlider
// version 2.1.7 Build: 371
// © Denis Ineshin, 2017
// https://github.com/IonDen
//
// Project page:    http://ionden.com/a/plugins/ion.rangeSlider/en.html
// GitHub page:     https://github.com/IonDen/ion.rangeSlider
//
// Released under MIT licence:
// http://ionden.com/a/plugins/licence-en.html
// =====================================================================================================================


;

(function (factory) {
  if (typeof define === "function" && define.amd) {
    define(["jquery"], function (jQuery) {
      return factory(jQuery, document, window, navigator);
    });
  } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === "object") {
    factory(require("jquery"), document, window, navigator);
  } else {
    factory(jQuery, document, window, navigator);
  }
})(function ($, document, window, navigator, undefined) {
  "use strict"; // =================================================================================================================
  // Service

  var plugin_count = 0; // IE8 fix

  var is_old_ie = function () {
    var n = navigator.userAgent,
        r = /msie\s\d+/i,
        v;

    if (n.search(r) > 0) {
      v = r.exec(n).toString();
      v = v.split(" ")[1];

      if (v < 9) {
        $("html").addClass("lt-ie9");
        return true;
      }
    }

    return false;
  }();

  if (!Function.prototype.bind) {
    Function.prototype.bind = function bind(that) {
      var target = this;
      var slice = [].slice;

      if (typeof target != "function") {
        throw new TypeError();
      }

      var args = slice.call(arguments, 1),
          bound = function bound() {
        if (this instanceof bound) {
          var F = function F() {};

          F.prototype = target.prototype;
          var self = new F();
          var result = target.apply(self, args.concat(slice.call(arguments)));

          if (Object(result) === result) {
            return result;
          }

          return self;
        } else {
          return target.apply(that, args.concat(slice.call(arguments)));
        }
      };

      return bound;
    };
  }

  if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (searchElement, fromIndex) {
      var k;

      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var O = Object(this);
      var len = O.length >>> 0;

      if (len === 0) {
        return -1;
      }

      var n = +fromIndex || 0;

      if (Math.abs(n) === Infinity) {
        n = 0;
      }

      if (n >= len) {
        return -1;
      }

      k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      while (k < len) {
        if (k in O && O[k] === searchElement) {
          return k;
        }

        k++;
      }

      return -1;
    };
  } // =================================================================================================================
  // Template


  var base_html = '<span class="irs">' + '<span class="irs-line" tabindex="-1"><span class="irs-line-left"></span><span class="irs-line-mid"></span><span class="irs-line-right"></span></span>' + '<span class="irs-min">0</span><span class="irs-max">1</span>' + '<span class="irs-from">0</span><span class="irs-to">0</span><span class="irs-single">0</span>' + '</span>' + '<span class="irs-grid"></span>' + '<span class="irs-bar"></span>';
  var single_html = '<span class="irs-bar-edge"></span>' + '<span class="irs-shadow shadow-single"></span>' + '<span class="irs-slider single"></span>';
  var double_html = '<span class="irs-shadow shadow-from"></span>' + '<span class="irs-shadow shadow-to"></span>' + '<span class="irs-slider from"></span>' + '<span class="irs-slider to"></span>';
  var disable_html = '<span class="irs-disable-mask"></span>'; // =================================================================================================================
  // Core

  /**
   * Main plugin constructor
   *
   * @param input {Object} link to base input element
   * @param options {Object} slider config
   * @param plugin_count {Number}
   * @constructor
   */

  var IonRangeSlider = function IonRangeSlider(input, options, plugin_count) {
    this.VERSION = "2.1.7";
    this.input = input;
    this.plugin_count = plugin_count;
    this.current_plugin = 0;
    this.calc_count = 0;
    this.update_tm = 0;
    this.old_from = 0;
    this.old_to = 0;
    this.old_min_interval = null;
    this.raf_id = null;
    this.dragging = false;
    this.force_redraw = false;
    this.no_diapason = false;
    this.is_key = false;
    this.is_update = false;
    this.is_start = true;
    this.is_finish = false;
    this.is_active = false;
    this.is_resize = false;
    this.is_click = false;
    options = options || {}; // cache for links to all DOM elements

    this.$cache = {
      win: $(window),
      body: $(document.body),
      input: $(input),
      cont: null,
      rs: null,
      min: null,
      max: null,
      from: null,
      to: null,
      single: null,
      bar: null,
      line: null,
      s_single: null,
      s_from: null,
      s_to: null,
      shad_single: null,
      shad_from: null,
      shad_to: null,
      edge: null,
      grid: null,
      grid_labels: []
    }; // storage for measure variables

    this.coords = {
      // left
      x_gap: 0,
      x_pointer: 0,
      // width
      w_rs: 0,
      w_rs_old: 0,
      w_handle: 0,
      // percents
      p_gap: 0,
      p_gap_left: 0,
      p_gap_right: 0,
      p_step: 0,
      p_pointer: 0,
      p_handle: 0,
      p_single_fake: 0,
      p_single_real: 0,
      p_from_fake: 0,
      p_from_real: 0,
      p_to_fake: 0,
      p_to_real: 0,
      p_bar_x: 0,
      p_bar_w: 0,
      // grid
      grid_gap: 0,
      big_num: 0,
      big: [],
      big_w: [],
      big_p: [],
      big_x: []
    }; // storage for labels measure variables

    this.labels = {
      // width
      w_min: 0,
      w_max: 0,
      w_from: 0,
      w_to: 0,
      w_single: 0,
      // percents
      p_min: 0,
      p_max: 0,
      p_from_fake: 0,
      p_from_left: 0,
      p_to_fake: 0,
      p_to_left: 0,
      p_single_fake: 0,
      p_single_left: 0
    };
    /**
     * get and validate config
     */

    var $inp = this.$cache.input,
        val = $inp.prop("value"),
        config,
        config_from_data,
        prop; // default config

    config = {
      type: "single",
      min: 10,
      max: 100,
      from: null,
      to: null,
      step: 1,
      min_interval: 0,
      max_interval: 0,
      drag_interval: false,
      values: [],
      p_values: [],
      from_fixed: false,
      from_min: null,
      from_max: null,
      from_shadow: false,
      to_fixed: false,
      to_min: null,
      to_max: null,
      to_shadow: false,
      prettify_enabled: true,
      prettify_separator: " ",
      prettify: null,
      force_edges: false,
      keyboard: false,
      keyboard_step: 5,
      grid: false,
      grid_margin: true,
      grid_num: 4,
      grid_snap: false,
      hide_min_max: false,
      hide_from_to: false,
      prefix: "",
      postfix: "",
      prefix_minmax: "",
      postfix_minmax: "",
      max_postfix: "",
      decorate_both: true,
      values_separator: " — ",
      input_values_separator: ";",
      disable: false,
      onStart: null,
      onChange: null,
      onFinish: null,
      onUpdate: null
    }; // check if base element is input

    if ($inp[0].nodeName !== "INPUT") {
      console && console.warn && console.warn("Base element should be <input>!", $inp[0]);
    } // config from data-attributes extends js config


    config_from_data = {
      type: $inp.data("type"),
      min: $inp.data("min"),
      max: $inp.data("max"),
      from: $inp.data("from"),
      to: $inp.data("to"),
      step: $inp.data("step"),
      min_interval: $inp.data("minInterval"),
      max_interval: $inp.data("maxInterval"),
      drag_interval: $inp.data("dragInterval"),
      values: $inp.data("values"),
      from_fixed: $inp.data("fromFixed"),
      from_min: $inp.data("fromMin"),
      from_max: $inp.data("fromMax"),
      from_shadow: $inp.data("fromShadow"),
      to_fixed: $inp.data("toFixed"),
      to_min: $inp.data("toMin"),
      to_max: $inp.data("toMax"),
      to_shadow: $inp.data("toShadow"),
      prettify_enabled: $inp.data("prettifyEnabled"),
      prettify_separator: $inp.data("prettifySeparator"),
      force_edges: $inp.data("forceEdges"),
      keyboard: $inp.data("keyboard"),
      keyboard_step: $inp.data("keyboardStep"),
      grid: $inp.data("grid"),
      grid_margin: $inp.data("gridMargin"),
      grid_num: $inp.data("gridNum"),
      grid_snap: $inp.data("gridSnap"),
      hide_min_max: $inp.data("hideMinMax"),
      hide_from_to: $inp.data("hideFromTo"),
      prefix: $inp.data("prefix"),
      postfix: $inp.data("postfix"),
      max_postfix: $inp.data("maxPostfix"),
      decorate_both: $inp.data("decorateBoth"),
      values_separator: $inp.data("valuesSeparator"),
      input_values_separator: $inp.data("inputValuesSeparator"),
      disable: $inp.data("disable")
    };
    config_from_data.values = config_from_data.values && config_from_data.values.split(",");

    for (prop in config_from_data) {
      if (config_from_data.hasOwnProperty(prop)) {
        if (config_from_data[prop] === undefined || config_from_data[prop] === "") {
          delete config_from_data[prop];
        }
      }
    } // input value extends default config


    if (val !== undefined && val !== "") {
      val = val.split(config_from_data.input_values_separator || options.input_values_separator || ";");

      if (val[0] && val[0] == +val[0]) {
        val[0] = +val[0];
      }

      if (val[1] && val[1] == +val[1]) {
        val[1] = +val[1];
      }

      if (options && options.values && options.values.length) {
        config.from = val[0] && options.values.indexOf(val[0]);
        config.to = val[1] && options.values.indexOf(val[1]);
      } else {
        config.from = val[0] && +val[0];
        config.to = val[1] && +val[1];
      }
    } // js config extends default config


    $.extend(config, options); // data config extends config

    $.extend(config, config_from_data);
    this.options = config; // validate config, to be sure that all data types are correct

    this.update_check = {};
    this.validate(); // default result object, returned to callbacks

    this.result = {
      input: this.$cache.input,
      slider: null,
      min: this.options.min,
      max: this.options.max,
      from: this.options.from,
      from_percent: 0,
      from_value: null,
      to: this.options.to,
      to_percent: 0,
      to_value: null
    };
    this.init();
  };

  IonRangeSlider.prototype = {
    /**
     * Starts or updates the plugin instance
     *
     * @param [is_update] {boolean}
     */
    init: function init(is_update) {
      this.no_diapason = false;
      this.coords.p_step = this.convertToPercent(this.options.step, true);
      this.target = "base";
      this.toggleInput();
      this.append();
      this.setMinMax();

      if (is_update) {
        this.force_redraw = true;
        this.calc(true); // callbacks called

        this.callOnUpdate();
      } else {
        this.force_redraw = true;
        this.calc(true); // callbacks called

        this.callOnStart();
      }

      this.updateScene();
    },

    /**
     * Appends slider template to a DOM
     */
    append: function append() {
      var container_html = '<span class="irs js-irs-' + this.plugin_count + '"></span>';
      this.$cache.input.before(container_html);
      this.$cache.input.prop("readonly", true);
      this.$cache.cont = this.$cache.input.prev();
      this.result.slider = this.$cache.cont;
      this.$cache.cont.html(base_html);
      this.$cache.rs = this.$cache.cont.find(".irs");
      this.$cache.min = this.$cache.cont.find(".irs-min");
      this.$cache.max = this.$cache.cont.find(".irs-max");
      this.$cache.from = this.$cache.cont.find(".irs-from");
      this.$cache.to = this.$cache.cont.find(".irs-to");
      this.$cache.single = this.$cache.cont.find(".irs-single");
      this.$cache.bar = this.$cache.cont.find(".irs-bar");
      this.$cache.line = this.$cache.cont.find(".irs-line");
      this.$cache.grid = this.$cache.cont.find(".irs-grid");

      if (this.options.type === "single") {
        this.$cache.cont.append(single_html);
        this.$cache.edge = this.$cache.cont.find(".irs-bar-edge");
        this.$cache.s_single = this.$cache.cont.find(".single");
        this.$cache.from[0].style.visibility = "hidden";
        this.$cache.to[0].style.visibility = "hidden";
        this.$cache.shad_single = this.$cache.cont.find(".shadow-single");
      } else {
        this.$cache.cont.append(double_html);
        this.$cache.s_from = this.$cache.cont.find(".from");
        this.$cache.s_to = this.$cache.cont.find(".to");
        this.$cache.shad_from = this.$cache.cont.find(".shadow-from");
        this.$cache.shad_to = this.$cache.cont.find(".shadow-to");
        this.setTopHandler();
      }

      if (this.options.hide_from_to) {
        this.$cache.from[0].style.display = "none";
        this.$cache.to[0].style.display = "none";
        this.$cache.single[0].style.display = "none";
      }

      this.appendGrid();

      if (this.options.disable) {
        this.appendDisableMask();
        this.$cache.input[0].disabled = true;
      } else {
        this.$cache.cont.removeClass("irs-disabled");
        this.$cache.input[0].disabled = false;
        this.bindEvents();
      }

      if (this.options.drag_interval) {
        this.$cache.bar[0].style.cursor = "ew-resize";
      }
    },

    /**
     * Determine which handler has a priority
     * works only for double slider type
     */
    setTopHandler: function setTopHandler() {
      var min = this.options.min,
          max = this.options.max,
          from = this.options.from,
          to = this.options.to;

      if (from > min && to === max) {
        this.$cache.s_from.addClass("type_last");
      } else if (to < max) {
        this.$cache.s_to.addClass("type_last");
      }
    },

    /**
     * Determine which handles was clicked last
     * and which handler should have hover effect
     *
     * @param target {String}
     */
    changeLevel: function changeLevel(target) {
      switch (target) {
        case "single":
          this.coords.p_gap = this.toFixed(this.coords.p_pointer - this.coords.p_single_fake);
          break;

        case "from":
          this.coords.p_gap = this.toFixed(this.coords.p_pointer - this.coords.p_from_fake);
          this.$cache.s_from.addClass("state_hover");
          this.$cache.s_from.addClass("type_last");
          this.$cache.s_to.removeClass("type_last");
          break;

        case "to":
          this.coords.p_gap = this.toFixed(this.coords.p_pointer - this.coords.p_to_fake);
          this.$cache.s_to.addClass("state_hover");
          this.$cache.s_to.addClass("type_last");
          this.$cache.s_from.removeClass("type_last");
          break;

        case "both":
          this.coords.p_gap_left = this.toFixed(this.coords.p_pointer - this.coords.p_from_fake);
          this.coords.p_gap_right = this.toFixed(this.coords.p_to_fake - this.coords.p_pointer);
          this.$cache.s_to.removeClass("type_last");
          this.$cache.s_from.removeClass("type_last");
          break;
      }
    },

    /**
     * Then slider is disabled
     * appends extra layer with opacity
     */
    appendDisableMask: function appendDisableMask() {
      this.$cache.cont.append(disable_html);
      this.$cache.cont.addClass("irs-disabled");
    },

    /**
     * Remove slider instance
     * and ubind all events
     */
    remove: function remove() {
      this.$cache.cont.remove();
      this.$cache.cont = null;
      this.$cache.line.off("keydown.irs_" + this.plugin_count);
      this.$cache.body.off("touchmove.irs_" + this.plugin_count);
      this.$cache.body.off("mousemove.irs_" + this.plugin_count);
      this.$cache.win.off("touchend.irs_" + this.plugin_count);
      this.$cache.win.off("mouseup.irs_" + this.plugin_count);

      if (is_old_ie) {
        this.$cache.body.off("mouseup.irs_" + this.plugin_count);
        this.$cache.body.off("mouseleave.irs_" + this.plugin_count);
      }

      this.$cache.grid_labels = [];
      this.coords.big = [];
      this.coords.big_w = [];
      this.coords.big_p = [];
      this.coords.big_x = [];
      cancelAnimationFrame(this.raf_id);
    },

    /**
     * bind all slider events
     */
    bindEvents: function bindEvents() {
      if (this.no_diapason) {
        return;
      }

      this.$cache.body.on("touchmove.irs_" + this.plugin_count, this.pointerMove.bind(this));
      this.$cache.body.on("mousemove.irs_" + this.plugin_count, this.pointerMove.bind(this));
      this.$cache.win.on("touchend.irs_" + this.plugin_count, this.pointerUp.bind(this));
      this.$cache.win.on("mouseup.irs_" + this.plugin_count, this.pointerUp.bind(this));
      this.$cache.line.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
      this.$cache.line.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));

      if (this.options.drag_interval && this.options.type === "double") {
        this.$cache.bar.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "both"));
        this.$cache.bar.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "both"));
      } else {
        this.$cache.bar.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
        this.$cache.bar.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
      }

      if (this.options.type === "single") {
        this.$cache.single.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "single"));
        this.$cache.s_single.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "single"));
        this.$cache.shad_single.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
        this.$cache.single.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "single"));
        this.$cache.s_single.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "single"));
        this.$cache.edge.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
        this.$cache.shad_single.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
      } else {
        this.$cache.single.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, null));
        this.$cache.single.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, null));
        this.$cache.from.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "from"));
        this.$cache.s_from.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "from"));
        this.$cache.to.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "to"));
        this.$cache.s_to.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "to"));
        this.$cache.shad_from.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
        this.$cache.shad_to.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
        this.$cache.from.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "from"));
        this.$cache.s_from.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "from"));
        this.$cache.to.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "to"));
        this.$cache.s_to.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "to"));
        this.$cache.shad_from.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
        this.$cache.shad_to.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
      }

      if (this.options.keyboard) {
        this.$cache.line.on("keydown.irs_" + this.plugin_count, this.key.bind(this, "keyboard"));
      }

      if (is_old_ie) {
        this.$cache.body.on("mouseup.irs_" + this.plugin_count, this.pointerUp.bind(this));
        this.$cache.body.on("mouseleave.irs_" + this.plugin_count, this.pointerUp.bind(this));
      }
    },

    /**
     * Mousemove or touchmove
     * only for handlers
     *
     * @param e {Object} event object
     */
    pointerMove: function pointerMove(e) {
      if (!this.dragging) {
        return;
      }

      var x = e.pageX || e.originalEvent.touches && e.originalEvent.touches[0].pageX;
      this.coords.x_pointer = x - this.coords.x_gap;
      this.calc();
    },

    /**
     * Mouseup or touchend
     * only for handlers
     *
     * @param e {Object} event object
     */
    pointerUp: function pointerUp(e) {
      if (this.current_plugin !== this.plugin_count) {
        return;
      }

      if (this.is_active) {
        this.is_active = false;
      } else {
        return;
      }

      this.$cache.cont.find(".state_hover").removeClass("state_hover");
      this.force_redraw = true;

      if (is_old_ie) {
        $("*").prop("unselectable", false);
      }

      this.updateScene();
      this.restoreOriginalMinInterval(); // callbacks call

      if ($.contains(this.$cache.cont[0], e.target) || this.dragging) {
        this.callOnFinish();
      }

      this.dragging = false;
    },

    /**
     * Mousedown or touchstart
     * only for handlers
     *
     * @param target {String|null}
     * @param e {Object} event object
     */
    pointerDown: function pointerDown(target, e) {
      e.preventDefault();
      var x = e.pageX || e.originalEvent.touches && e.originalEvent.touches[0].pageX;

      if (e.button === 2) {
        return;
      }

      if (target === "both") {
        this.setTempMinInterval();
      }

      if (!target) {
        target = this.target || "from";
      }

      this.current_plugin = this.plugin_count;
      this.target = target;
      this.is_active = true;
      this.dragging = true;
      this.coords.x_gap = this.$cache.rs.offset().left;
      this.coords.x_pointer = x - this.coords.x_gap;
      this.calcPointerPercent();
      this.changeLevel(target);

      if (is_old_ie) {
        $("*").prop("unselectable", true);
      }

      this.$cache.line.trigger("focus");
      this.updateScene();
    },

    /**
     * Mousedown or touchstart
     * for other slider elements, like diapason line
     *
     * @param target {String}
     * @param e {Object} event object
     */
    pointerClick: function pointerClick(target, e) {
      e.preventDefault();
      var x = e.pageX || e.originalEvent.touches && e.originalEvent.touches[0].pageX;

      if (e.button === 2) {
        return;
      }

      this.current_plugin = this.plugin_count;
      this.target = target;
      this.is_click = true;
      this.coords.x_gap = this.$cache.rs.offset().left;
      this.coords.x_pointer = +(x - this.coords.x_gap).toFixed();
      this.force_redraw = true;
      this.calc();
      this.$cache.line.trigger("focus");
    },

    /**
     * Keyborard controls for focused slider
     *
     * @param target {String}
     * @param e {Object} event object
     * @returns {boolean|undefined}
     */
    key: function key(target, e) {
      if (this.current_plugin !== this.plugin_count || e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) {
        return;
      }

      switch (e.which) {
        case 83: // W

        case 65: // A

        case 40: // DOWN

        case 37:
          // LEFT
          e.preventDefault();
          this.moveByKey(false);
          break;

        case 87: // S

        case 68: // D

        case 38: // UP

        case 39:
          // RIGHT
          e.preventDefault();
          this.moveByKey(true);
          break;
      }

      return true;
    },

    /**
     * Move by key. Beta
     * @todo refactor than have plenty of time
     *
     * @param right {boolean} direction to move
     */
    moveByKey: function moveByKey(right) {
      var p = this.coords.p_pointer;

      if (right) {
        p += this.options.keyboard_step;
      } else {
        p -= this.options.keyboard_step;
      }

      this.coords.x_pointer = this.toFixed(this.coords.w_rs / 100 * p);
      this.is_key = true;
      this.calc();
    },

    /**
     * Set visibility and content
     * of Min and Max labels
     */
    setMinMax: function setMinMax() {
      if (!this.options) {
        return;
      }

      if (this.options.hide_min_max) {
        this.$cache.min[0].style.display = "none";
        this.$cache.max[0].style.display = "none";
        return;
      }

      if (this.options.values.length) {
        this.$cache.min.html(this.decorate_minmax(this.options.p_values[this.options.min]));
        this.$cache.max.html(this.decorate_minmax(this.options.p_values[this.options.max]));
      } else {
        this.$cache.min.html(this.decorate_minmax(this._prettify(this.options.min), this.options.min));
        this.$cache.max.html(this.decorate_minmax(this._prettify(this.options.max), this.options.max));
      }

      this.labels.w_min = this.$cache.min.outerWidth(false);
      this.labels.w_max = this.$cache.max.outerWidth(false);
    },

    /**
     * Then dragging interval, prevent interval collapsing
     * using min_interval option
     */
    setTempMinInterval: function setTempMinInterval() {
      var interval = this.result.to - this.result.from;

      if (this.old_min_interval === null) {
        this.old_min_interval = this.options.min_interval;
      }

      this.options.min_interval = interval;
    },

    /**
     * Restore min_interval option to original
     */
    restoreOriginalMinInterval: function restoreOriginalMinInterval() {
      if (this.old_min_interval !== null) {
        this.options.min_interval = this.old_min_interval;
        this.old_min_interval = null;
      }
    },
    // =============================================================================================================
    // Calculations

    /**
     * All calculations and measures start here
     *
     * @param update {boolean=}
     */
    calc: function calc(update) {
      if (!this.options) {
        return;
      }

      this.calc_count++;

      if (this.calc_count === 10 || update) {
        this.calc_count = 0;
        this.coords.w_rs = this.$cache.rs.outerWidth(false);
        this.calcHandlePercent();
      }

      if (!this.coords.w_rs) {
        return;
      }

      this.calcPointerPercent();
      var handle_x = this.getHandleX();

      if (this.target === "both") {
        this.coords.p_gap = 0;
        handle_x = this.getHandleX();
      }

      if (this.target === "click") {
        this.coords.p_gap = this.coords.p_handle / 2;
        handle_x = this.getHandleX();

        if (this.options.drag_interval) {
          this.target = "both_one";
        } else {
          this.target = this.chooseHandle(handle_x);
        }
      }

      switch (this.target) {
        case "base":
          var w = (this.options.max - this.options.min) / 100,
              f = (this.result.from - this.options.min) / w,
              t = (this.result.to - this.options.min) / w;
          this.coords.p_single_real = this.toFixed(f);
          this.coords.p_from_real = this.toFixed(f);
          this.coords.p_to_real = this.toFixed(t);
          this.coords.p_single_real = this.checkDiapason(this.coords.p_single_real, this.options.from_min, this.options.from_max);
          this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max);
          this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max);
          this.coords.p_single_fake = this.convertToFakePercent(this.coords.p_single_real);
          this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real);
          this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);
          this.target = null;
          break;

        case "single":
          if (this.options.from_fixed) {
            break;
          }

          this.coords.p_single_real = this.convertToRealPercent(handle_x);
          this.coords.p_single_real = this.calcWithStep(this.coords.p_single_real);
          this.coords.p_single_real = this.checkDiapason(this.coords.p_single_real, this.options.from_min, this.options.from_max);
          this.coords.p_single_fake = this.convertToFakePercent(this.coords.p_single_real);
          break;

        case "from":
          if (this.options.from_fixed) {
            break;
          }

          this.coords.p_from_real = this.convertToRealPercent(handle_x);
          this.coords.p_from_real = this.calcWithStep(this.coords.p_from_real);

          if (this.coords.p_from_real > this.coords.p_to_real) {
            this.coords.p_from_real = this.coords.p_to_real;
          }

          this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max);
          this.coords.p_from_real = this.checkMinInterval(this.coords.p_from_real, this.coords.p_to_real, "from");
          this.coords.p_from_real = this.checkMaxInterval(this.coords.p_from_real, this.coords.p_to_real, "from");
          this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real);
          break;

        case "to":
          if (this.options.to_fixed) {
            break;
          }

          this.coords.p_to_real = this.convertToRealPercent(handle_x);
          this.coords.p_to_real = this.calcWithStep(this.coords.p_to_real);

          if (this.coords.p_to_real < this.coords.p_from_real) {
            this.coords.p_to_real = this.coords.p_from_real;
          }

          this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max);
          this.coords.p_to_real = this.checkMinInterval(this.coords.p_to_real, this.coords.p_from_real, "to");
          this.coords.p_to_real = this.checkMaxInterval(this.coords.p_to_real, this.coords.p_from_real, "to");
          this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);
          break;

        case "both":
          if (this.options.from_fixed || this.options.to_fixed) {
            break;
          }

          handle_x = this.toFixed(handle_x + this.coords.p_handle * 0.001);
          this.coords.p_from_real = this.convertToRealPercent(handle_x) - this.coords.p_gap_left;
          this.coords.p_from_real = this.calcWithStep(this.coords.p_from_real);
          this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max);
          this.coords.p_from_real = this.checkMinInterval(this.coords.p_from_real, this.coords.p_to_real, "from");
          this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real);
          this.coords.p_to_real = this.convertToRealPercent(handle_x) + this.coords.p_gap_right;
          this.coords.p_to_real = this.calcWithStep(this.coords.p_to_real);
          this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max);
          this.coords.p_to_real = this.checkMinInterval(this.coords.p_to_real, this.coords.p_from_real, "to");
          this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);
          break;

        case "both_one":
          if (this.options.from_fixed || this.options.to_fixed) {
            break;
          }

          var real_x = this.convertToRealPercent(handle_x),
              from = this.result.from_percent,
              to = this.result.to_percent,
              full = to - from,
              half = full / 2,
              new_from = real_x - half,
              new_to = real_x + half;

          if (new_from < 0) {
            new_from = 0;
            new_to = new_from + full;
          }

          if (new_to > 100) {
            new_to = 100;
            new_from = new_to - full;
          }

          this.coords.p_from_real = this.calcWithStep(new_from);
          this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max);
          this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real);
          this.coords.p_to_real = this.calcWithStep(new_to);
          this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max);
          this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);
          break;
      }

      if (this.options.type === "single") {
        this.coords.p_bar_x = this.coords.p_handle / 2;
        this.coords.p_bar_w = this.coords.p_single_fake;
        this.result.from_percent = this.coords.p_single_real;
        this.result.from = this.convertToValue(this.coords.p_single_real);

        if (this.options.values.length) {
          this.result.from_value = this.options.values[this.result.from];
        }
      } else {
        this.coords.p_bar_x = this.toFixed(this.coords.p_from_fake + this.coords.p_handle / 2);
        this.coords.p_bar_w = this.toFixed(this.coords.p_to_fake - this.coords.p_from_fake);
        this.result.from_percent = this.coords.p_from_real;
        this.result.from = this.convertToValue(this.coords.p_from_real);
        this.result.to_percent = this.coords.p_to_real;
        this.result.to = this.convertToValue(this.coords.p_to_real);

        if (this.options.values.length) {
          this.result.from_value = this.options.values[this.result.from];
          this.result.to_value = this.options.values[this.result.to];
        }
      }

      this.calcMinMax();
      this.calcLabels();
    },

    /**
     * calculates pointer X in percent
     */
    calcPointerPercent: function calcPointerPercent() {
      if (!this.coords.w_rs) {
        this.coords.p_pointer = 0;
        return;
      }

      if (this.coords.x_pointer < 0 || isNaN(this.coords.x_pointer)) {
        this.coords.x_pointer = 0;
      } else if (this.coords.x_pointer > this.coords.w_rs) {
        this.coords.x_pointer = this.coords.w_rs;
      }

      this.coords.p_pointer = this.toFixed(this.coords.x_pointer / this.coords.w_rs * 100);
    },
    convertToRealPercent: function convertToRealPercent(fake) {
      var full = 100 - this.coords.p_handle;
      return fake / full * 100;
    },
    convertToFakePercent: function convertToFakePercent(real) {
      var full = 100 - this.coords.p_handle;
      return real / 100 * full;
    },
    getHandleX: function getHandleX() {
      var max = 100 - this.coords.p_handle,
          x = this.toFixed(this.coords.p_pointer - this.coords.p_gap);

      if (x < 0) {
        x = 0;
      } else if (x > max) {
        x = max;
      }

      return x;
    },
    calcHandlePercent: function calcHandlePercent() {
      if (this.options.type === "single") {
        this.coords.w_handle = this.$cache.s_single.outerWidth(false);
      } else {
        this.coords.w_handle = this.$cache.s_from.outerWidth(false);
      }

      this.coords.p_handle = this.toFixed(this.coords.w_handle / this.coords.w_rs * 100);
    },

    /**
     * Find closest handle to pointer click
     *
     * @param real_x {Number}
     * @returns {String}
     */
    chooseHandle: function chooseHandle(real_x) {
      if (this.options.type === "single") {
        return "single";
      } else {
        var m_point = this.coords.p_from_real + (this.coords.p_to_real - this.coords.p_from_real) / 2;

        if (real_x >= m_point) {
          return this.options.to_fixed ? "from" : "to";
        } else {
          return this.options.from_fixed ? "to" : "from";
        }
      }
    },

    /**
     * Measure Min and Max labels width in percent
     */
    calcMinMax: function calcMinMax() {
      if (!this.coords.w_rs) {
        return;
      }

      this.labels.p_min = this.labels.w_min / this.coords.w_rs * 100;
      this.labels.p_max = this.labels.w_max / this.coords.w_rs * 100;
    },

    /**
     * Measure labels width and X in percent
     */
    calcLabels: function calcLabels() {
      if (!this.coords.w_rs || this.options.hide_from_to) {
        return;
      }

      if (this.options.type === "single") {
        this.labels.w_single = this.$cache.single.outerWidth(false);
        this.labels.p_single_fake = this.labels.w_single / this.coords.w_rs * 100;
        this.labels.p_single_left = this.coords.p_single_fake + this.coords.p_handle / 2 - this.labels.p_single_fake / 2;
        this.labels.p_single_left = this.checkEdges(this.labels.p_single_left, this.labels.p_single_fake);
      } else {
        this.labels.w_from = this.$cache.from.outerWidth(false);
        this.labels.p_from_fake = this.labels.w_from / this.coords.w_rs * 100;
        this.labels.p_from_left = this.coords.p_from_fake + this.coords.p_handle / 2 - this.labels.p_from_fake / 2;
        this.labels.p_from_left = this.toFixed(this.labels.p_from_left);
        this.labels.p_from_left = this.checkEdges(this.labels.p_from_left, this.labels.p_from_fake);
        this.labels.w_to = this.$cache.to.outerWidth(false);
        this.labels.p_to_fake = this.labels.w_to / this.coords.w_rs * 100;
        this.labels.p_to_left = this.coords.p_to_fake + this.coords.p_handle / 2 - this.labels.p_to_fake / 2;
        this.labels.p_to_left = this.toFixed(this.labels.p_to_left);
        this.labels.p_to_left = this.checkEdges(this.labels.p_to_left, this.labels.p_to_fake);
        this.labels.w_single = this.$cache.single.outerWidth(false);
        this.labels.p_single_fake = this.labels.w_single / this.coords.w_rs * 100;
        this.labels.p_single_left = (this.labels.p_from_left + this.labels.p_to_left + this.labels.p_to_fake) / 2 - this.labels.p_single_fake / 2;
        this.labels.p_single_left = this.toFixed(this.labels.p_single_left);
        this.labels.p_single_left = this.checkEdges(this.labels.p_single_left, this.labels.p_single_fake);
      }
    },
    // =============================================================================================================
    // Drawings

    /**
     * Main function called in request animation frame
     * to update everything
     */
    updateScene: function updateScene() {
      if (this.raf_id) {
        cancelAnimationFrame(this.raf_id);
        this.raf_id = null;
      }

      clearTimeout(this.update_tm);
      this.update_tm = null;

      if (!this.options) {
        return;
      }

      this.drawHandles();

      if (this.is_active) {
        this.raf_id = requestAnimationFrame(this.updateScene.bind(this));
      } else {
        this.update_tm = setTimeout(this.updateScene.bind(this), 300);
      }
    },

    /**
     * Draw handles
     */
    drawHandles: function drawHandles() {
      this.coords.w_rs = this.$cache.rs.outerWidth(false);

      if (!this.coords.w_rs) {
        return;
      }

      if (this.coords.w_rs !== this.coords.w_rs_old) {
        this.target = "base";
        this.is_resize = true;
      }

      if (this.coords.w_rs !== this.coords.w_rs_old || this.force_redraw) {
        this.setMinMax();
        this.calc(true);
        this.drawLabels();

        if (this.options.grid) {
          this.calcGridMargin();
          this.calcGridLabels();
        }

        this.force_redraw = true;
        this.coords.w_rs_old = this.coords.w_rs;
        this.drawShadow();
      }

      if (!this.coords.w_rs) {
        return;
      }

      if (!this.dragging && !this.force_redraw && !this.is_key) {
        return;
      }

      if (this.old_from !== this.result.from || this.old_to !== this.result.to || this.force_redraw || this.is_key) {
        this.drawLabels();
        this.$cache.bar[0].style.left = this.coords.p_bar_x + "%";
        this.$cache.bar[0].style.width = this.coords.p_bar_w + "%";

        if (this.options.type === "single") {
          this.$cache.s_single[0].style.left = this.coords.p_single_fake + "%";
          this.$cache.single[0].style.left = this.labels.p_single_left + "%";
        } else {
          this.$cache.s_from[0].style.left = this.coords.p_from_fake + "%";
          this.$cache.s_to[0].style.left = this.coords.p_to_fake + "%";

          if (this.old_from !== this.result.from || this.force_redraw) {
            this.$cache.from[0].style.left = this.labels.p_from_left + "%";
          }

          if (this.old_to !== this.result.to || this.force_redraw) {
            this.$cache.to[0].style.left = this.labels.p_to_left + "%";
          }

          this.$cache.single[0].style.left = this.labels.p_single_left + "%";
        }

        this.writeToInput();

        if ((this.old_from !== this.result.from || this.old_to !== this.result.to) && !this.is_start) {
          this.$cache.input.trigger("change");
          this.$cache.input.trigger("input");
        }

        this.old_from = this.result.from;
        this.old_to = this.result.to; // callbacks call

        if (!this.is_resize && !this.is_update && !this.is_start && !this.is_finish) {
          this.callOnChange();
        }

        if (this.is_key || this.is_click) {
          this.is_key = false;
          this.is_click = false;
          this.callOnFinish();
        }

        this.is_update = false;
        this.is_resize = false;
        this.is_finish = false;
      }

      this.is_start = false;
      this.is_key = false;
      this.is_click = false;
      this.force_redraw = false;
    },

    /**
     * Draw labels
     * measure labels collisions
     * collapse close labels
     */
    drawLabels: function drawLabels() {
      if (!this.options) {
        return;
      }

      var values_num = this.options.values.length,
          p_values = this.options.p_values,
          text_single,
          text_from,
          text_to;

      if (this.options.hide_from_to) {
        return;
      }

      if (this.options.type === "single") {
        if (values_num) {
          text_single = this.decorate(p_values[this.result.from]);
          this.$cache.single.html(text_single);
        } else {
          text_single = this.decorate(this._prettify(this.result.from), this.result.from);
          this.$cache.single.html(text_single);
        }

        this.calcLabels();

        if (this.labels.p_single_left < this.labels.p_min + 1) {
          this.$cache.min[0].style.visibility = "hidden";
        } else {
          this.$cache.min[0].style.visibility = "visible";
        }

        if (this.labels.p_single_left + this.labels.p_single_fake > 100 - this.labels.p_max - 1) {
          this.$cache.max[0].style.visibility = "hidden";
        } else {
          this.$cache.max[0].style.visibility = "visible";
        }
      } else {
        if (values_num) {
          if (this.options.decorate_both) {
            text_single = this.decorate(p_values[this.result.from]);
            text_single += this.options.values_separator;
            text_single += this.decorate(p_values[this.result.to]);
          } else {
            text_single = this.decorate(p_values[this.result.from] + this.options.values_separator + p_values[this.result.to]);
          }

          text_from = this.decorate(p_values[this.result.from]);
          text_to = this.decorate(p_values[this.result.to]);
          this.$cache.single.html(text_single);
          this.$cache.from.html(text_from);
          this.$cache.to.html(text_to);
        } else {
          if (this.options.decorate_both) {
            text_single = this.decorate(this._prettify(this.result.from), this.result.from);
            text_single += this.options.values_separator;
            text_single += this.decorate(this._prettify(this.result.to), this.result.to);
          } else {
            text_single = this.decorate(this._prettify(this.result.from) + this.options.values_separator + this._prettify(this.result.to), this.result.to);
          }

          text_from = this.decorate(this._prettify(this.result.from), this.result.from);
          text_to = this.decorate(this._prettify(this.result.to), this.result.to);
          this.$cache.single.html(text_single);
          this.$cache.from.html(text_from);
          this.$cache.to.html(text_to);
        }

        this.calcLabels();
        var min = Math.min(this.labels.p_single_left, this.labels.p_from_left),
            single_left = this.labels.p_single_left + this.labels.p_single_fake,
            to_left = this.labels.p_to_left + this.labels.p_to_fake,
            max = Math.max(single_left, to_left);

        if (this.labels.p_from_left + this.labels.p_from_fake >= this.labels.p_to_left) {
          this.$cache.from[0].style.visibility = "hidden";
          this.$cache.to[0].style.visibility = "hidden";
          this.$cache.single[0].style.visibility = "visible";

          if (this.result.from === this.result.to) {
            if (this.target === "from") {
              this.$cache.from[0].style.visibility = "visible";
            } else if (this.target === "to") {
              this.$cache.to[0].style.visibility = "visible";
            } else if (!this.target) {
              this.$cache.from[0].style.visibility = "visible";
            }

            this.$cache.single[0].style.visibility = "hidden";
            max = to_left;
          } else {
            this.$cache.from[0].style.visibility = "hidden";
            this.$cache.to[0].style.visibility = "hidden";
            this.$cache.single[0].style.visibility = "visible";
            max = Math.max(single_left, to_left);
          }
        } else {
          this.$cache.from[0].style.visibility = "visible";
          this.$cache.to[0].style.visibility = "visible";
          this.$cache.single[0].style.visibility = "hidden";
        }

        if (min < this.labels.p_min + 1) {
          this.$cache.min[0].style.visibility = "hidden";
        } else {
          this.$cache.min[0].style.visibility = "visible";
        }

        if (max > 100 - this.labels.p_max - 1) {
          this.$cache.max[0].style.visibility = "hidden";
        } else {
          this.$cache.max[0].style.visibility = "visible";
        }
      }
    },

    /**
     * Draw shadow intervals
     */
    drawShadow: function drawShadow() {
      var o = this.options,
          c = this.$cache,
          is_from_min = typeof o.from_min === "number" && !isNaN(o.from_min),
          is_from_max = typeof o.from_max === "number" && !isNaN(o.from_max),
          is_to_min = typeof o.to_min === "number" && !isNaN(o.to_min),
          is_to_max = typeof o.to_max === "number" && !isNaN(o.to_max),
          from_min,
          from_max,
          to_min,
          to_max;

      if (o.type === "single") {
        if (o.from_shadow && (is_from_min || is_from_max)) {
          from_min = this.convertToPercent(is_from_min ? o.from_min : o.min);
          from_max = this.convertToPercent(is_from_max ? o.from_max : o.max) - from_min;
          from_min = this.toFixed(from_min - this.coords.p_handle / 100 * from_min);
          from_max = this.toFixed(from_max - this.coords.p_handle / 100 * from_max);
          from_min = from_min + this.coords.p_handle / 2;
          c.shad_single[0].style.display = "block";
          c.shad_single[0].style.left = from_min + "%";
          c.shad_single[0].style.width = from_max + "%";
        } else {
          c.shad_single[0].style.display = "none";
        }
      } else {
        if (o.from_shadow && (is_from_min || is_from_max)) {
          from_min = this.convertToPercent(is_from_min ? o.from_min : o.min);
          from_max = this.convertToPercent(is_from_max ? o.from_max : o.max) - from_min;
          from_min = this.toFixed(from_min - this.coords.p_handle / 100 * from_min);
          from_max = this.toFixed(from_max - this.coords.p_handle / 100 * from_max);
          from_min = from_min + this.coords.p_handle / 2;
          c.shad_from[0].style.display = "block";
          c.shad_from[0].style.left = from_min + "%";
          c.shad_from[0].style.width = from_max + "%";
        } else {
          c.shad_from[0].style.display = "none";
        }

        if (o.to_shadow && (is_to_min || is_to_max)) {
          to_min = this.convertToPercent(is_to_min ? o.to_min : o.min);
          to_max = this.convertToPercent(is_to_max ? o.to_max : o.max) - to_min;
          to_min = this.toFixed(to_min - this.coords.p_handle / 100 * to_min);
          to_max = this.toFixed(to_max - this.coords.p_handle / 100 * to_max);
          to_min = to_min + this.coords.p_handle / 2;
          c.shad_to[0].style.display = "block";
          c.shad_to[0].style.left = to_min + "%";
          c.shad_to[0].style.width = to_max + "%";
        } else {
          c.shad_to[0].style.display = "none";
        }
      }
    },

    /**
     * Write values to input element
     */
    writeToInput: function writeToInput() {
      if (this.options.type === "single") {
        if (this.options.values.length) {
          this.$cache.input.prop("value", this.result.from_value);
        } else {
          this.$cache.input.prop("value", this.result.from);
        }

        this.$cache.input.data("from", this.result.from);
      } else {
        if (this.options.values.length) {
          this.$cache.input.prop("value", this.result.from_value + this.options.input_values_separator + this.result.to_value);
        } else {
          this.$cache.input.prop("value", this.result.from + this.options.input_values_separator + this.result.to);
        }

        this.$cache.input.data("from", this.result.from);
        this.$cache.input.data("to", this.result.to);
      }
    },
    // =============================================================================================================
    // Callbacks
    callOnStart: function callOnStart() {
      this.writeToInput();

      if (this.options.onStart && typeof this.options.onStart === "function") {
        this.options.onStart(this.result);
      }
    },
    callOnChange: function callOnChange() {
      this.writeToInput();

      if (this.options.onChange && typeof this.options.onChange === "function") {
        this.options.onChange(this.result);
      }
    },
    callOnFinish: function callOnFinish() {
      this.writeToInput();

      if (this.options.onFinish && typeof this.options.onFinish === "function") {
        this.options.onFinish(this.result);
      }
    },
    callOnUpdate: function callOnUpdate() {
      this.writeToInput();

      if (this.options.onUpdate && typeof this.options.onUpdate === "function") {
        this.options.onUpdate(this.result);
      }
    },
    // =============================================================================================================
    // Service methods
    toggleInput: function toggleInput() {
      this.$cache.input.toggleClass("irs-hidden-input");
    },

    /**
     * Convert real value to percent
     *
     * @param value {Number} X in real
     * @param no_min {boolean=} don't use min value
     * @returns {Number} X in percent
     */
    convertToPercent: function convertToPercent(value, no_min) {
      var diapason = this.options.max - this.options.min,
          one_percent = diapason / 100,
          val,
          percent;

      if (!diapason) {
        this.no_diapason = true;
        return 0;
      }

      if (no_min) {
        val = value;
      } else {
        val = value - this.options.min;
      }

      percent = val / one_percent;
      return this.toFixed(percent);
    },

    /**
     * Convert percent to real values
     *
     * @param percent {Number} X in percent
     * @returns {Number} X in real
     */
    convertToValue: function convertToValue(percent) {
      var min = this.options.min,
          max = this.options.max,
          min_decimals = min.toString().split(".")[1],
          max_decimals = max.toString().split(".")[1],
          min_length,
          max_length,
          avg_decimals = 0,
          abs = 0;

      if (percent === 0) {
        return this.options.min;
      }

      if (percent === 100) {
        return this.options.max;
      }

      if (min_decimals) {
        min_length = min_decimals.length;
        avg_decimals = min_length;
      }

      if (max_decimals) {
        max_length = max_decimals.length;
        avg_decimals = max_length;
      }

      if (min_length && max_length) {
        avg_decimals = min_length >= max_length ? min_length : max_length;
      }

      if (min < 0) {
        abs = Math.abs(min);
        min = +(min + abs).toFixed(avg_decimals);
        max = +(max + abs).toFixed(avg_decimals);
      }

      var number = (max - min) / 100 * percent + min,
          string = this.options.step.toString().split(".")[1],
          result;

      if (string) {
        number = +number.toFixed(string.length);
      } else {
        number = number / this.options.step;
        number = number * this.options.step;
        number = +number.toFixed(0);
      }

      if (abs) {
        number -= abs;
      }

      if (string) {
        result = +number.toFixed(string.length);
      } else {
        result = this.toFixed(number);
      }

      if (result < this.options.min) {
        result = this.options.min;
      } else if (result > this.options.max) {
        result = this.options.max;
      }

      return result;
    },

    /**
     * Round percent value with step
     *
     * @param percent {Number}
     * @returns percent {Number} rounded
     */
    calcWithStep: function calcWithStep(percent) {
      var rounded = Math.round(percent / this.coords.p_step) * this.coords.p_step;

      if (rounded > 100) {
        rounded = 100;
      }

      if (percent === 100) {
        rounded = 100;
      }

      return this.toFixed(rounded);
    },
    checkMinInterval: function checkMinInterval(p_current, p_next, type) {
      var o = this.options,
          current,
          next;

      if (!o.min_interval) {
        return p_current;
      }

      current = this.convertToValue(p_current);
      next = this.convertToValue(p_next);

      if (type === "from") {
        if (next - current < o.min_interval) {
          current = next - o.min_interval;
        }
      } else {
        if (current - next < o.min_interval) {
          current = next + o.min_interval;
        }
      }

      return this.convertToPercent(current);
    },
    checkMaxInterval: function checkMaxInterval(p_current, p_next, type) {
      var o = this.options,
          current,
          next;

      if (!o.max_interval) {
        return p_current;
      }

      current = this.convertToValue(p_current);
      next = this.convertToValue(p_next);

      if (type === "from") {
        if (next - current > o.max_interval) {
          current = next - o.max_interval;
        }
      } else {
        if (current - next > o.max_interval) {
          current = next + o.max_interval;
        }
      }

      return this.convertToPercent(current);
    },
    checkDiapason: function checkDiapason(p_num, min, max) {
      var num = this.convertToValue(p_num),
          o = this.options;

      if (typeof min !== "number") {
        min = o.min;
      }

      if (typeof max !== "number") {
        max = o.max;
      }

      if (num < min) {
        num = min;
      }

      if (num > max) {
        num = max;
      }

      return this.convertToPercent(num);
    },
    toFixed: function toFixed(num) {
      num = num.toFixed(20);
      return +num;
    },
    _prettify: function _prettify(num) {
      if (!this.options.prettify_enabled) {
        return num;
      }

      if (this.options.prettify && typeof this.options.prettify === "function") {
        return this.options.prettify(num);
      } else {
        return this.prettify(num);
      }
    },
    prettify: function prettify(num) {
      var n = num.toString();
      return n.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, "$1" + this.options.prettify_separator);
    },
    checkEdges: function checkEdges(left, width) {
      if (!this.options.force_edges) {
        return this.toFixed(left);
      }

      if (left < 0) {
        left = 0;
      } else if (left > 100 - width) {
        left = 100 - width;
      }

      return this.toFixed(left);
    },
    validate: function validate() {
      var o = this.options,
          r = this.result,
          v = o.values,
          vl = v.length,
          value,
          i;
      if (typeof o.min === "string") o.min = +o.min;
      if (typeof o.max === "string") o.max = +o.max;
      if (typeof o.from === "string") o.from = +o.from;
      if (typeof o.to === "string") o.to = +o.to;
      if (typeof o.step === "string") o.step = +o.step;
      if (typeof o.from_min === "string") o.from_min = +o.from_min;
      if (typeof o.from_max === "string") o.from_max = +o.from_max;
      if (typeof o.to_min === "string") o.to_min = +o.to_min;
      if (typeof o.to_max === "string") o.to_max = +o.to_max;
      if (typeof o.keyboard_step === "string") o.keyboard_step = +o.keyboard_step;
      if (typeof o.grid_num === "string") o.grid_num = +o.grid_num;

      if (o.max < o.min) {
        o.max = o.min;
      }

      if (vl) {
        o.p_values = [];
        o.min = 0;
        o.max = vl - 1;
        o.step = 1;
        o.grid_num = o.max;
        o.grid_snap = true;

        for (i = 0; i < vl; i++) {
          value = +v[i];

          if (!isNaN(value)) {
            v[i] = value;
            value = this._prettify(value);
          } else {
            value = v[i];
          }

          o.p_values.push(value);
        }
      }

      if (typeof o.from !== "number" || isNaN(o.from)) {
        o.from = o.min;
      }

      if (typeof o.to !== "number" || isNaN(o.to)) {
        o.to = o.max;
      }

      if (o.type === "single") {
        if (o.from < o.min) o.from = o.min;
        if (o.from > o.max) o.from = o.max;
      } else {
        if (o.from < o.min) o.from = o.min;
        if (o.from > o.max) o.from = o.max;
        if (o.to < o.min) o.to = o.min;
        if (o.to > o.max) o.to = o.max;

        if (this.update_check.from) {
          if (this.update_check.from !== o.from) {
            if (o.from > o.to) o.from = o.to;
          }

          if (this.update_check.to !== o.to) {
            if (o.to < o.from) o.to = o.from;
          }
        }

        if (o.from > o.to) o.from = o.to;
        if (o.to < o.from) o.to = o.from;
      }

      if (typeof o.step !== "number" || isNaN(o.step) || !o.step || o.step < 0) {
        o.step = 1;
      }

      if (typeof o.keyboard_step !== "number" || isNaN(o.keyboard_step) || !o.keyboard_step || o.keyboard_step < 0) {
        o.keyboard_step = 5;
      }

      if (typeof o.from_min === "number" && o.from < o.from_min) {
        o.from = o.from_min;
      }

      if (typeof o.from_max === "number" && o.from > o.from_max) {
        o.from = o.from_max;
      }

      if (typeof o.to_min === "number" && o.to < o.to_min) {
        o.to = o.to_min;
      }

      if (typeof o.to_max === "number" && o.from > o.to_max) {
        o.to = o.to_max;
      }

      if (r) {
        if (r.min !== o.min) {
          r.min = o.min;
        }

        if (r.max !== o.max) {
          r.max = o.max;
        }

        if (r.from < r.min || r.from > r.max) {
          r.from = o.from;
        }

        if (r.to < r.min || r.to > r.max) {
          r.to = o.to;
        }
      }

      if (typeof o.min_interval !== "number" || isNaN(o.min_interval) || !o.min_interval || o.min_interval < 0) {
        o.min_interval = 0;
      }

      if (typeof o.max_interval !== "number" || isNaN(o.max_interval) || !o.max_interval || o.max_interval < 0) {
        o.max_interval = 0;
      }

      if (o.min_interval && o.min_interval > o.max - o.min) {
        o.min_interval = o.max - o.min;
      }

      if (o.max_interval && o.max_interval > o.max - o.min) {
        o.max_interval = o.max - o.min;
      }
    },
    decorate: function decorate(num, original) {
      var decorated = "",
          o = this.options;

      if (o.prefix) {
        decorated += o.prefix;
      }

      decorated += num;

      if (o.max_postfix) {
        if (o.values.length && num === o.p_values[o.max]) {
          decorated += o.max_postfix;

          if (o.postfix) {
            decorated += " ";
          }
        } else if (original === o.max) {
          decorated += o.max_postfix;

          if (o.postfix) {
            decorated += " ";
          }
        }
      }

      if (o.postfix) {
        decorated += o.postfix;
      }

      return decorated;
    },
    decorate_minmax: function decorate_minmax(num, original) {
      var decorated = "",
          o = this.options;

      if (o.prefix_minmax) {
        decorated += o.prefix_minmax;
      }

      decorated += num;

      if (o.postfix_minmax) {
        decorated += o.postfix_minmax;
      }

      return decorated;
    },
    updateFrom: function updateFrom() {
      this.result.from = this.options.from;
      this.result.from_percent = this.convertToPercent(this.result.from);

      if (this.options.values) {
        this.result.from_value = this.options.values[this.result.from];
      }
    },
    updateTo: function updateTo() {
      this.result.to = this.options.to;
      this.result.to_percent = this.convertToPercent(this.result.to);

      if (this.options.values) {
        this.result.to_value = this.options.values[this.result.to];
      }
    },
    updateResult: function updateResult() {
      this.result.min = this.options.min;
      this.result.max = this.options.max;
      this.updateFrom();
      this.updateTo();
    },
    // =============================================================================================================
    // Grid
    appendGrid: function appendGrid() {
      if (!this.options.grid) {
        return;
      }

      var o = this.options,
          i,
          z,
          total = o.max - o.min,
          big_num = o.grid_num,
          big_p = 0,
          big_w = 0,
          small_max = 4,
          local_small_max,
          small_p,
          small_w = 0,
          result,
          html = '';
      this.calcGridMargin();

      if (o.grid_snap) {
        if (total > 50) {
          big_num = 50 / o.step;
          big_p = this.toFixed(o.step / 0.5);
        } else {
          big_num = total / o.step;
          big_p = this.toFixed(o.step / (total / 100));
        }
      } else {
        big_p = this.toFixed(100 / big_num);
      }

      if (big_num > 4) {
        small_max = 3;
      }

      if (big_num > 7) {
        small_max = 2;
      }

      if (big_num > 14) {
        small_max = 1;
      }

      if (big_num > 28) {
        small_max = 0;
      }

      for (i = 0; i < big_num + 1; i++) {
        local_small_max = small_max;
        big_w = this.toFixed(big_p * i);

        if (big_w > 100) {
          big_w = 100;
          local_small_max -= 2;

          if (local_small_max < 0) {
            local_small_max = 0;
          }
        }

        this.coords.big[i] = big_w;
        small_p = (big_w - big_p * (i - 1)) / (local_small_max + 1);

        for (z = 1; z <= local_small_max; z++) {
          if (big_w === 0) {
            break;
          }

          small_w = this.toFixed(big_w - small_p * z);
          html += '<span class="irs-grid-pol small" style="left: ' + small_w + '%"></span>';
        }

        html += '<span class="irs-grid-pol" style="left: ' + big_w + '%"></span>';
        result = this.convertToValue(big_w);

        if (o.values.length) {
          result = o.p_values[result];
        } else {
          result = this._prettify(result);
        }

        html += '<span class="irs-grid-text js-grid-text-' + i + '" style="left: ' + big_w + '%">' + result + '</span>';
      }

      this.coords.big_num = Math.ceil(big_num + 1);
      this.$cache.cont.addClass("irs-with-grid");
      this.$cache.grid.html(html);
      this.cacheGridLabels();
    },
    cacheGridLabels: function cacheGridLabels() {
      var $label,
          i,
          num = this.coords.big_num;

      for (i = 0; i < num; i++) {
        $label = this.$cache.grid.find(".js-grid-text-" + i);
        this.$cache.grid_labels.push($label);
      }

      this.calcGridLabels();
    },
    calcGridLabels: function calcGridLabels() {
      var i,
          label,
          start = [],
          finish = [],
          num = this.coords.big_num;

      for (i = 0; i < num; i++) {
        this.coords.big_w[i] = this.$cache.grid_labels[i].outerWidth(false);
        this.coords.big_p[i] = this.toFixed(this.coords.big_w[i] / this.coords.w_rs * 100);
        this.coords.big_x[i] = this.toFixed(this.coords.big_p[i] / 2);
        start[i] = this.toFixed(this.coords.big[i] - this.coords.big_x[i]);
        finish[i] = this.toFixed(start[i] + this.coords.big_p[i]);
      }

      if (this.options.force_edges) {
        if (start[0] < -this.coords.grid_gap) {
          start[0] = -this.coords.grid_gap;
          finish[0] = this.toFixed(start[0] + this.coords.big_p[0]);
          this.coords.big_x[0] = this.coords.grid_gap;
        }

        if (finish[num - 1] > 100 + this.coords.grid_gap) {
          finish[num - 1] = 100 + this.coords.grid_gap;
          start[num - 1] = this.toFixed(finish[num - 1] - this.coords.big_p[num - 1]);
          this.coords.big_x[num - 1] = this.toFixed(this.coords.big_p[num - 1] - this.coords.grid_gap);
        }
      }

      this.calcGridCollision(2, start, finish);
      this.calcGridCollision(4, start, finish);

      for (i = 0; i < num; i++) {
        label = this.$cache.grid_labels[i][0];

        if (this.coords.big_x[i] !== Number.POSITIVE_INFINITY) {
          label.style.marginLeft = -this.coords.big_x[i] + "%";
        }
      }
    },
    // Collisions Calc Beta
    // TODO: Refactor then have plenty of time
    calcGridCollision: function calcGridCollision(step, start, finish) {
      var i,
          next_i,
          label,
          num = this.coords.big_num;

      for (i = 0; i < num; i += step) {
        next_i = i + step / 2;

        if (next_i >= num) {
          break;
        }

        label = this.$cache.grid_labels[next_i][0];

        if (finish[i] <= start[next_i]) {
          label.style.visibility = "visible";
        } else {
          label.style.visibility = "hidden";
        }
      }
    },
    calcGridMargin: function calcGridMargin() {
      if (!this.options.grid_margin) {
        return;
      }

      this.coords.w_rs = this.$cache.rs.outerWidth(false);

      if (!this.coords.w_rs) {
        return;
      }

      if (this.options.type === "single") {
        this.coords.w_handle = this.$cache.s_single.outerWidth(false);
      } else {
        this.coords.w_handle = this.$cache.s_from.outerWidth(false);
      }

      this.coords.p_handle = this.toFixed(this.coords.w_handle / this.coords.w_rs * 100);
      this.coords.grid_gap = this.toFixed(this.coords.p_handle / 2 - 0.1);
      this.$cache.grid[0].style.width = this.toFixed(100 - this.coords.p_handle) + "%";
      this.$cache.grid[0].style.left = this.coords.grid_gap + "%";
    },
    // =============================================================================================================
    // Public methods
    update: function update(options) {
      if (!this.input) {
        return;
      }

      this.is_update = true;
      this.options.from = this.result.from;
      this.options.to = this.result.to;
      this.update_check.from = this.result.from;
      this.update_check.to = this.result.to;
      this.options = $.extend(this.options, options);
      this.validate();
      this.updateResult(options);
      this.toggleInput();
      this.remove();
      this.init(true);
    },
    reset: function reset() {
      if (!this.input) {
        return;
      }

      this.updateResult();
      this.update();
    },
    destroy: function destroy() {
      if (!this.input) {
        return;
      }

      this.toggleInput();
      this.$cache.input.prop("readonly", false);
      $.data(this.input, "ionRangeSlider", null);
      this.remove();
      this.input = null;
      this.options = null;
    },
    addCustomElement: function addCustomElement(data) {
      var $customLabel = $('<span class="irs-to irs-custom ' + data.key + '">' + data.label + '</span>');
      var $customLine = $('<span class="irs-slider single irs-custom ' + data.key + '"></span>');
      var leftPerc = this.convertToPercent(data.value);
      if (leftPerc > 100) leftPerc = 100;
      var leftFakePerc = this.convertToFakePercent(leftPerc);
      $(this.result.slider).find('.irs-to').parent().prepend($customLabel);
      $(this.result.slider).find('.irs-slider').parent().prepend($customLine);
      $customLine.css('left', leftFakePerc + '%');
      $customLabel.css('left', 'calc(' + leftFakePerc + '% - ' + $customLabel.width() / 2 + 'px');

      if (data.showBar) {
        var $barEdge = $('<span class="irs-bar-edge irs-custom ' + data.key + '"/>');
        var $bar = $('<span class="irs-bar irs-custom ' + data.key + '"/>');
        $(this.result.slider).append($barEdge);
        $(this.result.slider).append($bar);
        $bar.css({
          width: leftFakePerc + '%',
          left: this.coords.p_bar_x + '%'
        });
      }
    }
  };

  $.fn.ionRangeSlider = function (options) {
    return this.each(function () {
      if (!$.data(this, "ionRangeSlider")) {
        $.data(this, "ionRangeSlider", new IonRangeSlider(this, options, plugin_count++));
      }
    });
  }; // =================================================================================================================
  // http://paulirish.com/2011/requestanimationframe-for-smart-animating/
  // http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
  // requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
  // MIT license


  (function () {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];

    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
      window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
      window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame) window.requestAnimationFrame = function (callback, element) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = window.setTimeout(function () {
        callback(currTime + timeToCall);
      }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
    if (!window.cancelAnimationFrame) window.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };
  })();
});

;

(function ($) {
  $.fn.counter = function (options) {
    var settings = $.extend({
      start: 0,
      end: 100,
      decimals: 0,
      easing: 'swing',
      duration: 400,
      thousandsSeparator: '.',
      decimalsSeparator: ',',
      parentSelector: '',
      removeNegativeSign: false,
      onUpdate: function onUpdate() {},
      onAfterUpdate: function onAfterUpdate() {}
    }, options);
    if (isNaN(settings.start)) settings.start = 0;
    if (isNaN(settings.end)) settings.end = 0;
    var $this = $(this);
    var $parent = settings.parentSelector != '' ? $this.closest(settings.parentSelector) : null;

    var getFormattedText = function getFormattedText(count) {
      var showCount = parseFloat(count);

      if (isNaN(showCount)) {
        showCount = 0;
      }

      showCount = showCount.toFixed(settings.decimals);
      var showCountParts = showCount.split('.');
      var number = showCountParts[0];
      var decimals = showCountParts[1];
      showCount = number.replace(/\B(?=(\d{3})+(?!\d))/g, settings.thousandsSeparator);

      if (settings.removeNegativeSign) {
        showCount = showCount.replace('-', '');
      }

      if (decimals != undefined) {
        showCount += '<span class="counter-separator">' + settings.decimalsSeparator + '</span><span class="counter-decimals">' + decimals + '</span>';
      }

      return showCount;
    };

    var setValue = function setValue(count) {
      var formattedText = getFormattedText(count);
      $this.data('counter-current', count).html(formattedText);

      if ($parent) {
        $parent.toggleClass('counter-positive', count > 0);
        $parent.toggleClass('counter-zero', count == 0);
        $parent.toggleClass('counter-negative', count < 0);
      }
    };

    $({
      count: settings.start
    }).stop(false, false).animate({
      count: settings.end
    }, {
      duration: settings.duration,
      easing: settings.easing,
      step: function step() {
        setValue(this.count);
        settings.onUpdate(this.count);
      },
      complete: function complete() {
        setValue(settings.end);
        settings.onAfterUpdate(settings.end);
      }
    });
  };
})(jQuery);

;

(function ($, window, document, undefined) {
  "use strict";

  var defaults = {
    resultsContainer: ".search-results",
    monitorSelector: "",
    searchUrl: "search.php",
    searchVar: null,
    searchField: null,
    searchData: [],
    onSearchStart: function onSearchStart() {},
    onSearchComplete: function onSearchComplete() {},
    ignoreEmpty: true
  };

  function quickSearch(element, options) {
    this.timeout = false;
    this.request = false;
    this.element = element;
    this.settings = $.extend({}, defaults, options);
    this.init();
  }

  $.extend(quickSearch.prototype, {
    init: function init() {
      this.$monitorElement = this.settings.monitorSelector == '' ? $(this.element) : $(this.element).find(this.settings.monitorSelector);

      if (this.$monitorElement.filter('select,input').length > 0) {
        this.$monitorElement = this.$monitorElement.filter('select,input');
      } else {
        this.$monitorElement = this.$monitorElement.find('select,input');
      }

      if (this.settings.searchVar === null) {
        this.settings.searchVar = $(this.element).attr('name');
      }

      if (this.settings.searchField === null) {
        this.settings.searchField = this.settings.monitorSelector == '' ? this.element : this.settings.monitorSelector;
      }

      this.loadResults();
      this.monitor();
    },
    monitor: function monitor() {
      var self = this;

      if (self.timeout != false) {
        clearTimeout(self.timeout);
      }

      this.$monitorElement.filter('input[type=text]').on('input', function () {
        self.timeout = setTimeout(self.loadResults(), 200);
      });
      this.$monitorElement.filter('input[type!=text]').on('change', function () {
        self.timeout = setTimeout(self.loadResults(), 200);
      });
    },
    loadResults: function loadResults() {
      var self = this;
      var searchVal = $(this.settings.searchField).val();
      var searchData = this.settings.searchData.slice(0);
      if (this.settings.ignoreEmpty && searchVal == '') return;

      if (typeof searchData == 'string') {
        searchData = $(searchData).serializeArray();
      }

      if (searchVal !== '') {
        searchData.push({
          name: this.settings.searchVar,
          value: searchVal
        });
      }

      if (typeof this.request.abort == 'function') {
        this.request.abort();
      }

      this.settings.onSearchStart();
      this.request = $.ajax({
        url: this.settings.searchUrl,
        data: searchData
      }).always(function (data) {
        $(self.settings.resultsContainer).html(data);
        self.settings.onSearchComplete();
      });
    }
  });

  $.fn['quickSearch'] = function (options) {
    return this.each(function () {
      if (!$.data(this, "quickSearch")) {
        $.data(this, "quickSearch", new quickSearch(this, options));
      }
    });
  };
})(jQuery, window, document);
/*!
 * roundSlider v1.6.1 | (c) 2015-2020, Soundar
 * MIT license | http://roundsliderui.com/licence.html
 */


(function (factory) {
  if (typeof define === 'function' && define.amd) {
    define(['jquery'], factory);
  } else if (typeof exports !== 'undefined') {
    factory(require('jquery'));
  } else {
    factory(jQuery);
  }
})(function ($) {
  "use strict";
  /*jslint nomen: true */

  var pluginName = "roundSlider"; // The plugin initialization

  $.fn[pluginName] = function (options) {
    return CreateRoundSlider.call(this, options, arguments);
  };

  RoundSlider.prototype = {
    pluginName: pluginName,
    version: "1.6.1",
    // after the control initialization the updated default values
    // are merged into the options
    options: {},
    // holds the current roundSlider element
    control: null,
    // default properties of the plugin. while add a new property,
    // that type should be included in the "_props:" for validation
    defaults: {
      min: 0,
      max: 100,
      step: 1,
      value: null,
      radius: 85,
      width: 18,
      handleSize: "+0",
      startAngle: 0,
      endAngle: "+360",
      animation: true,
      showTooltip: true,
      editableTooltip: true,
      readOnly: false,
      disabled: false,
      keyboardAction: true,
      mouseScrollAction: false,
      lineCap: "butt",
      sliderType: "default",
      circleShape: "full",
      handleShape: "round",
      // the 'startValue' property decides at which point the slider should start.
      // otherwise, by default the slider starts with min value. this is mainly used
      // for min-range slider, where you can customize the min-range start position.
      startValue: null,
      // SVG related properties
      svgMode: false,
      borderWidth: 1,
      borderColor: null,
      pathColor: null,
      rangeColor: null,
      tooltipColor: null,
      // events
      beforeCreate: null,
      create: null,
      start: null,
      beforeValueChange: null,
      drag: null,
      change: null,
      update: null,
      valueChange: null,
      stop: null,
      tooltipFormat: null
    },
    keys: {
      // key codes for
      UP: 38,
      // up arrow
      DOWN: 40,
      // down arrow
      LEFT: 37,
      // left arrow
      RIGHT: 39 // right arrow

    },
    _props: function _props() {
      return {
        numberType: ["min", "max", "step", "radius", "width", "borderWidth", "startAngle", "startValue"],
        booleanType: ["animation", "showTooltip", "editableTooltip", "readOnly", "disabled", "keyboardAction", "mouseScrollAction", "svgMode"],
        stringType: ["sliderType", "circleShape", "handleShape", "lineCap"]
      };
    },
    _init: function _init() {
      var options = this.options;

      if (options.svgMode) {
        var EMPTY_FUNCTION = function EMPTY_FUNCTION() {};

        this._appendSeperator = EMPTY_FUNCTION;
        this._refreshSeperator = EMPTY_FUNCTION;
        this._updateSeperator = EMPTY_FUNCTION;
        this._appendOverlay = EMPTY_FUNCTION;
        this._checkOverlay = EMPTY_FUNCTION;
        this._updateWidth = EMPTY_FUNCTION;
      }

      if (this.control.is("input")) {
        this._isInputType = true;
        this._hiddenField = this.control;
        this.control = this.$createElement("div");
        this.control.insertAfter(this._hiddenField);
        options.value = this._hiddenField.val() || options.value;
      }

      if (this._isBrowserSupported()) {
        this._onInit();
      }
    },
    _onInit: function _onInit() {
      this._initialize();

      this._update();

      this._render();
    },
    _initialize: function _initialize() {
      var browserName = this.browserName = this.getBrowserName();
      if (browserName) this.control.addClass("rs-" + browserName);
      this._isReadOnly = false;

      this._checkDataType();

      this._refreshCircleShape();
    },
    _render: function _render() {
      this.container = this.$createElement("div.rs-container");
      this.innerContainer = this.$createElement("div.rs-inner-container");
      this.container.append(this.innerContainer);
      var $rootCSS = "rs-control " + (this.options.svgMode ? "rs-svg-mode" : "rs-classic-mode");
      this.control.addClass($rootCSS).empty().append(this.container);

      this._createLayers();

      this._createOtherLayers();

      this._setContainerClass();

      this._setRadius();

      this._setProperties();

      this._setValue();

      this._updateTooltipPos();

      this._bindControlEvents("_bind");

      this._raiseValueChange("create");

      this._updatePre();
    },
    _update: function _update() {
      this._validateSliderType();

      this._updateStartEnd();

      this._validateStartEnd();

      this._handle1 = this._handle2 = this._handleDefaults();

      this._analyzeModelValue();

      this._validateModelValue();
    },
    _createLayers: function _createLayers() {
      var options = this.options;

      if (options.svgMode) {
        this._createSVGElements();

        this._setSVGAttributes();

        this._setSVGStyles();

        this._moveSliderRange(true);

        return;
      }

      this.block = this.$createElement("div.rs-block rs-outer rs-border");
      this.innerContainer.append(this.block);
      var padd = options.width,
          start = this._start,
          path;
      path = this.$createElement("div.rs-path rs-transition");

      if (this._showRange) {
        this.block1 = path.clone().addClass("rs-range-color").rsRotate(start);
        this.block2 = path.clone().addClass("rs-range-color").css("opacity", "0").rsRotate(start);
        this.block3 = path.clone().addClass("rs-path-color").rsRotate(start);
        this.block4 = path.addClass("rs-path-color").css({
          "opacity": "1",
          "z-index": "1"
        }).rsRotate(start - 180);
        this.block.append(this.block1, this.block2, this.block3, this.block4).addClass("rs-split");
      } else this.block.append(path.addClass("rs-path-color"));

      this.lastBlock = this.$createElement("span.rs-block").css({
        "padding": padd
      });
      this.innerBlock = this.$createElement("div.rs-inner rs-bg-color rs-border");
      this.lastBlock.append(this.innerBlock);
      this.block.append(this.lastBlock);
    },
    _createOtherLayers: function _createOtherLayers() {
      this._appendHandle();

      this._appendSeperator(); // non SVG mode only


      this._appendOverlay(); // non SVG mode only


      this._appendHiddenField();
    },
    _setProperties: function _setProperties() {
      var options = this.options;

      this._setHandleShape();

      this._addAnimation();

      this._appendTooltip();

      if (!options.showTooltip) this._removeTooltip();
      if (options.disabled) this.disable();else if (options.readOnly) this._readOnly(true);
      if (options.mouseScrollAction) this._bindScrollEvents("_bind");
    },
    _updatePre: function _updatePre() {
      this._prechange = this._predrag = this._pre_bvc = this._preValue = this.options.value;
    },
    _backupPreValue: function _backupPreValue() {
      this._pre_handle1 = this._handle1;
      this._pre_handle2 = this._handle2;
    },
    _revertPreValue: function _revertPreValue() {
      this._handle1 = this._pre_handle1;
      this._handle2 = this._pre_handle2;

      this._updateModelValue();
    },
    _setValue: function _setValue() {
      if (this._rangeSlider) {
        this._setHandleValue(1);

        this._setHandleValue(2);
      } else {
        if (this._minRange && !this.options.svgMode) this._setHandleValue(1);
        var index = this._minRange ? 2 : this._active || 1;

        this._setHandleValue(index);
      }
    },
    _appendTooltip: function _appendTooltip() {
      if (this.container.children(".rs-tooltip").length !== 0) return;
      var tooltip = this.tooltip = this.$createElement("span.rs-tooltip rs-tooltip-text");
      this.container.append(tooltip);

      this._setTooltipColor(tooltip);

      this._tooltipEditable();

      this._updateTooltip();
    },
    _removeTooltip: function _removeTooltip() {
      if (this.container.children(".rs-tooltip").length == 0) return;
      this.tooltip && this.tooltip.remove();
    },
    _setTooltipColor: function _setTooltipColor(ele) {
      var o = this.options,
          tooltipColor = o.tooltipColor;
      var color = tooltipColor !== "inherit" ? tooltipColor : o.rangeColor;
      if (ele && color != null) ele.css("color", color);
    },
    _tooltipEditable: function _tooltipEditable() {
      var o = this.options,
          tooltip = this.tooltip,
          hook;
      if (!tooltip || !o.showTooltip) return;

      if (o.editableTooltip) {
        tooltip.addClass("rs-edit");
        hook = "_bind";
      } else {
        tooltip.removeClass("rs-edit");
        hook = "_unbind";
      }

      this[hook](tooltip, "click", this._editTooltip);
    },
    _editTooltip: function _editTooltip(e) {
      var tooltip = this.tooltip;
      if (!tooltip.hasClass("rs-edit") || this._isReadOnly) return;
      var border = parseFloat(tooltip.css("border-left-width")) * 2;
      var input = this.input = this.$createElement("input.rs-input rs-tooltip-text").css({
        height: tooltip.outerHeight() - border,
        width: tooltip.outerWidth() - border
      });

      this._setTooltipColor(input);

      tooltip.html(input).removeClass("rs-edit").addClass("rs-hover");
      input.focus().val(this._getTooltipValue(true));

      this._bind(input, "blur change", this._focusOut);
    },
    _focusOut: function _focusOut(e) {
      if (e.type == "change") {
        var val = this.input.val().replace("-", ",");

        if (val[0] == ",") {
          val = "-" + val.slice(1).replace("-", ",");
        }

        this.options.value = val;

        if (this._validateValue(true)) {
          this.input.val(this._getTooltipValue(true));

          this._raiseEvent("change");
        }
      } else {
        delete this.input;
        this.tooltip.addClass("rs-edit").removeClass("rs-hover");

        this._updateTooltip();
      }
    },
    _setHandleShape: function _setHandleShape() {
      var options = this.options,
          type = options.handleShape,
          allHandles = this._handles();

      allHandles.removeClass("rs-handle-dot rs-handle-square");
      if (type == "dot") allHandles.addClass("rs-handle-dot");else if (type == "square") allHandles.addClass("rs-handle-square");else options.handleShape = "round";
    },
    _setHandleValue: function _setHandleValue(index) {
      this._active = index;
      var handle = this["_handle" + index];
      if (!this._minRange) this.bar = this._activeHandleBar();

      this._changeSliderValue(handle.value, handle.angle);
    },
    _addAnimation: function _addAnimation() {
      if (this.options.animation) this.control.addClass("rs-animation");
    },
    _removeAnimation: function _removeAnimation() {
      this.control.removeClass("rs-animation");
    },
    _setContainerClass: function _setContainerClass() {
      var circleShape = this.options.circleShape;

      if (circleShape == "full" || circleShape == "pie" || circleShape.indexOf("custom") === 0) {
        this.container.addClass("rs-full rs-" + circleShape);
      } else {
        this.container.addClass("rs-" + circleShape.split("-").join(" rs-"));
      }
    },
    _setRadius: function _setRadius() {
      var o = this.options,
          r = o.radius,
          d = r * 2,
          circleShape = o.circleShape;
      var extraSize = 0,
          actualHeight,
          actualWidth;
      var height = actualHeight = d,
          width = actualWidth = d; // whenever the radius changes, before update the container size
      // check for the lineCap also, since that will make some additional size
      // also, based on that need to align the handle bars

      var isFullCircle = circleShape == "full" || circleShape == "pie" || circleShape.indexOf("custom") === 0;

      if (o.svgMode && !isFullCircle) {
        var handleBars = this._handleBars();

        if (o.lineCap != "none") {
          extraSize = o.lineCap === "butt" ? o.borderWidth / 2 : o.width / 2 + o.borderWidth;

          if (circleShape.indexOf("bottom") != -1) {
            handleBars.css("margin-top", extraSize + 'px');
          }

          if (circleShape.indexOf("right") != -1) {
            handleBars.css("margin-right", -extraSize + 'px');
          }
        } else {
          // when lineCap none, then remove the styles that was set previously for the other lineCap props
          $.each(handleBars, function (i, bar) {
            bar.style.removeProperty("margin-top");
            bar.style.removeProperty("margin-right");
          });
        }
      }

      if (circleShape.indexOf("half") === 0) {
        switch (circleShape) {
          case "half-top":
          case "half-bottom":
            height = r;
            actualHeight = r + extraSize;
            break;

          case "half-left":
          case "half-right":
            width = r;
            actualWidth = r + extraSize;
            break;
        }
      } else if (circleShape.indexOf("quarter") === 0) {
        height = width = r;
        actualHeight = actualWidth = r + extraSize;
      }

      this.container.css({
        "height": height,
        "width": width
      });
      this.control.css({
        "height": actualHeight,
        "width": actualWidth
      }); // when needed, then only we can set the styles through script, otherwise CSS styles applicable

      if (extraSize !== 0) this.innerContainer.css({
        "height": actualHeight,
        "width": actualWidth
      });else this.innerContainer.removeAttr("style");

      if (o.svgMode) {
        this.svgContainer.height(d).width(d).children("svg").height(d).width(d);
      }
    },
    _border: function _border(seperator) {
      var options = this.options;
      if (options.svgMode) return options.borderWidth * 2;
      if (seperator) return parseFloat(this._startLine.children().css("border-bottom-width"));
      return parseFloat(this.block.css("border-top-width")) * 2;
    },
    _appendHandle: function _appendHandle() {
      // if this is range or default slider then create handle 1
      if (this._rangeSlider || !this._minRange) this._createHandle(1); // if this is range or min-range slider then create handle 2

      if (this._showRange) this._createHandle(2);
    },
    _appendSeperator: function _appendSeperator() {
      this._startLine = this._addSeperator(this._start, "rs-start");
      this._endLine = this._addSeperator(this._start + this._end, "rs-end");

      this._refreshSeperator();
    },
    _addSeperator: function _addSeperator(pos, cls) {
      var line = this.$createElement("span.rs-seperator rs-border");
      var lineWrap = this.$createElement("span.rs-bar rs-transition " + cls).append(line).rsRotate(pos);
      this.container.append(lineWrap);
      return lineWrap;
    },
    _refreshSeperator: function _refreshSeperator() {
      var bars = this._startLine.add(this._endLine),
          seperators = bars.children().removeAttr("style");

      var o = this.options,
          width = o.width,
          _border = this._border(),
          size = width + _border;

      if (o.lineCap == "round" && o.circleShape != "full") {
        bars.addClass("rs-rounded");
        seperators.css({
          width: size,
          height: size / 2 + 1
        });

        this._startLine.children().css("margin-top", -1).addClass(this._minRange ? "rs-range-color" : "rs-path-color");

        this._endLine.children().css("margin-top", size / -2).addClass("rs-path-color");
      } else {
        bars.removeClass("rs-rounded");
        seperators.css({
          "width": size,
          "margin-top": this._border(true) / -2
        }).removeClass("rs-range-color rs-path-color");
      }
    },
    _updateSeperator: function _updateSeperator() {
      this._startLine.rsRotate(this._start);

      this._endLine.rsRotate(this._start + this._end);
    },
    _createHandle: function _createHandle(index) {
      var handle = this.$createElement("div.rs-handle rs-move"),
          o = this.options,
          hs;
      if ((hs = o.handleShape) != "round") handle.addClass("rs-handle-" + hs);
      handle.attr({
        "index": index,
        "tabIndex": "0"
      });

      var id = this._dataElement()[0].id,
          id = id ? id + "_" : "";

      var label = id + "handle";
      if (this._rangeSlider) label += "_" + (index == 1 ? "start" : "end");
      handle.attr({
        "role": "slider",
        "aria-label": label
      }); // WAI-ARIA support

      var handleDefaults = this._handleDefaults();

      var bar = this.$createElement("div.rs-bar rs-transition").css("z-index", "7").append(handle);
      bar.addClass(this._rangeSlider && index == 2 ? "rs-second" : "rs-first"); // at initial creation keep the handle and bar at the default angle position

      bar.rsRotate(handleDefaults.angle);
      this.container.append(bar);

      this._refreshHandle();

      this.bar = bar;
      this._active = index;
      if (index != 1 && index != 2) this["_handle" + index] = handleDefaults;

      this._bind(handle, "focus blur", this._handleFocus);

      return handle;
    },
    _refreshHandle: function _refreshHandle() {
      var o = this.options,
          hSize = o.handleSize,
          width = o.width,
          h,
          w,
          isSquare = true,
          isNumber = this.isNumber;

      if (typeof hSize === "string" && isNumber(hSize)) {
        if (hSize.charAt(0) === "+" || hSize.charAt(0) === "-") {
          hSize = width + parseFloat(hSize);
        } else if (hSize.indexOf(",")) {
          var s = hSize.split(",");
          if (isNumber(s[0]) && isNumber(s[1])) w = parseFloat(s[0]), h = parseFloat(s[1]), isSquare = false;
        }
      }

      if (isSquare) h = w = isNumber(hSize) ? parseFloat(hSize) : width;
      var diff = (width + this._border() - w) / 2;

      this._handles().css({
        height: h,
        width: w,
        "margin": -h / 2 + "px 0 0 " + diff + "px"
      });
    },
    _defaultValue: function _defaultValue() {
      var o = this.options,
          startValue = o.startValue;
      var defaultValue = this.isNumber(startValue) ? this._limitValue(startValue) : o.min;
      return defaultValue;
    },
    _handleDefaults: function _handleDefaults() {
      var defaultValue = this._defaultValue();

      return {
        angle: this._valueToAngle(defaultValue),
        value: defaultValue
      };
    },
    _handleBars: function _handleBars() {
      return this.container.children("div.rs-bar");
    },
    _handles: function _handles() {
      return this._handleBars().find(".rs-handle");
    },
    _activeHandleBar: function _activeHandleBar(index) {
      if (this._minRange) return this.bar;
      index = index != undefined ? index : this._active;
      return $(this._handleBars()[index - 1]);
    },
    _handleArgs: function _handleArgs(index) {
      index = index != undefined ? index : this._active;

      var _handle = this["_handle" + index] || {};

      return {
        element: this._activeHandleBar(index).children(),
        index: index,
        isActive: index == this._active,
        value: _handle.value,
        angle: _handle.angle
      };
    },
    _dataElement: function _dataElement() {
      return this._isInputType ? this._hiddenField : this.control;
    },
    _raiseEvent: function _raiseEvent(event) {
      var preValue = this["_pre" + event],
          currentValue = this.options.value;

      if (preValue !== currentValue) {
        this["_pre" + event] = currentValue;

        if (event == "change") {
          this._predrag = currentValue;

          this._updateHidden();
        }

        this._updateTooltip();

        var _handle = this._handleArgs();

        this._raise(event, {
          value: currentValue,
          preValue: preValue,
          "handle": _handle
        });

        if (currentValue != this._preValue) {
          // whenever the drag and change event happens, at that time trigger 'update' also
          this._raise("update", {
            value: currentValue,
            preValue: preValue,
            "handle": _handle,
            action: event
          }); // after the "update" event trigger the "valueChange" event


          this._raiseValueChange(event);
        }
      }
    },
    _raiseBeforeValueChange: function _raiseBeforeValueChange(action, value) {
      if (typeof value !== "undefined") {
        if (this._rangeSlider) value = this._formRangeValue(value);
      } else {
        value = this.options.value;
      }

      var isUserAction = action !== "code";

      if (value !== this._pre_bvc) {
        var args = {
          value: value,
          preValue: this._pre_bvc,
          action: action,
          isUserAction: isUserAction,
          cancelable: true
        };
        var returnValue = this._raise("beforeValueChange", args) != false;

        if (returnValue) {
          // if the beforeValueChange is success then only we can update the preVal flag
          // otherwise when user prevent the event, at that time we can't revert this value
          this._pre_bvc = value;
        }

        return returnValue;
      } // if this is the from user action then return false, because user can't update the same value again
      // otherwise if this is from 'code' then return true, since when changing the min and max values
      // at that time also slider needs to update, even though value not changed


      return isUserAction ? false : true;
    },
    _raiseValueChange: function _raiseValueChange(action) {
      var value = this.options.value,
          handles = [];
      if (!this._minRange) handles.push(this._handleArgs(1)); // for range and default slider

      if (this._showRange) handles.push(this._handleArgs(2)); // for range and min-range slider

      var args = {
        value: value,
        preValue: this._preValue,
        action: action,
        isUserAction: action !== "code" && action !== "create",
        isInvertedRange: this._isInvertedRange,
        handles: handles
      };

      this._raise("valueChange", args); // once the valueChange event raised then update all the preVal flags


      this._preValue = value;
    },
    // Events handlers
    _elementDown: function _elementDown(e) {
      if (this._isReadOnly) return;
      var $target = $(e.target);

      if ($target.hasClass("rs-handle")) {
        this._handleDown(e);
      } else {
        var point = this._getXY(e),
            center = this._getCenterPoint();

        var distance = this._getDistance(point, center);

        var block = this.block || this.svgContainer;
        var outerDistance = block.outerWidth() / 2;

        var innerDistance = outerDistance - (this.options.width + this._border());

        if (distance >= innerDistance && distance <= outerDistance) {
          var handle = this.control.find(".rs-handle.rs-focus"),
              angle,
              value;

          if (handle.length !== 0) {
            // here, some handle was in already focused state, and user clicked on the slider path
            // so this will make the handle unfocus, to avoid that we can prevent this event
            e.preventDefault();
          }

          var d = this._getAngleValue(point, center);

          angle = d.angle, value = d.value;

          if (this._rangeSlider) {
            if (handle.length == 1) {
              var active = parseFloat(handle.attr("index"));

              if (!this._invertRange) {
                if (active == 1 && angle > this._handle2.angle) active = 2;else if (active == 2 && angle < this._handle1.angle) active = 1;
              }

              this._active = active;
            } else this._active = this._handle2.angle - angle < angle - this._handle1.angle ? 2 : 1;

            this.bar = this._activeHandleBar();
          }

          if (this._raiseBeforeValueChange("change", value)) {
            this._changeSliderValue(value, angle);

            this._raiseEvent("change");
          }
        }
      }
    },
    _handleDown: function _handleDown(e) {
      e.preventDefault();
      var $target = $(e.target);
      $target.focus();

      this._removeAnimation();

      this._bindMouseEvents("_bind");

      this.bar = $target.parent();
      this._active = parseFloat($target.attr("index"));

      this._handles().removeClass("rs-move");

      this._raise("start", {
        value: this.options.value,
        "handle": this._handleArgs()
      });
    },
    _handleMove: function _handleMove(e) {
      e.preventDefault();

      var point = this._getXY(e),
          center = this._getCenterPoint();

      var d = this._getAngleValue(point, center, true),
          angle,
          value;

      angle = d.angle, value = d.value;

      if (this._raiseBeforeValueChange("drag", value)) {
        this._changeSliderValue(value, angle);

        this._raiseEvent("drag");
      }
    },
    _handleUp: function _handleUp(e) {
      this._handles().addClass("rs-move");

      this._bindMouseEvents("_unbind");

      this._addAnimation();

      this._raiseEvent("change");

      this._raise("stop", {
        value: this.options.value,
        "handle": this._handleArgs()
      });
    },
    _handleFocus: function _handleFocus(e) {
      if (this._isReadOnly) return; // the below checks are common for both focus and blur events

      this._handles().removeClass("rs-focus");

      var keyboardActionEnabled = this.options.keyboardAction;

      if (keyboardActionEnabled) {
        this._bindKeyboardEvents("_unbind");
      }

      if (e.type === "blur") {
        return;
      } // when the handle gets focus


      var $target = $(e.target);
      $target.addClass("rs-focus");
      this.bar = $target.parent();
      this._active = parseFloat($target.attr("index"));

      if (keyboardActionEnabled) {
        this._bindKeyboardEvents("_bind");
      } // updates the class for change z-index


      this.control.find("div.rs-bar").css("z-index", "7");
      this.bar.css("z-index", "8");
    },
    _handleKeyDown: function _handleKeyDown(e) {
      var key = e.keyCode,
          keyCodes = this.keys;
      if (key == 27) // if Esc key pressed then hanldes will be focused out
        this._handles().blur();
      if (!(key >= 35 && key <= 40)) return; // if not valid keys, then return

      if (key >= 37 && key <= 40) this._removeAnimation();
      var h = this["_handle" + this._active],
          val,
          ang;
      e.preventDefault();
      if (key == keyCodes.UP || key == keyCodes.RIGHT) // Up || Right Key
        val = this._round(this._limitValue(h.value + this.options.step));else if (key == keyCodes.DOWN || key == keyCodes.LEFT) // Down || Left Key
        val = this._round(this._limitValue(h.value - this._getMinusStep(h.value)));else if (key == 36) // Home Key
        val = this._getKeyValue("Home");else if (key == 35) // End Key
        val = this._getKeyValue("End");
      ang = this._valueToAngle(val);

      if (this._raiseBeforeValueChange("drag", val)) {
        this._changeSliderValue(val, ang);

        this._raiseEvent("drag");
      }
    },
    _handleKeyUp: function _handleKeyUp(e) {
      this._addAnimation();

      this._raiseEvent("change");
    },
    _getMinusStep: function _getMinusStep(val) {
      var o = this.options,
          min = o.min,
          max = o.max,
          step = o.step;

      if (val == max) {
        var remain = (max - min) % step;
        return remain == 0 ? step : remain;
      }

      return step;
    },
    _getKeyValue: function _getKeyValue(key) {
      var o = this.options,
          min = o.min,
          max = o.max;

      if (this._rangeSlider) {
        if (key == "Home") return this._active == 1 ? min : this._handle1.value;else return this._active == 1 ? this._handle2.value : max;
      }

      return key == "Home" ? min : max;
    },
    _elementScroll: function _elementScroll(event) {
      if (this._isReadOnly) return;
      event.preventDefault();
      var e = event.originalEvent || event,
          h,
          val,
          ang,
          delta;
      delta = e.wheelDelta ? e.wheelDelta / 60 : e.detail ? -e.detail / 2 : 0;
      if (delta == 0) return;

      this._updateActiveHandle(event);

      h = this["_handle" + this._active];
      val = h.value + (delta > 0 ? this.options.step : -this._getMinusStep(h.value));
      val = this._limitValue(val);
      ang = this._valueToAngle(val);

      if (this._raiseBeforeValueChange("change", val)) {
        this._removeAnimation();

        this._changeSliderValue(val, ang);

        this._raiseEvent("change");

        this._addAnimation();
      }
    },
    _updateActiveHandle: function _updateActiveHandle(e) {
      var $target = $(e.target);

      if ($target.hasClass("rs-handle") && $target.parent().parent()[0] == this.control[0]) {
        this.bar = $target.parent();
        this._active = parseFloat($target.attr("index"));
      }

      if (!this.bar.find(".rs-handle").hasClass("rs-focus")) this.bar.find(".rs-handle").focus();
    },
    // Events binding
    _bindControlEvents: function _bindControlEvents(hook) {
      this[hook](this.control, "mousedown touchstart", this._elementDown);
    },
    _bindScrollEvents: function _bindScrollEvents(hook) {
      this[hook](this.control, "mousewheel DOMMouseScroll", this._elementScroll);
    },
    _bindMouseEvents: function _bindMouseEvents(hook) {
      var _document = $(document);

      this[hook](_document, "mousemove touchmove", this._handleMove);
      this[hook](_document, "mouseup mouseleave touchend touchcancel", this._handleUp);
    },
    _bindKeyboardEvents: function _bindKeyboardEvents(hook) {
      var _document = $(document);

      this[hook](_document, "keydown", this._handleKeyDown);
      this[hook](_document, "keyup", this._handleKeyUp);
    },
    // internal methods
    _changeSliderValue: function _changeSliderValue(value, angle) {
      var oAngle = this._oriAngle(angle),
          lAngle = this._limitAngle(angle),
          activeHandle = this._active,
          options = this.options;

      if (!this._showRange) {
        // if this is the default slider
        this["_handle" + activeHandle] = {
          angle: angle,
          value: value
        };
        options.value = value;
        this.bar.rsRotate(lAngle);

        this._updateARIA(value);
      } else {
        var isValidRange = activeHandle == 1 && oAngle <= this._oriAngle(this._handle2.angle) || activeHandle == 2 && oAngle >= this._oriAngle(this._handle1.angle);

        var canAllowInvertRange = this._invertRange;

        if (this._minRange || isValidRange || canAllowInvertRange) {
          this["_handle" + activeHandle] = {
            angle: angle,
            value: value
          };
          options.value = this._rangeSlider ? this._handle1.value + "," + this._handle2.value : value;
          this.bar.rsRotate(lAngle);

          this._updateARIA(value);

          if (options.svgMode) {
            this._moveSliderRange();

            return;
          } // classic DIV handling


          var dAngle = this._oriAngle(this._handle2.angle) - this._oriAngle(this._handle1.angle),
              o2 = "1",
              o3 = "0";

          if (dAngle <= 180 && !(dAngle < 0 && dAngle > -180)) o2 = "0", o3 = "1";
          this.block2.css("opacity", o2);
          this.block3.css("opacity", o3);
          (activeHandle == 1 ? this.block4 : this.block2).rsRotate(lAngle - 180);
          (activeHandle == 1 ? this.block1 : this.block3).rsRotate(lAngle);
        }
      }
    },
    // SVG related functionalities
    _createSVGElements: function _createSVGElements() {
      var svgEle = this.$createSVG("svg");
      var PATH = "path.rs-transition ";
      var pathAttr = {
        fill: "transparent"
      };
      this.$path = this.$createSVG(PATH + "rs-path", pathAttr);
      this.$range = this._showRange ? this.$createSVG(PATH + "rs-range", pathAttr) : null;
      this.$border = this.$createSVG(PATH + "rs-border", pathAttr);
      this.$append(svgEle, [this.$path, this.$range, this.$border]);
      this.svgContainer = this.$createElement("div.rs-svg-container").append(svgEle).appendTo(this.innerContainer);
    },
    _setSVGAttributes: function _setSVGAttributes() {
      var o = this.options,
          radius = o.radius,
          border = o.borderWidth,
          width = o.width,
          lineCap = o.lineCap;
      var outerRadius = radius - border / 2,
          innerRadius = outerRadius - width - border;
      var startAngle = this._start,
          totalAngle = this._end,
          endAngle = startAngle + totalAngle; // draw the path for border element

      var border_d = this.$drawPath(radius, outerRadius, startAngle, endAngle, innerRadius, lineCap);
      this.$setAttribute(this.$border, {
        "d": border_d
      }); // and set the border width

      $(this.$border).css("stroke-width", border);
      var pathRadius = radius - border - width / 2;
      this.svgPathLength = this.$getArcLength(pathRadius, totalAngle);
      var d = this.$drawPath(radius, pathRadius, startAngle, endAngle);
      var attr = {
        "d": d,
        "stroke-width": width,
        "stroke-linecap": lineCap
      }; // draw the path for slider path element

      this.$setAttribute(this.$path, attr);

      if (this._showRange) {
        // draw the path for slider range element
        this.$setAttribute(this.$range, attr); // there was a small bug when lineCap was round/square, this will solve that

        if (lineCap == "round" || lineCap == "square") this.$range.setAttribute("stroke-dashoffset", "0.01");else this.$range.removeAttribute("stroke-dashoffset");
      }
    },
    _setSVGStyles: function _setSVGStyles() {
      var o = this.options,
          borderColor = o.borderColor,
          pathColor = o.pathColor,
          rangeColor = o.rangeColor;

      if (borderColor) {
        if (borderColor == "inherit") borderColor = rangeColor;
        $(this.$border).css("stroke", borderColor);
      }

      if (pathColor) {
        this.svgContainer[pathColor == "inherit" ? "addClass" : "removeClass"]("rs-path-inherited");
        if (pathColor == "inherit") pathColor = rangeColor;
        $(this.$path).css("stroke", pathColor);
      }

      if (this._showRange && rangeColor) {
        $(this.$range).css("stroke", rangeColor);
      }
    },
    _moveSliderRange: function _moveSliderRange(isInit) {
      if (!this._showRange) return;
      var startAngle = this._start,
          totalAngle = this._end;
      var handle1Angle = this._handle1.angle,
          handle2Angle = this._handle2.angle;

      if (isInit) {
        // at the initial time, keep all the handles angle to default angle
        // so that once the value set, the animation happens from this default angle
        handle1Angle = handle2Angle = this._handleDefaults().angle;
      } // always to get the actual angle, just minus from the start angle


      handle1Angle -= startAngle;
      handle2Angle -= startAngle;
      var dashArray = [];
      var isNormalRange = handle1Angle <= handle2Angle;
      this._isInvertedRange = !isNormalRange;

      if (isNormalRange) {
        // starting the dashArray from 0 means normal range, otherwise it's invert range
        // so when handle1 value is smaller then it's a normal range selection only
        dashArray.push(0);
      } else {
        if (this._minRange) {
          // this case will be executed for the min-range slider with any startValue set.
          // when the handle value goes beyond the startValue, then this will be triggered.
          // which means that is a invert range selection, but for min-range slider the invert range
          // is not applicable, so by default show the normal range instead of the inverted range.
          dashArray.push(0);
        } // when handle1 value is larger then it's a invert range selection, also swap the values


        var temp = handle1Angle;
        handle1Angle = handle2Angle;
        handle2Angle = temp;
      }

      var handle1Distance = handle1Angle / totalAngle * this.svgPathLength;
      dashArray.push(handle1Distance);
      var handle2Distance = (handle2Angle - handle1Angle) / totalAngle * this.svgPathLength;
      dashArray.push(handle2Distance, this.svgPathLength);
      this.$range.style.strokeDasharray = dashArray.join(" ");
    },
    _isPropsRelatedToSVG: function _isPropsRelatedToSVG(property) {
      var svgRelatedProps = ["radius", "borderWidth", "width", "lineCap", "startAngle", "endAngle"];
      return this._hasProperty(property, svgRelatedProps);
    },
    _isPropsRelatedToSVGStyles: function _isPropsRelatedToSVGStyles(property) {
      var svgStylesRelatedProps = ["borderColor", "pathColor", "rangeColor"];
      return this._hasProperty(property, svgStylesRelatedProps);
    },
    _hasProperty: function _hasProperty(property, list) {
      if (typeof property == "string") {
        return list.indexOf(property) !== -1;
      } else {
        var allProperties = Object.keys(property);
        return allProperties.some(function (prop) {
          return list.indexOf(prop) !== -1;
        });
      }
    },
    // WAI-ARIA support
    _updateARIA: function _updateARIA(value) {
      var o = this.options,
          min = o.min,
          max = o.max;
      this.bar.children().attr({
        "aria-valuenow": value
      });

      if (this._rangeSlider) {
        var handles = this._handles();

        handles.eq(0).attr({
          "aria-valuemin": min
        });
        handles.eq(1).attr({
          "aria-valuemax": max
        });
        if (this._active == 1) handles.eq(1).attr({
          "aria-valuemin": value
        });else handles.eq(0).attr({
          "aria-valuemax": value
        });
      } else this.bar.children().attr({
        "aria-valuemin": min,
        "aria-valuemax": max
      });
    },
    _getDistance: function _getDistance(p1, p2) {
      return Math.sqrt((p1.x - p2.x) * (p1.x - p2.x) + (p1.y - p2.y) * (p1.y - p2.y));
    },
    _getXY: function _getXY(e) {
      if (e.type.indexOf("mouse") == -1) e = (e.originalEvent || e).changedTouches[0];
      return {
        x: e.pageX,
        y: e.pageY
      };
    },
    _getCenterPoint: function _getCenterPoint() {
      var block = this.block || this.svgContainer;
      var offset = block.offset(),
          center;
      center = {
        x: offset.left + block.outerWidth() / 2,
        y: offset.top + block.outerHeight() / 2
      };
      return center;
    },
    _getAngleValue: function _getAngleValue(point, center, isDrag) {
      var deg = Math.atan2(point.y - center.y, center.x - point.x);
      var angle = -deg / (Math.PI / 180);
      if (angle < this._start) angle += 360;
      angle = this._checkAngle(angle, isDrag);
      return this._processStepByAngle(angle);
    },
    _checkAngle: function _checkAngle(angle, isDrag) {
      var o_angle = this._oriAngle(angle),
          preAngle = this["_handle" + this._active].angle,
          o_preAngle = this._oriAngle(preAngle);

      if (o_angle > this._end) {
        if (!isDrag) return preAngle;
        angle = this._start + (o_preAngle <= this._end - o_preAngle ? 0 : this._end);
      } else if (isDrag) {
        var d = this._handleDragDistance;
        if (this.isNumber(d)) if (Math.abs(o_angle - o_preAngle) > d) return preAngle;
      }

      return angle;
    },
    _processStepByAngle: function _processStepByAngle(angle) {
      var value = this._angleToValue(angle);

      return this._processStepByValue(value);
    },
    _processStepByValue: function _processStepByValue(value) {
      var o = this.options,
          min = o.min,
          max = o.max,
          step = o.step,
          isMinHigher = min > max;
      var remain, currVal, nextVal, preVal, newVal, ang;
      step = isMinHigher ? -step : step;
      remain = (value - min) % step;
      currVal = value - remain;
      nextVal = this._limitValue(currVal + step);
      preVal = this._limitValue(currVal - step);

      if (!isMinHigher) {
        if (value >= currVal) newVal = value - currVal < nextVal - value ? currVal : nextVal;else newVal = currVal - value > value - preVal ? currVal : preVal;
      } else {
        if (value <= currVal) newVal = currVal - value < value - nextVal ? currVal : nextVal;else newVal = value - currVal > preVal - value ? currVal : preVal;
      }

      newVal = this._round(newVal), ang = this._valueToAngle(newVal);
      return {
        value: newVal,
        angle: ang
      };
    },
    _round: function _round(val) {
      var s = this.options.step.toString().split(".");
      return s[1] ? parseFloat(val.toFixed(s[1].length)) : Math.round(val);
    },
    _oriAngle: function _oriAngle(angle) {
      var ang = angle - this._start;
      if (ang < 0) ang += 360;
      return ang;
    },
    _limitAngle: function _limitAngle(angle) {
      if (angle > 360 + this._start) angle -= 360;
      if (angle < this._start) angle += 360;
      return angle;
    },
    _limitValue: function _limitValue(value) {
      var o = this.options,
          min = o.min,
          max = o.max,
          isMinHigher = min > max;
      if (!isMinHigher && value < min || isMinHigher && value > min) value = min;
      if (!isMinHigher && value > max || isMinHigher && value < max) value = max;
      return value;
    },
    _angleToValue: function _angleToValue(angle) {
      var o = this.options,
          min = o.min,
          max = o.max,
          value;
      value = this._oriAngle(angle) / this._end * (max - min) + min;
      return value;
    },
    _valueToAngle: function _valueToAngle(value) {
      var o = this.options,
          min = o.min,
          max = o.max,
          angle;
      angle = (value - min) / (max - min) * this._end + this._start;
      return angle;
    },
    _appendHiddenField: function _appendHiddenField() {
      var hiddenField = this._hiddenField = this._hiddenField || this.$createElement("input");
      hiddenField.attr({
        "type": "hidden",
        "name": this._dataElement()[0].id || ""
      });
      this.control.append(hiddenField);

      this._updateHidden();
    },
    _updateHidden: function _updateHidden() {
      var val = this.options.value;

      this._hiddenField.val(val);
    },
    _updateTooltip: function _updateTooltip() {
      var o = this.options,
          tooltip = this.tooltip;

      if (tooltip) {
        if (!tooltip.hasClass("rs-hover")) tooltip.html(this._getTooltipValue());

        this._updateTooltipPos();
      }

      if (!o.showTooltip && o.mouseScrollAction) {
        // fix for a weird issue !! with min-range slider, tooltip disabled and mouseScrollAction enabled
        // when you mouse scroll on slider, the range very strucks. so we need to touch the DOM for this case.
        this.control.height();
      }
    },
    _updateTooltipPos: function _updateTooltipPos() {
      var o = this.options,
          circleShape = o.circleShape,
          pos = {};
      if (!o.showTooltip || circleShape.indexOf("quarter") === 0) return;
      var tooltip = this.tooltip;

      if (!tooltip.is(":visible")) {
        // when the element is not in the visible state we can't find height and width
        // for this case we can set the translate to center the element
        // To-Do: maybe in future, based on multiple use cases we can make this way as default
        tooltip.addClass("rs-center");
      } else {
        tooltip.removeClass("rs-center").addClass("rs-reset");
        var marginTop = -(tooltip.outerHeight() / 2),
            // before get the tooltip height and width, we can reset
        marginLeft = -(tooltip.outerWidth() / 2); // the previous styles so that we can get the proper values.

        tooltip.removeClass("rs-reset");

        if (circleShape == "full" || circleShape == "pie" || circleShape.indexOf("custom") === 0) {
          pos = {
            "margin-top": marginTop,
            "margin-left": marginLeft
          };
        } else if (circleShape == "half-top" || circleShape == "half-bottom") {
          pos = {
            "margin-left": marginLeft
          };
        } else if (circleShape == "half-left" || circleShape == "half-right") {
          pos = {
            "margin-top": marginTop
          };
        }
      }

      tooltip.css(pos);
    },
    _getTooltipValue: function _getTooltipValue(isNormal) {
      var value = this.options.value;

      if (this._rangeSlider) {
        var p = value.split(",");
        if (isNormal) return p[0] + " - " + p[1];
        return this._tooltipValue(p[0], 1) + " - " + this._tooltipValue(p[1], 2);
      }

      if (isNormal) return value;
      return this._tooltipValue(value);
    },
    _tooltipValue: function _tooltipValue(value, index) {
      var returnValue = this._raise("tooltipFormat", {
        value: value,
        "handle": this._handleArgs(index)
      });

      return returnValue != null && typeof returnValue !== "boolean" ? returnValue : value;
    },
    _validateStartAngle: function _validateStartAngle() {
      var options = this.options,
          start = options.startAngle;
      start = (this.isNumber(start) ? parseFloat(start) : 0) % 360;
      if (start < 0) start += 360;
      options.startAngle = start;
      return start;
    },
    _validateEndAngle: function _validateEndAngle() {
      var o = this.options,
          start = o.startAngle,
          end = o.endAngle;

      if (this.isNumber(end)) {
        if (typeof end === "string" && (end.charAt(0) === "+" || end.charAt(0) === "-")) {
          end = start + parseFloat(end);
        }

        end = parseFloat(end);
      } else end = 360;

      end %= 360;
      if (end <= start) end += 360;
      return end;
    },
    _refreshCircleShape: function _refreshCircleShape() {
      var options = this.options,
          circleShape = options.circleShape;
      var allCircelShapes = ["half-top", "half-bottom", "half-left", "half-right", "quarter-top-left", "quarter-top-right", "quarter-bottom-right", "quarter-bottom-left", "pie", "custom-half", "custom-quarter"];

      if (allCircelShapes.indexOf(circleShape) == -1) {
        if (circleShape == "half") circleShape = "half-top";else if (circleShape == "quarter") circleShape = "quarter-top-left";else circleShape = "full";
      }

      options.circleShape = circleShape;
    },
    _appendOverlay: function _appendOverlay() {
      var shape = this.options.circleShape;
      if (shape == "pie") this._checkOverlay(".rs-overlay", 270);else if (shape == "custom-half" || shape == "custom-quarter") {
        this._checkOverlay(".rs-overlay1", 180);

        if (shape == "custom-quarter") this._checkOverlay(".rs-overlay2", this._end);
      }
    },
    _checkOverlay: function _checkOverlay(cls, angle) {
      var overlay = this.container.children(cls);

      if (overlay.length == 0) {
        overlay = this.$createElement("div" + cls + " rs-transition rs-bg-color");
        this.container.append(overlay);
      }

      overlay.rsRotate(this._start + angle);
    },
    _checkDataType: function _checkDataType() {
      var m = this.options,
          i,
          prop,
          value,
          props = this._props(); // to check number datatype


      for (i in props.numberType) {
        prop = props.numberType[i], value = m[prop];
        if (!this.isNumber(value)) m[prop] = this.defaults[prop];else m[prop] = parseFloat(value);
      } // to check input string


      for (i in props.booleanType) {
        prop = props.booleanType[i], value = m[prop];
        m[prop] = value == "false" ? false : !!value;
      } // to check boolean datatype


      for (i in props.stringType) {
        prop = props.stringType[i], value = m[prop];
        m[prop] = ("" + value).toLowerCase();
      }
    },
    _validateSliderType: function _validateSliderType() {
      var options = this.options,
          type = options.sliderType.toLowerCase();
      this._rangeSlider = this._showRange = this._minRange = false;
      if (type == "range") this._rangeSlider = this._showRange = true;else if (type.indexOf("min") != -1) {
        this._showRange = this._minRange = true;
        type = "min-range";
      } else type = "default";
      options.sliderType = type;
    },
    _updateStartEnd: function _updateStartEnd() {
      var o = this.options,
          circle = o.circleShape,
          startAngle = o.startAngle,
          endAngle = o.endAngle;

      if (circle != "full") {
        if (circle.indexOf("quarter") != -1) endAngle = "+90";else if (circle.indexOf("half") != -1) endAngle = "+180";else if (circle == "pie") endAngle = "+270";
        o.endAngle = endAngle;
        if (circle == "quarter-top-left" || circle == "half-top") startAngle = 0;else if (circle == "quarter-top-right" || circle == "half-right") startAngle = 90;else if (circle == "quarter-bottom-right" || circle == "half-bottom") startAngle = 180;else if (circle == "quarter-bottom-left" || circle == "half-left") startAngle = 270;
        o.startAngle = startAngle;
      }
    },
    _validateStartEnd: function _validateStartEnd() {
      this._start = this._validateStartAngle();
      this._end = this._validateEndAngle();
      var add = this._start < this._end ? 0 : 360;
      this._end += add - this._start;
    },
    _validateValue: function _validateValue(isChange) {
      this._backupPreValue();

      this._analyzeModelValue();

      this._validateModelValue();

      if (this._raiseBeforeValueChange(isChange ? "change" : "code")) {
        this._setValue();

        this._backupPreValue();

        return true;
      } else {
        this._revertPreValue();

        return false;
      }
    },
    _analyzeModelValue: function _analyzeModelValue() {
      var o = this.options,
          val = o.value,
          newValue;
      if (val instanceof Array) val = val.toString();
      var parts = typeof val == "string" ? val.split(",") : [val];
      if (parts.length == 1 && this.isNumber(parts[0])) parts = [o.min, parts[0]];else if (parts.length >= 2 && !this.isNumber(parts[1])) parts[1] = o.max;

      if (this._rangeSlider) {
        newValue = [this._parseModelValue(parts[0]), this._parseModelValue(parts[1])].toString();
      } else {
        var lastValue = parts.pop();
        newValue = this._parseModelValue(lastValue);
      }

      o.value = newValue;
    },
    _parseModelValue: function _parseModelValue(value) {
      return this.isNumber(value) ? parseFloat(value) : this._defaultValue();
    },
    _validateModelValue: function _validateModelValue() {
      var o = this.options,
          val = o.value;

      if (this._rangeSlider) {
        var parts = val.split(","),
            val1 = parseFloat(parts[0]),
            val2 = parseFloat(parts[1]);
        val1 = this._limitValue(val1);
        val2 = this._limitValue(val2);

        if (!this._invertRange) {
          var min = o.min,
              max = o.max;
          var isMinHigher = min > max;

          if (isMinHigher) {
            if (val1 < val2) val1 = val2;
          } else {
            if (val1 > val2) val2 = val1;
          }
        }

        this._handle1 = this._processStepByValue(val1);
        this._handle2 = this._processStepByValue(val2);
      } else {
        var index = this._minRange ? 2 : this._active || 1;
        this["_handle" + index] = this._processStepByValue(this._limitValue(val));
      }

      this._updateModelValue();
    },
    _updateModelValue: function _updateModelValue() {
      var value;

      if (this._rangeSlider) {
        value = this._handle1.value + "," + this._handle2.value;
      } else {
        var index = this._minRange ? 2 : this._active || 1;
        value = this["_handle" + index].value;
      }

      this.options.value = value;
    },
    _formRangeValue: function _formRangeValue(value, index) {
      index = index || this._active;
      var h1 = this._handle1.value,
          h2 = this._handle2.value;
      return index == 1 ? value + "," + h2 : h1 + "," + value;
    },
    // common core methods
    $createElement: function $createElement(tag) {
      var t = tag.split('.');
      return $(document.createElement(t[0])).addClass(t[1] || "");
    },
    $createSVG: function $createSVG(tag, attr) {
      var t = tag.split('.');
      var svgEle = document.createElementNS("http://www.w3.org/2000/svg", t[0]);

      if (t[1]) {
        svgEle.setAttribute("class", t[1]);
      }

      if (attr) {
        this.$setAttribute(svgEle, attr);
      }

      return svgEle;
    },
    $setAttribute: function $setAttribute(ele, attr) {
      for (var key in attr) {
        var val = attr[key];

        if (key === "class") {
          var prev = ele.getAttribute('class');
          if (prev) val += " " + prev;
        }

        ele.setAttribute(key, val);
      }

      return ele;
    },
    $append: function $append(parent, children) {
      children.forEach(function (element) {
        element && parent.appendChild(element);
      });
      return parent;
    },
    isNumber: function isNumber(number) {
      number = parseFloat(number);
      return typeof number === "number" && !isNaN(number);
    },
    getBrowserName: function getBrowserName() {
      var browserName = "",
          ua = window.navigator.userAgent;
      if (!!window.opr && !!opr.addons || !!window.opera || ua.indexOf(' OPR/') >= 0) browserName = "opera";else if (typeof InstallTrigger !== 'undefined') browserName = "firefox";else if (ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0) browserName = "ie";else if (!!window.StyleMedia) browserName = "edge";else if (ua.indexOf('Safari') != -1 && ua.indexOf('Chrome') == -1) browserName = "safari";else if (!!window.chrome && !!window.chrome.webstore || ua.indexOf('Chrome') != -1) browserName = "chrome";
      return browserName;
    },
    _isBrowserSupported: function _isBrowserSupported() {
      var properties = ["borderRadius", "WebkitBorderRadius", "MozBorderRadius", "OBorderRadius", "msBorderRadius", "KhtmlBorderRadius"];

      for (var i = 0; i < properties.length; i++) {
        if (document.body.style[properties[i]] !== undefined) return true;
      }

      console.error(pluginName + ' : Browser not supported');
    },
    _raise: function _raise(event, args) {
      var o = this.options,
          fn = o[event],
          val = true;
      args = args || {
        value: o.value
      }; // default event arguments

      args["id"] = this.id;
      args["control"] = this.control;
      args["options"] = o;

      if (fn) {
        args["type"] = event;
        if (typeof fn === "string") fn = window[fn];

        if ($.isFunction(fn)) {
          val = fn.call(this, args);
          val = val === false ? false : val;
        }
      }

      this.control.trigger($.Event(event, args));
      return val;
    },
    _bind: function _bind(element, _event, handler) {
      $(element).bind(_event, $.proxy(handler, this));
    },
    _unbind: function _unbind(element, _event, handler) {
      $(element).unbind(_event, $.proxy(handler, this));
    },
    _getInstance: function _getInstance() {
      return $.data(this._dataElement()[0], pluginName);
    },
    _saveInstanceOnElement: function _saveInstanceOnElement() {
      $.data(this.control[0], pluginName, this);
    },
    _saveInstanceOnID: function _saveInstanceOnID() {
      var id = this.id;
      if (id && typeof window[id] !== "undefined") window[id] = this;
    },
    _removeData: function _removeData() {
      var control = this._dataElement()[0];

      $.removeData && $.removeData(control, pluginName);
      if (control.id && typeof window[control.id]["_init"] === "function") delete window[control.id];
    },
    _destroyControl: function _destroyControl() {
      if (this._isInputType) this._dataElement().insertAfter(this.control).attr("type", "text");
      this.control.empty().removeClass("rs-control").height("").width("");

      this._removeAnimation();

      this._bindControlEvents("_unbind");

      this._bindScrollEvents("_unbind");
    },
    // methods to dynamic options updation (through option)
    _updateWidth: function _updateWidth() {
      this.lastBlock.css("padding", this.options.width);
    },
    _readOnly: function _readOnly(bool) {
      this._isReadOnly = bool;
      this.container.removeClass("rs-readonly");
      if (bool) this.container.addClass("rs-readonly");
    },
    // get & set for the properties
    _get: function _get(property) {
      return this.options[property];
    },
    _set: function _set(property, value, forceSet) {
      var props = this._props();

      if ($.inArray(property, props.numberType) != -1) {
        // to check number datatype
        if (!this.isNumber(value)) return;
        value = parseFloat(value);
      } else if ($.inArray(property, props.booleanType) != -1) {
        // to check boolean datatype
        value = value == "false" ? false : !!value;
      } else if ($.inArray(property, props.stringType) != -1) {
        // to check input string
        value = value.toLowerCase();
      }

      var options = this.options;
      this._preValue = options.value;
      if (!forceSet && options[property] === value) return;
      options[property] = value;

      switch (property) {
        case "startAngle":
        case "endAngle":
          this._validateStartEnd();

          this._updateSeperator(); // non SVG mode only


          this._appendOverlay();

        // non SVG mode only

        case "startValue":
          if (this._minRange) {
            this._handle1 = this._handleDefaults();
          }

        case "min":
        case "max":
        case "step":
        case "value":
          if (this._validateValue()) {
            this._updateHidden();

            this._updateTooltip();

            if (options.value !== this._preValue) {
              this._raiseValueChange("code");

              this._updatePre();
            }
          }

          break;

        case "radius":
          this._setRadius();

          this._updateTooltipPos();

          break;

        case "width":
          this._removeAnimation();

          this._updateWidth(); // non SVG mode only


          this._setRadius();

          this._refreshHandle();

          this._updateTooltipPos();

          this._addAnimation();

          this._refreshSeperator(); // non SVG mode only


          break;

        case "borderWidth":
          this._setRadius();

          this._refreshHandle();

          break;

        case "handleSize":
          this._refreshHandle();

          break;

        case "handleShape":
          this._setHandleShape();

          break;

        case "animation":
          options.animation ? this._addAnimation() : this._removeAnimation();
          break;

        case "showTooltip":
          options.showTooltip ? this._appendTooltip() : this._removeTooltip();
          break;

        case "editableTooltip":
          this._tooltipEditable();

          this._updateTooltipPos();

          break;

        case "rangeColor":
        case "tooltipColor":
          this._setTooltipColor(this.tooltip);

          this._setTooltipColor(this.input);

          break;

        case "disabled":
          options.disabled ? this.disable() : this.enable();
          break;

        case "readOnly":
          options.readOnly ? this._readOnly(true) : !options.disabled && this._readOnly(false);
          break;

        case "mouseScrollAction":
          this._bindScrollEvents(options.mouseScrollAction ? "_bind" : "_unbind");

          break;

        case "lineCap":
          this._setRadius();

          this._refreshSeperator(); // non SVG mode only


          break;

        case "circleShape":
          this._refreshCircleShape();

          if (options.circleShape == "full") {
            options.startAngle = 0;
            options.endAngle = "+360";
          }

        case "sliderType":
          this._destroyControl();

          this._onInit();

          break;

        case "svgMode":
          var $control = this.control,
              $options = options;
          this.destroy();
          $control[pluginName]($options);
          break;
      }

      return this;
    },
    // public methods
    option: function option(property, value) {
      if (!property || !this._getInstance()) return;
      var options = this.options;

      if ($.isPlainObject(property)) {
        var MIN = "min",
            MAX = "max",
            VALUE = "value";
        var isMinAvailable = property[MIN] !== undefined;
        var isMaxAvailable = property[MAX] !== undefined;

        if (isMinAvailable || isMaxAvailable) {
          if (isMinAvailable) {
            options[MIN] = property[MIN];
            delete property[MIN];
          }

          if (isMaxAvailable) {
            options[MAX] = property[MAX];
            delete property[MAX];
          }

          var val = options.value;

          if (property[VALUE] !== undefined) {
            val = property[VALUE];
            delete property[VALUE];
          }

          this._set(VALUE, val, true);
        }

        for (var prop in property) {
          this._set(prop, property[prop]);
        }
      } else if (typeof property == "string") {
        if (value === undefined) return this._get(property);

        this._set(property, value);
      } // whenever the properties set dynamically, check for SVG mode. also check
      // any of the property was related to SVG. If yes, then redraw the SVG path


      if (options.svgMode) {
        if (this._isPropsRelatedToSVG(property)) {
          this._setSVGAttributes();

          this._moveSliderRange();
        }

        if (this._isPropsRelatedToSVGStyles(property)) {
          this._setSVGStyles();
        }
      }

      return this;
    },
    getValue: function getValue(index) {
      if (this._rangeSlider && this.isNumber(index)) {
        var i = parseFloat(index);
        if (i == 1 || i == 2) return this["_handle" + i].value;
      }

      return this._get("value");
    },
    setValue: function setValue(value, index) {
      if (this.isNumber(value)) {
        if (this.isNumber(index)) {
          if (this._rangeSlider) {
            var i = parseFloat(index),
                val = parseFloat(value);
            value = this._formRangeValue(val, i);
          } else if (!this._minRange) this._active = index;
        }

        this._set("value", value);
      }
    },
    refreshTooltip: function refreshTooltip() {
      this._updateTooltipPos();
    },
    disable: function disable() {
      this.options.disabled = true;
      this.container.addClass("rs-disabled");

      this._readOnly(true);
    },
    enable: function enable() {
      var options = this.options;
      options.disabled = false;
      this.container.removeClass("rs-disabled");
      if (!options.readOnly) this._readOnly(false);
    },
    destroy: function destroy() {
      if (!this._getInstance()) return;

      this._destroyControl();

      this._removeData();

      if (this._isInputType) this.control.remove();
    }
  };

  $.fn.rsRotate = function (degree) {
    var control = this,
        rotation = "rotate(" + degree + "deg)";
    control.css('-webkit-transform', rotation);
    control.css('-moz-transform', rotation);
    control.css('-ms-transform', rotation);
    control.css('-o-transform', rotation);
    control.css('transform', rotation);
    return control;
  }; // The plugin constructor


  function RoundSlider(control, options) {
    this.id = control.id;
    this.control = $(control); // the options value holds the updated defaults value

    this.options = $.extend({}, this.defaults, options);
  } // The plugin wrapper, prevents multiple instantiations


  function CreateRoundSlider(options, args) {
    for (var i = 0; i < this.length; i++) {
      var that = this[i],
          instance = $.data(that, pluginName);

      if (!instance) {
        var _this = new RoundSlider(that, options);

        _this._saveInstanceOnElement();

        _this._saveInstanceOnID();

        if (_this._raise("beforeCreate") !== false) {
          _this._init();

          _this._raise("create");
        } else _this._removeData();
      } else if ($.isPlainObject(options)) {
        if (typeof instance.option === "function") instance.option(options);else if (that.id && window[that.id] && typeof window[that.id].option === "function") {
          window[that.id].option(options);
        }
      } else if (typeof options === "string") {
        if (typeof instance[options] === "function") {
          if ((options === "option" || options.indexOf("get") === 0) && args[2] === undefined) {
            return instance[options](args[1]);
          }

          instance[options](args[1], args[2]);
        }
      }
    }

    return this;
  } // ### SVG related logic


  RoundSlider.prototype.$polarToCartesian = function (centerXY, radius, angleInDegrees) {
    var angleInRadians = (angleInDegrees - 180) * Math.PI / 180;
    return [centerXY + radius * Math.cos(angleInRadians), centerXY + radius * Math.sin(angleInRadians)].join(" ");
  };

  RoundSlider.prototype.$drawArc = function (centerXY, radius, startAngle, endAngle, isOuter) {
    var isCircle = endAngle - startAngle == 360;
    var largeArcFlag = Math.abs(startAngle - endAngle) <= 180 ? "0" : "1";
    var isClockwise = true;
    var outerDirection = isClockwise ? 1 : 0;
    var innerDirection = isClockwise ? 0 : 1;
    var direction = isOuter ? outerDirection : innerDirection;

    var _endAngle = isOuter ? endAngle : startAngle;

    var path = []; // if it is a perfect circle then draw two half circles, otherwise draw arc

    if (isCircle) {
      var midAngle = (startAngle + endAngle) / 2;
      var midPoint = this.$polarToCartesian(centerXY, radius, midAngle);
      var endPoint = this.$polarToCartesian(centerXY, radius, _endAngle);
      path.push("A", 1, 1, 0, 0, direction, midPoint, "A", 1, 1, 0, 0, direction, endPoint);
    } else {
      var endPoint = this.$polarToCartesian(centerXY, radius, _endAngle);
      path.push("A", radius, radius, 0, largeArcFlag, direction, endPoint);
    }

    return path.join(" ");
  };

  RoundSlider.prototype.$drawPath = function (centerXY, outerRadius, startAngle, endAngle, innerRadius, lineCap) {
    var outerStart = this.$polarToCartesian(centerXY, outerRadius, startAngle);
    var outerArc = this.$drawArc(centerXY, outerRadius, startAngle, endAngle, true); // draw outer circle

    var d = ["M " + outerStart, outerArc];

    if (innerRadius) {
      var innerEnd = this.$polarToCartesian(centerXY, innerRadius, endAngle);
      var innerArc = this.$drawArc(centerXY, innerRadius, startAngle, endAngle, false); // draw inner circle

      if (lineCap == "none") {
        d.push("M " + innerEnd, innerArc);
      } else if (lineCap == "round") {
        d.push("A 1, 1, 0, 0, 1, " + innerEnd, innerArc, "A 1, 1, 0, 0, 1, " + outerStart);
      } else if (lineCap == "butt" || lineCap == "square") {
        d.push("L " + innerEnd, innerArc, "L " + outerStart, "Z");
      }
    }

    return d.join(" ");
  };

  RoundSlider.prototype.$getArcLength = function (radius, degree) {
    // when degree not provided we can consider that arc as a complete circle
    if (typeof degree == "undefined") degree = 360; // circle's arc length formula => 2πR(Θ/360)

    return 2 * Math.PI * radius * (degree / 360);
  };

  $.fn[pluginName].prototype = RoundSlider.prototype;
});

var fn1 = $.fn.roundSlider.prototype._setProperties;

$.fn.roundSlider.prototype._setProperties = function () {
  fn1.apply(this);

  var o = this.options,
      r = o.radius,
      d = r * 2,
      r1 = r - o.width / 2 - this._border(true),
      svgNS = "http://www.w3.org/2000/svg";

  this._circum = Math.PI * (r1 * 2);
  var $svg = $(document.createElementNS(svgNS, "svg"));
  $svg.attr({
    "height": d,
    "width": d
  });
  this.$circle = $(document.createElementNS(svgNS, 'circle')).attr({
    "fill": "transparent",
    "class": "rs-transition",
    "cx": r,
    "cy": r,
    "r": r1,
    "stroke-width": o.width,
    "stroke-dasharray": this._circum
  });
  var $path = this.$circle.clone().addClass("path-bg");

  this._setDashOffset($path, this._end);

  $svg.append($path, this.$circle.addClass("range-bg"));
  this.$svg_box = $(document.createElement("div")).addClass("rs-transition rs-svg").append($svg).css({
    "height": d,
    "width": d,
    "transform-origin": "50% 50%",
    "transform": "rotate(" + (o.startAngle + 180) + "deg)"
  }).appendTo(this.innerContainer);
};

$.fn.roundSlider.prototype._setDashOffset = function ($ele, deg) {
  var pct = (1 - deg / 360) * this._circum;
  $ele.css({
    strokeDashoffset: pct + 'px'
  });
};

var fn2 = $.fn.roundSlider.prototype._changeSliderValue;

$.fn.roundSlider.prototype._changeSliderValue = function (val, deg) {
  fn2.apply(this, arguments);
  deg = deg - this.options.startAngle;

  if (this._rangeSlider) {
    this.$svg_box.rsRotate(this._handle1.angle + 180);
    deg = this._handle2.angle - this._handle1.angle;
  }

  this._setDashOffset(this.$circle, deg);
};